import {
  Component,
  OnInit,
  HostListener,
  NgZone,
  ElementRef,
  ViewChild,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  AfterViewChecked,
  Inject,
  Input,
  Output,
  EventEmitter,
  AfterViewInit,
  TemplateRef,
  OnDestroy,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Location } from '@angular/common';
import {
  NgbModal,
  NgbModalOptions,
  NgbModalRef,
  NgbTypeaheadSelectItemEvent
} from '@ng-bootstrap/ng-bootstrap';

import { Guid } from 'guid-typescript';

import {
  DnvMapState,
  LayerState,
  LayerType,
  BaseMapState,
  DnvSearchState,
  DnvFeatureLayer,
  DnvLegendState,
  FeatureClickedPayload,
  UpdateLayer,
  SetActiveLayer,
  Layer as DnvLayer,
  ToggleShowFilterPanel,
  SetAvailableLayer,
  DnvMapInfo,
  DnvMapAction,
  CenterMap,
  SetZoom,
  SetMapFeatureLayers,
  SearchItem,
  DnvMapActionType,
  SetSelectedItem,
  SetMapGeoJsonLayers,
  initialSearchItem,
  SetMapState,
  SetIcons,
  SetSearchItemsUrl,
  DnvBasemap,
  SetMapBasemaps,
  SetBaseMapSelected,
  CloseBasemaps,
  ToggleBasemaps,
  SelectBasemap,
  ToggleExpand,
  // SetFeatureLayerVisible, ToggleVisiblePayload,
  DnvFieldFilter,
  FeatureFilterUpdate,
  FeatureFilterPayload,
  QueryLayerFeatureCount,
  UpdateLayerFilter,
  ZoomToFeatures,
  HideFilterPanel,
  LoadLegendLayers,
  SetLayerFeatureVisible,
  FeatureLayerVisibilityPayload,
  SetActiveLegendLayers,
  ToggleMetaDataPanel,
  SetMetaData,
  SetLayerInfo,
  SetMarkers,
  SetSelectedFeatureLayer,
  FeatureClicked,
  SelectFeature,
  SetSurroundingFeatureList,
  DnvGisUtility,
  SetTextStyle,
  AddText,
  TextStylePayload,
  DnvMapComponent,
  DrawShapes,
  StartDraw,
  UpdateStartDrawCircle,
  IsDrawing,
  DnvMapViewComponent,
  SetOrthoOpacity,
  MapViewState,
  MapViewAction,
  MapViewLoad,
  noLoadedMapView,
  MapViewLoadDefault,
  MapViewLoadSharedId,
  MapViewCheckIsDirty,
  MapViewMarkDirty,
  MapViewSetUrlProvider,
  MapViewSetStoreWrapper,
  ClearLayerFilters,
  SearchItemType,
  SetFeatureLayersOpacity,
  ShowingAOIShape,
  SetFillPattern,
  UpdateShapeFeatureColor,
  UpdateShapeFeatureMarker,
  UpdateShapeFeatureStyle,
  UpdateShapeOutlineColour,
  UpdateMarkerShape,
  UpdateShapeFillPattern,
  UpdateCircleRadius,
  UpdateLabelMarkerText,
  ToggleEditShapes,
  SetLineStyle,
  UpdateFeatureLineStyle,
  UpdateFeatureStyle,
  SetAllTextStyle,
  DnvDrawnShapes,
  ResetSelected,
  UpdateShowMeasure,
  UpdateAreaMeasure,
  UpdateLinearMeasure,
  UpdateUtmMeasure,
  BringToFront,
  BringToBack,
  DnvLatLng,
  DeleteFeature,
  SetFilterAOIShape,
  SetFilterAOIMode,
  ToggleHideTilePane,
  SetHistoricalAerials,
  SetHistoricalAerialsOpacity,
  AddHistoricalAerials,
  EditShapes,
  SetMeasureShapeId,
  SetLineWeight,
  SetMarkerSize,
  UpdateLineWeight,
  UpdateMarkerSize,
  LoadBasemapLegendLayers,
  LayerInfo,
  SetActiveBasemapLegends,
  SetEditFeaturesGeometry,
  SetEditFeaturesPermission,
  SetEditFeatures,
  GetEditFeaturesGeometry,
  RevertFeatureGeometry,
  DeleteAllArrows,
  SetSnapToLayers,
  SetSnapAsset,
  EditFeatureLayerSymbology,
  SetFeatureLayerSymbology,
  ToggleFeaturePanel,
  DeleteEditFeature as MapDeleteEditFeature,
  AddEditFeature,
  UpdateEditFeature,
  MeasurementUnit,
  MeasurementUnits,
  EditingFeature,
  WINDOW,
  SetLayerExpandState,
  flSymbols,
  DnvSymbol,
  DnvSymbology,
  DnvUniqueValueRenderer,
  ZoomToGeoJsonLayer
} from 'dnv-lib';

import { Subject, Observable, forkJoin, of, EMPTY } from 'rxjs';
import {
  ApplicationState,
  ApplicationStatus,
  State,
  GetLayers,
  UserProfile,
  getMapState,
  getApplicationState,
  getPropertiesState,
  PropertiesState,
  Idle,
  getBasemaps,
  Layer,
  Table,
  Legend,
  CheckLayerDisplay,
  Search,
  SearchCoordinates,
  GetDBLink,
  GridSelectLayer,
  getGridSelectLayer,
  GridPayload,
  getGridSelectLayerCache,
  GetBasemaps,
  InvalidateGridCache,
  GetDataNames,
  DelayedAction,
  DelayedActionBy1,
  IdentifySurroundingFeature,
  SetSurroundingFeature,
  GetFeatureData,
  getLayerInfo,
  Draw,
  Export,
  SearchEngineerDrawings,
  ToastUserNotification,
  GetEngDrawingGeometry,
  SearchEngineerDrawingsByNum,
  SearchEngineerDrawingsByProj,
  Toolbox,
  getPropertiesInfo,
  PropertyInfo,
  getSelectedProperty,
  getPropertiesDBLink,
  GetShape,
  SearchCCTV,
  SetCCTV,
  SearchEngineerDrawingsByNumType,
  SelectedFeatureInspection,
  ToolboxStatus,
  SetToolboxStatus,
  GetMailMergeByProperty,
  ToolboxMailMerge,
  ToolboxMailMergeState,
  getToolboxMailMerge,
  ToolboxMailMergeArea,
  ToolboxMailMergeToggleParcelAtCoordinate,
  RefreshDisplayedGeoJson,
  SetUserProfile,
  GetMailMergeList,
  SearchReset,
  ToolboxMailMergeOptions,
  ToolboxMailMergeUpdateOptions,
  SelectCCTV,
  LaunchStreetView,
  ToggleStreetView,
  SetMeasurements,
  GetCoordsByObjectId,
  SetFeatureRasterHighlight,
  getBaseMapState,
  SetEditFeature,
  SetSelectedFeatureSections,
  GetEditPermission,
  SetNewFeatureLatLng,
  SetLastEditFeature,
  GetMaxAssetId,
  EditPermissionPayload,
  UpdateEditFeatureGeometry,
  SetShowSpinner,
  GetEditFeatureFields,
  SetEditFeatureFields,
  SetRelatedRecords,
  GetEditRequiredFields,
  SetMaxAssetId,
  GetEditReadOnlyFields,
  SetEditPermissionSymbology,
  SearchPostingPlansByNum,
  SearchPostingPlans,
  SetEditFeatureShowActiveLayer,
  SearchAsset,
  GetCoordsByAssetId,
  ExportInspections,
  getEnerGovInfo,
  GetMaterialsDictionary,
  GetWMRPModule,
  getWMRPModule,
  WMRPState,
  WMRPModule,
  lookupDictionary,
  getMaterials,
  GetTemplateNames,
  WmrpAnalysisParam,
  SaveTemplateParameters,
  WmrpAnalysisRun,
  SaveAnalysisDetails,
  WmrpSaveObject,
  getSavedTemplate,
  getWMRPState,
  WmrpAnalysisParamSet,
  getWMRPAnalysisData,
  GetAnalysisDetails,
  GetTemplateParameters,
  RunAnalysisTemplate,
  RunAnalysisCustom,
  SelectRun,
  getCurrentConditions,
  ShowExpandParametersBtn,
  StopAnalysisResultsPolling,
  GenerateReplacementSchedule,
  WmrpReplacementSchedParam,
  GetReplacementSchedules,
  getReplacementSchedules,
  WmrpReplacementSched,
  GetWmrtResults,
  SetWmrtBoundary,
  ShapeCreated,
  SetWmrtResults,
  StopSchedulePolling,
  WmrpCondition,
  SetSelectedReplacementSchedule,
  DynamicFeatureLayer,
  dynamicFeatureLayerIdGenerator,
  GetToolsPermissions,
  ToolsPermissions,
  SetWMRPLayers,
  SetWMRPLayerFeatureVisible,
  SetWMRPActiveLayer,
  SetWMRPAvailableLayer,
  UpdateWMRPLayerFilter,
  GetExclusionLayerMains,
  featureLayerIdFromDynamicFLId,
  ToggleWMRPLayer,
  UpdateScheduleYear,
  PopulationState,
  PopulationSelectMode,
  getPopulationState,
  PopulationSelectedArea,
  PopulationClearSelectedArea,
  PopulationSetState,
  SetFromMeasureTool,
  IdentifySurroundingFeatureParam,
  IdentifySurroundingFeaturePost,
  SaveAnalysisTitle,
  DeleteAnalysisRun,
  SaveScheduleTitle,
  DeleteSchedule,
  SetShowSearchSpinner
} from 'src/app/state-management';
import { Action, Store } from '@ngrx/store';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfigService } from '../../services/config.service';
import {
  debounceTime,
  distinctUntilChanged,
  switchMap,
  catchError,
  map,
  takeUntil,
  finalize,
  take
} from 'rxjs/operators';

// import { MsalService } from '@azure/msal-angular';
import { SearchedInfo } from 'src/app/models/search-info';
import { PrintService, SearchService } from 'src/app/services';
import {
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  FormGroupDirective,
  Validators
} from '@angular/forms';
// import { environment } from '../../../environments/environment';
import { Options } from '@angular-slider/ngx-slider';

import { AppStoreWrapper } from '../../models/AppStoreWrapper';
import { AppUrlProvider } from '../../models/AppUrlProvider';
import {
  Address,
  GetPropertyByAddress,
  GetPropertyByFolio,
  GetPropertyByXY,
  SetPropertyInfo,
  GetPropertyByPID,
  GetPropertyInfo,
  SetSelectedProperty,
  SetPropertiesDbLinks,
  PropertyAirSpace,
  GetPropertyBoundingBox,
  PrintSvcConn,
  GetServiceConnectionsByLatLong,
  SetPrintSvcConn,
  ResetGeoJsonProperty,
  EnergovInfo
} from 'src/app/state-management/properties';
import * as L from 'leaflet';
import '../../../../node_modules/leaflet.browser.print/dist/leaflet.browser.print.min.js';
import { ClipboardService } from 'ngx-clipboard';
import { saveAs } from 'file-saver';

function* generateSequence(start: number, end: number) {
  for (let i = start; i <= end; i++) yield i;
}

interface Symbol {
  type: string;
  style: string;
  color: number[];
  width?: number;
}

@Component({
  selector: 'app-map-view',
  templateUrl: './map-view.component.html',
  styleUrls: ['./map-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class MapViewComponent implements OnInit, AfterViewInit, OnDestroy {
  populationState$: Observable<any>;
  constructor(
    @Inject(WINDOW) private _window: any,
    private httpClient: HttpClient, // for demo purpose, should not be here
    private route: ActivatedRoute,
    private router: Router,
    private changeDetector: ChangeDetectorRef,
    // private authService: MsalService,
    private configService: ConfigService,
    private store: Store<State>,
    private searchService: SearchService,
    private modalService: NgbModal,
    private gisUtility: DnvGisUtility,
    private printService: PrintService,
    private zone: NgZone,
    private elementRef: ElementRef,
    // private layersService: LayersService
    private formBuilder: UntypedFormBuilder,
    private location: Location,
    private clipboardService: ClipboardService
  ) {
    this.application$ = this.store.select(getApplicationState);
    this.mapState$ = this.store.select('mapState');
    this.layerState$ = this.store.select('layerState');
    this.legendState$ = this.store.select('legendState');
    this.baseMapState$ = this.store.select(getBaseMapState);
    this.dnvSearchState$ = this.store.select('dnvSearchState');
    this.gridSelectLayer$ = this.store.select(getGridSelectLayer);
    this.gridSelectLayerCache$ = this.store.select(getGridSelectLayerCache);
    this.layerInfo$ = this.store.select(getLayerInfo);
    this.mapViewState$ = this.store.select('mapViewState');
    this.propertiesInfo$ = this.store.select(getPropertiesInfo);
    this.selectedProperty$ = this.store.select(getSelectedProperty);
    this.propertiesDBLink$ = this.store.select(getPropertiesDBLink);
    this.propertiesState$ = this.store.select(getPropertiesState);
    this.toolboxMailMerge$ = this.store.select(getToolboxMailMerge);
    this.energovInfo$ = this.store.select(getEnerGovInfo);
    this.wmrpModule$ = this.store.select(getWMRPModule);
    this.wmrpRecentAnalyses$ = this.store.select(getWMRPAnalysisData);
    this.materials$ = this.store.select(getMaterials);
    this.savedTemplate$ = this.store.select(getSavedTemplate);
    this.wmrpState$ = this.store.select(getWMRPState);
    this.currentConditions$ = this.store.select(getCurrentConditions);
    this.replacementSchedules$ = this.store.select(getReplacementSchedules);
    this.populationState$ = this.store.select(getPopulationState);

    this.searchForm = new UntypedFormGroup({
      addressSearch: new UntypedFormControl('')
    });

    this.engSearchForm = new UntypedFormGroup({
      engDrawSearchNum: new UntypedFormControl(''),
      engDrawSearchProj: new UntypedFormControl('')
    });

    this.cctvSearchForm = new UntypedFormGroup({
      cctvSearch: new UntypedFormControl('SANMN')
    });

    this.ppSearchForm = new UntypedFormGroup({
      ppSearchNum: new UntypedFormControl('')
      //   engDrawSearchProj: new FormControl('')
    });

    this.assetSearchForm = new UntypedFormGroup({
      assetSearch: new UntypedFormControl('')
    });

    this.hazardForm = new UntypedFormGroup({
      hazardMin: new UntypedFormControl(this.minValue),
      hazardMax: new UntypedFormControl(this.maxValue)
    });

    this.wmrpForm = new UntypedFormGroup({
      paramSet: this.formBuilder.array([])
    });

    this.replacementSchedForm = new UntypedFormGroup({
      analysisValueEnabled: new UntypedFormControl(true),
      addressingEnabled: new UntypedFormControl(false),
      endOfLifeEnabled: new UntypedFormControl(true),
      numberOfBreaksEnabled: new UntypedFormControl(true),
      exclusionLayerEnabled: new UntypedFormControl(true),
      replacementMetres: new UntypedFormControl(null, [
        Validators.pattern(/^-?[0-9]\d*(\.\d+)?$/),
        Validators.required
      ]),
      startYear: new UntypedFormControl(null, [
        Validators.pattern(/^-?[0-9]\d*(\.\d+)?$/),
        Validators.required
      ]),
      endYear: new UntypedFormControl(null, [
        Validators.pattern(/^-?[0-9]\d*(\.\d+)?$/),
        Validators.required
      ])
    });

    this.analysisTitleForm = new UntypedFormGroup({
      analysisTitle: new UntypedFormControl('')
    });
  }

  private ngUnsubscribe: Subject<void> = new Subject();

  application$: Observable<ApplicationState>;
  mapState$: Observable<DnvMapState>;
  layerState$: Observable<LayerState>;
  legendState$: Observable<DnvLegendState>;
  baseMapState$: Observable<BaseMapState>;
  dnvSearchState$: Observable<DnvSearchState>;
  gridSelectLayer$: Observable<DnvFeatureLayer>;
  gridSelectLayerCache$: Observable<Map<string, GridPayload>>;
  layerInfo$: Observable<string>; // text for layer popup
  energovInfo$: Observable<EnergovInfo>;
  // textStyle$: Observable<TextStylePayload>;
  // _mapViewState: MapViewState;
  mapViewState$: Observable<MapViewState>;
  propertiesInfo$: Observable<any>;
  propertiesDBLink$: Observable<any>;
  mapViewState: MapViewState;
  selectedProperty$: Observable<string>;
  appUrlProvider: AppUrlProvider;
  appStoreWrapper: AppStoreWrapper;
  propertiesState$: Observable<PropertiesState>;
  propertiesState: PropertiesState;
  energovInfo: EnergovInfo;
  isDialogOpen = false;
  wmrpModule$: Observable<WMRPModule[]>;
  wmrpModule: WMRPModule[];
  wmrpRecentAnalyses$: Observable<WmrpAnalysisRun[]>;
  wmrpRecentAnalyses: WmrpAnalysisRun[];
  materials$: Observable<lookupDictionary[]>;
  savedTemplate$: Observable<any>;
  wmrpState$: Observable<WMRPState>;
  wmrpState: WMRPState;
  prevWmrpState: WMRPState;
  wmrpLayerState: LayerState = { layers: [{ canFilter: false }] } as LayerState;
  type2LayerUids: string[];
  currentConditions$: Observable<WmrpAnalysisParam[]>;
  currentConditions: WmrpAnalysisParam[];
  selectedRun: WmrpAnalysisRun;
  replacementSchedules$: Observable<WmrpReplacementSched[]>;
  replacementSchedules: WmrpReplacementSched[];
  selectedSchedule: WmrpReplacementSched;

  // mapViewState$: Observable<MapViewState>;
  lastSelectedFeature$: Observable<FeatureClickedPayload>;
  toolboxMailMerge$: Observable<ToolboxMailMergeState>;
  toolboxMailMergeState: ToolboxMailMergeState;

  populationState: PopulationState;

  ApplicationStatus = ApplicationStatus; // Expose the enum in the template
  ToolboxStatus = ToolboxStatus;

  currentZoomLevel: number;
  applicationState: ApplicationState;
  layerState: LayerState;
  // _mapViewState: MapViewState;
  // isDialogOpen: boolean = false;
  featurePanelOpen: boolean;
  panelHeight: number;
  featureLayers: DnvFeatureLayer[];
  excludeFeatureInfo: string[];
  selectedFeature: any;
  isDrawing: boolean;
  formError: string;
  headerHeight = 54;
  contentHeight = 0;
  headerHeightSecondary = 0;
  searchingProj = false;
  searchingNum = false;
  editingShape = '';
  filterAOILeafletId = 0;
  inspectionHeight: number;
  searchingAsset = false;

  graphMeEndpoint = 'https://graph.microsoft.com/v1.0/me'; // demo
  userProfile: UserProfile = null;
  userIcon = '??';
  horizontalStripes: any;
  featureSelected: string;
  featureAdded = false;
  defaultViewLoaded = false;
  wmrpConditions = false;
  chkCount = 0;
  active = 1;
  scheduleYears: string[] = [];
  initialWMRP = true;
  selectedAnalysisJobId = 0; // fme Job id
  selectedAnalysisType = 'Analysis';
  selectedScheduleJobId = 0;
  scheduleCount = 0;

  propertyInfoScrollToTop = false;

  wmrpHiddenFields = [
    {
      uid: 'WMRP_POOR_ACCESS',
      alias: ['OBJECTID', 'Run reference', 'Has Poor Access']
    },
    { uid: 'WMRP_ANALYSIS', alias: ['OBJECTID', 'Run reference', 'Shape'] },
    {
      uid: 'WMRP_SCHEDULE',
      alias: [
        'OBJECTID',
        'Replacement year',
        'Schedule reference',
        'Run reference'
      ]
    }
  ];

  @ViewChild('fixedHeader') fixedHeader: ElementRef;
  @ViewChild('content') popup: TemplateRef<any>;
  @ViewChild('dnvMap') dnvMap: DnvMapComponent;
  @ViewChild('mapViewComponent') mapViewComponent: DnvMapViewComponent;

  public search: (text$: Observable<string>) => Observable<SearchItem[]>;
  public engDrawSearchNum: (
    searchNum$: Observable<string>
  ) => Observable<SearchItem[]>;
  public ppSearchNum: (
    ppSearchNum$: Observable<string>
  ) => Observable<SearchItem[]>;
  public engDrawSearchProj: (
    searchProj$: Observable<string>
  ) => Observable<SearchItem[]>;
  public cctvSearch: (
    cctvSearch$: Observable<string>
  ) => Observable<SearchItem[]>;
  public assetSearch: (
    assetSearch$: Observable<string>
  ) => Observable<SearchItem[]>;
  private selected: SearchItem = initialSearchItem;
  private readonly defaultIcon = 'far fa-question-circle';
  legendState: DnvLegendState;
  baseMapState: BaseMapState;
  searchForm: UntypedFormGroup;
  engSearchForm: UntypedFormGroup;
  cctvSearchForm: UntypedFormGroup;
  ppSearchForm: UntypedFormGroup;
  assetSearchForm: UntypedFormGroup;
  conditionsForm: UntypedFormGroup;
  hazardForm: UntypedFormGroup;
  wmrpForm: UntypedFormGroup;
  replacementSchedForm: UntypedFormGroup;
  replacementSchedFormDefaults = {
    analysisValueEnabled: true,
    addressingEnabled: false,
    endOfLifeEnabled: true,
    numberOfBreaksEnabled: true,
    exclusionLayerEnabled: true
  };
  analysisTitleForm: UntypedFormGroup;
  hasReplacementSchedules: boolean = false;
  dnvSearchState: DnvSearchState;
  mapState: DnvMapState;
  currentLayerInfo: LayerInfo;
  modal: NgbModalRef = null;
  color = '#000000';
  selectedColor = '';
  colorSwatches: string[][];
  sliderControl: UntypedFormControl = new UntypedFormControl(180);
  sliderOptions: Options = {
    floor: 0,
    ceil: 359,
    step: 10
  };
  bufferSliderOptions: Options = {
    floor: 0,
    ceil: 1000,
    step: 1,
    translate: (value: number): string => {
      return value + 'm';
    }
  };
  historicalSlider: UntypedFormControl = new UntypedFormControl();
  aerialDates: number[] = [];
  haSliderOptions: Options = {
    floor: 0,
    ceil: 5,
    showTicksValues: true,
    vertical: true,
    step: 0.1,
    translate: (value: number): string => {
      if (this.aerialDates[value]) {
        return this.aerialDates[value] + '';
      } else {
        return '';
      }
    }
  };

  hazardScore: UntypedFormControl = new UntypedFormControl();
  minValue: number = 300;
  maxValue: number = 600;
  hazardSliderOptions: Options = {
    floor: 0,
    ceil: 1000,
    step: 10,
    showTicksValues: true,
    translate: (value: number): string => {
      if (value % 100 == 0) {
        return value.toString();
      }
      return '';
    }
  };

  textStyle: TextStylePayload;
  fontFace = ['Arial', 'Courier New', 'Georgia', 'Verdana'];
  drawBtn = 'cancel';
  circleRadius: UntypedFormControl = new UntypedFormControl(0);
  isDesktop = false;
  mapViewViewName = '';
  markerOptions = ['circle', 'plus', 'diamond', 'square', 'triangle', 'x'];
  selectedFontSize: number;
  layerOpacity = 1;
  dblink: string;
  ltopid: string;
  multiPlan = false;
  mapTitle = '';
  mapSubTitle = '';
  noTitle = '';
  mapBorder = false;
  mapLegendEnabled = false;
  mapLegendPosition = 'topRight';
  prevConn = { name: '', objectId: 0 };
  selectedLineWeight: number;
  selectedMarkerSize: number;
  bmLegendCache: LayerInfo[];
  // editedGeometryObj: { state: string, latlng: any, objId: number, shape: string };
  // origGeometryObj: { state: string, latlng: any, objId: number, shape: string };
  writeUrl: string;
  drawingSearch: string;
  showAnalysisParametersBtn = false;
  showAnalysisParameters = false;
  showAnalysisStatus = false;
  showAnalysisSchedules = false;
  templates: WmrpAnalysisParamSet[] = [];
  defaultTemplate: WmrpAnalysisParamSet = null;
  showNotAuthorizedToast = true;

  basemapLegendMap: any = [
    { basemapName: 'Streets', legendName: 'BUILDINGS LAND USE' },
    { basemapName: 'Ownership', legendName: 'OWNERSHIP' },
    { basemapName: 'Zoning', legendName: 'ZONING CLASS' },
    { basemapName: 'OCP', legendName: 'OCP CLASS' },
    { basemapName: 'OCP', legendName: 'OCP PROPOSED ROADS' },
    { basemapName: 'OCP', legendName: 'OCP TOWN CENTRES' },
    { basemapName: 'OCP', legendName: 'OCP URBAN CONTAINMENT' }
  ];

  analysisGuid: string;
  scheduleGuid: string;
  sharedURLLoaded = false;
  appSettings: { [key: string]: string };
  populationTotal = 0;

  // Format the autosuggested item into a string for the input control
  formatter = (x: { name: string }) => x.name;

  assetFormatter = (x: { assetId: string }) => x.assetId;

  ngOnInit(): void {
    this.mapState$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((state: DnvMapState) => {
        this.currentZoomLevel = state.zoomLevel;
        this.mapState = state;
        this.isDrawing = state.isDrawing;
        this.textStyle = state.textStyle;
        this.color = state.textStyle.color;
        this.sliderControl.setValue(state.textStyle.rotation);
        this.selectedFontSize = Number(state.textStyle.fontSize);
        if (state.filterAOIMode && state.filterAOIMode.shape) {
          this.filterAOILeafletId = state.filterAOIMode.shape.leafletId
            ? state.filterAOIMode.shape.leafletId
            : 0;
        }
        this.selectedLineWeight = state.lineWeight;
        this.selectedMarkerSize = state.markerSize;
      });

    this.application$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((state: ApplicationState) => {
        if (
          this.applicationState &&
          this.applicationState.status !== state.status
        ) {
          this.store.dispatch(
            new ShowingAOIShape(state.status === ApplicationStatus.Layer)
          );
        }
        this.applicationState = state;
        this.appSettings = state.appSettings;
        this.setHeaderHeight();
      });

    this.dnvSearchState$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((state: DnvSearchState) => {
        this.dnvSearchState = state;
      });

    this.layerState$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((state: LayerState) => {
        this.layerState = state;

        const availLayers = this.applicationState.appSettings[
          'wmrp.available.layers'
        ];

        let layers: DnvLayer[] = [];
        layers = state.layers
          .filter(l => availLayers.includes(l.uid))
          .map(l =>
            Object.assign({}, l, {
              featureLayers: l.featureLayers.map(fl =>
                Object.assign({}, fl, {
                  isVisible: true,
                  opacity: 1,
                  fieldFilters: null,
                  whereClause: '1=1'
                })
              )
            })
          );

        if (this.wmrpState?.layers?.length > 0) {
          const wmrpLyrs = this.wmrpState.layers.filter(
            lyr =>
              lyr.type === 1 &&
              (lyr.uid?.indexOf('WMRP_SCHEDULE') > -1 ||
                lyr.uid?.indexOf('WMRP_ANALYSIS') > -1)
          );
          layers = this.wmrpState.layers;
        }

        const wmrpAnalysisLayers = state.layers?.filter(
          l => l.uid === 'WMRP_ANALYSIS_LAYERS'
        );
        if (wmrpAnalysisLayers.length > 0) {
          const idx = layers.findIndex(l => l.uid === 'WMRP_ANALYSIS_LAYERS');
          const analysisLyr = Object.assign({}, wmrpAnalysisLayers[0], {
            type:
              wmrpAnalysisLayers[0].type === 2 ? 1 : wmrpAnalysisLayers[0].type,
            name:
              this.selectedRun?.fmeJobId.length > 0
                ? `WMRP Analysis ID ${this.selectedRun.fmeJobId}`
                : wmrpAnalysisLayers[0]?.name
          });
          if (idx > -1) {
            // layer exists, delete first
            // layers.splice(idx, 1);
            // layers.splice(idx, 0, analysisLyr as any);
            layers = [
              ...layers.slice(0, idx),
              analysisLyr,
              ...layers.slice(idx + 1)
            ];
          } else {
            layers.push(analysisLyr as any);
          }
        }
        const wmrpScheduleLayers = state.layers?.filter(
          l => l.uid === 'WMRP_SCHEDULE_LAYERS'
        );
        let type = 2;
        if (wmrpScheduleLayers[0]?.name.indexOf('ID') > -1) {
          if (wmrpScheduleLayers[0]?.type === 2) {
            type = 1;
          } else {
            type = wmrpScheduleLayers[0]?.type;
          }
        }
        const scheduleLayer = Object.assign({}, wmrpScheduleLayers[0], {
          type: type
        });
        if (wmrpScheduleLayers.length > 0) {
          const idx = layers.findIndex(l => l.uid === 'WMRP_SCHEDULE_LAYERS');
          if (idx > -1) {
            layers.splice(idx, 1);
            layers.splice(idx, 0, scheduleLayer as any);
          } else {
            layers.push(scheduleLayer as any);
          }

          // get schedule years
          this.scheduleYears = wmrpScheduleLayers[0].featureLayers.map(
            lyr => lyr.name
          );
        }
        const wmrpPoorAccessLayers = state.layers?.filter(
          l => l.uid === 'WMRP_POOR_ACCESS_LAYERS'
        );
        const poorAccess = Object.assign({}, wmrpPoorAccessLayers[0], {
          type:
            wmrpPoorAccessLayers[0]?.type == 2
              ? 1
              : wmrpPoorAccessLayers[0]?.type,
          name:
            this.selectedRun?.fmeJobId.length > 0
              ? `WMRP Poor Access Mains ID ${this.selectedRun.fmeJobId}`
              : wmrpPoorAccessLayers[0]?.name
        });
        if (wmrpPoorAccessLayers.length > 0) {
          const idx = layers.findIndex(
            l => l.uid === 'WMRP_POOR_ACCESS_LAYERS'
          );
          if (idx > -1) {
            layers.splice(idx, 1);
            layers.splice(idx, 0, poorAccess as any);
          } else {
            layers.push(poorAccess as any);
          }
        }

        const wmrpExclusionLayers = state.layers?.filter(
          l => l.uid === 'WMRP_EXCLUSION_LAYERS'
        );
        const exclusionLayer = Object.assign({}, wmrpExclusionLayers[0], {
          type:
            wmrpExclusionLayers[0]?.type == 2 ? 1 : wmrpExclusionLayers[0]?.type
        });
        if (wmrpExclusionLayers.length > 0) {
          const idx = layers.findIndex(l => l.uid === 'WMRP_EXCLUSION_LAYERS');
          if (idx > -1) {
            layers.splice(idx, 1);
            layers.splice(idx, 0, exclusionLayer as any);
          } else {
            layers.push(exclusionLayer as any);
          }
          this.store.dispatch(new GetExclusionLayerMains());
        }

        const wmrpMergedScoresLayers = state.layers?.filter(
          l => l.uid === 'WRP_MERGED_SCORES' || l.uid === 'WMRP_MERGED_SCORES'
        );
        const mergedScores = Object.assign({}, wmrpMergedScoresLayers[0], {
          type:
            wmrpMergedScoresLayers[0]?.type == 2
              ? 1
              : wmrpMergedScoresLayers[0]?.type,
          name:
            this.selectedRun?.fmeJobId.length > 0
              ? `WRP Merged Scores ID ${this.selectedRun.fmeJobId}`
              : wmrpMergedScoresLayers[0]?.name
        });
        if (wmrpMergedScoresLayers.length > 0) {
          const idx = layers.findIndex(
            l => l.uid === 'WRP_MERGED_SCORES' || l.uid === 'WMRP_MERGED_SCORES'
          );
          if (idx > -1) {
            layers.splice(idx, 1);
            layers.splice(idx, 0, mergedScores as any);
          } else {
            layers.push(mergedScores as any);
          }
        }

        if (layers.length > 0 /*&& this.initialWMRP === true*/) {
          this.store.dispatch(new SetWMRPLayers(layers));
          // this.initialWMRP = false;
        }

        if (
          this.applicationState.status === ApplicationStatus.Toolbox &&
          this.applicationState.toolboxStatus === ToolboxStatus.WMRP
        ) {
          if (
            this.analysisGuid?.length > 0 &&
            this.sharedURLLoaded === false &&
            state.layers?.length > 0
          ) {
            this.selectRun(this.analysisGuid);
            // this.updateWmrpPoorAccessCBR();
            this.sharedURLLoaded = true;
          }
        }
      });

    this.legendState$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((legendState: DnvLegendState) => {
        this.legendState = legendState;
      });

    this.propertiesState$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((propertiesState: PropertiesState) => {
        this.propertiesState = propertiesState;
      });

    this.layerInfo$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((layerInfo: string) => {
        if (layerInfo.length > 0) {
          this.open(this.popup);
        }
      });

    this.propertiesDBLink$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((propertiesAirSpace: PropertyAirSpace[]) => {
        if (propertiesAirSpace) {
          this.multiPlan = propertiesAirSpace.length > 0;
        }
      });

    this.toolboxMailMerge$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((toolboxMailMerge: ToolboxMailMergeState) => {
        // this.mailMergeForm.setValue({
        //   selectionMethod: toolboxMailMerge.selectionMethod,
        //   selectionBuffer: toolboxMailMerge.selectionBuffer
        // });
        this.toolboxMailMergeState = toolboxMailMerge;
      });

    this.populationState$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((population: PopulationState) => {
        this.populationState = population;
        this.populationTotal = 0;
        for (let i = 0; i < population.buildings.length; i++) {
          this.populationTotal =
            this.populationTotal + population.buildings[i].population;
        }
      });

    this.energovInfo$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((energovInfo: EnergovInfo) => {
        this.energovInfo = energovInfo;
      });

    this.wmrpState$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((state: WMRPState) => {
        this.showAnalysisParametersBtn = state.showExpandParametersBtn;
        if (this.showAnalysisParametersBtn === true) {
          this.toggleWMRPConditions(false);
          setInterval(() => {
            this.changeDetector.detectChanges();
          }, 1000);
        }
        this.templates = state.templates
          ?.filter(t => t.isTemplate === true && t.isDefault === false)
          .sort((a, b) => a.name.localeCompare(b.name));
        if (this.templates?.length > 0) {
          this.templates.forEach(t => {
            (this.wmrpForm.get('paramSet') as UntypedFormArray).controls.push(
              new UntypedFormGroup({
                paramSetId: new UntypedFormControl(t.id)
              })
            );
          });
        }

        this.defaultTemplate = state.templates?.filter(
          t => t.isTemplate === true && t.isDefault
        )[0];

        this.wmrpModule = state.module;

        this.prevWmrpState = this.wmrpState;
        this.wmrpState = state;

        if (this.prevWmrpState?.recentAnalysisRunData) {
          this.compareStatus(
            this.wmrpState.recentAnalysisRunData,
            this.prevWmrpState.recentAnalysisRunData,
            'Analysis'
          );
        }

        if (this.prevWmrpState?.replacementSchedules) {
          this.compareStatus(
            this.wmrpState.replacementSchedules,
            this.prevWmrpState.replacementSchedules,
            'Schedule'
          );
        }
      });

    this.wmrpRecentAnalyses$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((recentAnalyses: WmrpAnalysisRun[]) => {
        this.wmrpRecentAnalyses = recentAnalyses;
        if (
          this.analysisGuid &&
          this.analysisGuid.length > 0 &&
          !this.sharedURLLoaded
        ) {
          if (this.isWMRP('WMRP USER') || this.isWMRP('WMRP READER')) {
            this.toggleToolbox(ApplicationStatus.Toolbox);
            this.store.dispatch(new SetToolboxStatus(ToolboxStatus.WMRP));
            this.analysisGuid = this.route.snapshot.params?.analysisId;
            this.scheduleGuid = this.route.snapshot.params?.scheduleId;
            this.selectRun(this.analysisGuid);
            // this.sharedURLLoaded = true;
            if (!this.scheduleGuid || this.scheduleGuid.length === 0) {
              this.store.dispatch(new Toolbox());
            }
          } else {
            if (this.showNotAuthorizedToast) {
              this.notAuthorizedToast();
              this.showNotAuthorizedToast = false;
            }
          }
        } else if (
          this.analysisGuid === undefined &&
          this.scheduleGuid === undefined &&
          this.route.snapshot.routeConfig.path === 'wmrp' &&
          this.sharedURLLoaded === false
        ) {
          this.store.dispatch(new SetToolboxStatus(ToolboxStatus.WMRP));
          this.toggleToolbox(ApplicationStatus.Toolbox);
          this.sharedURLLoaded = true;
          this.store.dispatch(new Toolbox());
        }
      });

    this.currentConditions$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((currentConds: WmrpAnalysisParam[]) => {
        this.currentConditions = currentConds;
      });

    this.replacementSchedules$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((selectedScheds: WmrpReplacementSched[]) => {
        this.replacementSchedules = selectedScheds;
        this.hasReplacementSchedules = this.replacementSchedules.length > 0;
        if (this.scheduleGuid) {
          if (this.isWMRP('WMRP USER') || this.isWMRP('WMRP READER')) {
            const schedule = this.replacementSchedules.filter(
              s => s.fmeReference_Schedule === this.scheduleGuid
            );
            if (schedule && !this.sharedURLLoaded) {
              if (schedule[0]?.status === 'SUCCESS') {
                this.selectSchedule(schedule[0]);
                this.store.dispatch(new Toolbox());
              } else {
                // toast can't load msg
                this.store.dispatch(
                  new ToastUserNotification({
                    type: 'fail',
                    title: 'Invalid schedule',
                    message: 'The schedule is not available',
                    options: {
                      disableTimeOut: false,
                      closeButton: true,
                      enableHtml: true,
                      timeOut: 5000
                    }
                  })
                );
                this.scheduleGuid = '';
              }
            }
          }
        }
      });

    this.getProfile();

    this.search = (text$: Observable<string>): Observable<SearchItem[]> => {
      return text$.pipe(
        debounceTime(50),
        distinctUntilChanged(),
        switchMap((name: string) => {
          if (name.length > 0) {
            const encodedName = encodeURIComponent(name);
            return forkJoin({
              address: this.searchService
                .getSearchItems('api/gis/searchaddress/' + encodedName)
                .pipe(
                  catchError(
                    (error: HttpErrorResponse): Observable<SearchItem[]> => {
                      return of([]);
                    }
                  )
                ),
              streets: this.searchService
                .getSearchItems('api/gis/searchstreets/' + encodedName)
                .pipe(
                  catchError(
                    (error: HttpErrorResponse): Observable<SearchItem[]> => {
                      return of([]);
                    }
                  )
                ),
              parks: this.searchService
                .getSearchItems('api/gis/searchparks/' + encodedName)
                .pipe(
                  catchError(
                    (error: HttpErrorResponse): Observable<SearchItem[]> => {
                      return of([]);
                    }
                  )
                ),
              intersections: this.searchService
                .getSearchItems('api/gis/searchitems/' + encodedName)
                .pipe(
                  catchError(
                    (error: HttpErrorResponse): Observable<SearchItem[]> => {
                      return of([]);
                    }
                  )
                ),
              pid: this.searchService
                .getSearchItems('api/gis/searchpid/' + encodedName)
                .pipe(
                  catchError(
                    (error: HttpErrorResponse): Observable<SearchItem[]> => {
                      return of([]);
                    }
                  )
                ),
              folio: this.searchService
                .getSearchItems('api/gis/searchfolio/' + encodedName)
                .pipe(
                  catchError(
                    (error: HttpErrorResponse): Observable<SearchItem[]> => {
                      return of([]);
                    }
                  )
                ),
              buildings: this.searchService
                .getSearchItems('api/gis/searchbuildings/' + encodedName)
                .pipe(
                  catchError(
                    (error: HttpErrorResponse): Observable<SearchItem[]> => {
                      return of([]);
                    }
                  )
                ),
              schools: this.searchService
                .getSearchItems('api/gis/searchschools/' + encodedName)
                .pipe(
                  catchError(
                    (error: HttpErrorResponse): Observable<SearchItem[]> => {
                      return of([]);
                    }
                  )
                ),
              trails: this.searchService
                .getSearchItems('api/gis/searchtrails/' + encodedName)
                .pipe(
                  catchError(
                    (error: HttpErrorResponse): Observable<SearchItem[]> => {
                      return of([]);
                    }
                  )
                )
              // drawings:
              //   this.searchService.getSearchItems('api/engNum/' + encodedName)
              //     .pipe(
              //       catchError((error: HttpErrorResponse): Observable<SearchItem[]> => {
              //         return of([]);
              //       }),
              //     ),
            });
          } else {
            return EMPTY;
          }
        }),
        map(itemsMap => {
          return [
            ...itemsMap.address,
            ...itemsMap.parks,
            ...itemsMap.streets,
            ...itemsMap.intersections,
            ...itemsMap.pid,
            ...itemsMap.folio,
            ...itemsMap.buildings,
            ...itemsMap.schools,
            ...itemsMap.trails
            // , ...itemsMap.drawings
          ];
        })
      );
    };

    this.engDrawSearchNum = (
      searchNum$: Observable<string>
    ): Observable<SearchItem[]> => {
      return searchNum$.pipe(
        debounceTime(50),
        distinctUntilChanged(),
        switchMap((name: string) => {
          const encodedName = encodeURIComponent(name);
          if (name.length > 1 && name.indexOf(',') === -1) {
            this.searchingNum = true;
            return this.searchService
              .getSearchItems('api/engNum/' + encodedName)
              .pipe(
                finalize(() => (this.searchingNum = false)),
                map(response => {
                  return response.length > 0
                    ? response
                    : [
                      {
                        name: 'no results',
                        assetId: '0',
                        id: 0,
                        type: SearchItemType.Drawing
                      } as SearchItem
                    ];
                }),
                catchError(
                  (error: HttpErrorResponse): Observable<SearchItem[]> => {
                    this.searchingNum = false;
                    return of([]);
                  }
                )
              );
          } else {
            return EMPTY;
          }
        })
      );
    };

    this.engDrawSearchProj = (
      searchProj$: Observable<string>
    ): Observable<SearchItem[]> => {
      return searchProj$.pipe(
        debounceTime(100),
        distinctUntilChanged(),
        switchMap((name: string) => {
          this.searchingProj = true;
          const encodedName = encodeURIComponent(name);
          if (name.length > 1) {
            return this.searchService
              .getSearchItems('api/engproj/' + encodedName)
              .pipe(
                finalize(() => (this.searchingProj = false)),
                map(response => {
                  return response.length > 0
                    ? response
                    : [
                      {
                        name: 'no results',
                        assetId: '0',
                        id: 0,
                        type: SearchItemType.Drawing
                      }
                    ];
                }),
                catchError(
                  (error: HttpErrorResponse): Observable<SearchItem[]> => {
                    this.searchingProj = false;
                    return of([]);
                  }
                )
              );
          } else {
            return EMPTY;
          }
        })
      );
    };

    this.ppSearchNum = (
      ppSearchNum$: Observable<string>
    ): Observable<SearchItem[]> => {
      return ppSearchNum$.pipe(
        debounceTime(50),
        distinctUntilChanged(),
        switchMap((name: string) => {
          const encodedName = encodeURIComponent(name);
          if (name.length > 1 && name.indexOf(',') === -1) {
            this.searchingNum = true;
            return this.searchService
              .getSearchItems('api/ppNum/' + encodedName)
              .pipe(
                finalize(() => (this.searchingNum = false)),
                map(response => {
                  return response.length > 0
                    ? response
                    : [
                      {
                        name: 'no results',
                        assetId: '0',
                        id: 0,
                        type: SearchItemType.Drawing
                      } as SearchItem
                    ];
                }),
                catchError(
                  (error: HttpErrorResponse): Observable<SearchItem[]> => {
                    this.searchingNum = false;
                    return of([]);
                  }
                )
              );
          } else {
            return EMPTY;
          }
        })
      );
    };

    this.assetSearch = (
      assetSearch$: Observable<string>
    ): Observable<SearchItem[]> => {
      return assetSearch$.pipe(
        debounceTime(50),
        distinctUntilChanged(),
        switchMap((assetId: string) => {
          const encodedAssetId = encodeURIComponent(assetId);

          if (assetId.length > 1 && assetId.indexOf(',') === -1) {
            this.searchingAsset = true;
            return this.searchService
              .getSearchItems('api/assetSearch/' + encodedAssetId)
              .pipe(
                finalize(() => (this.searchingAsset = false)),
                map(response => {
                  return response.length > 0
                    ? response
                    : [
                      {
                        name: 'no results',
                        assetId: 'no results',
                        id: 0,
                        type: SearchItemType.AssetSearch
                      } as SearchItem
                    ];
                }),
                catchError(
                  (error: HttpErrorResponse): Observable<SearchItem[]> => {
                    this.searchingAsset = false;
                    return of([]);
                  }
                )
              );
          } else {
            return EMPTY;
          }
        })
      );
    };

    this.circleRadius.valueChanges
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe(() => this.updateCircleRadius());

    // this.store.dispatch(new GetAppSettings(this.configService));
    this.store.dispatch(
      new GetBasemaps(`${this.configService.webApiEndpoint}basemap`)
    );
    this.store.dispatch(
      new LoadBasemapLegendLayers({ url: 'api/basemap/basemaplegends' })
    );
    this.store.dispatch(
      new SetMapState(this.configService.initialDnvMapState())
    );
    this.store.dispatch(new SetIcons(this.configService.initialSearchIcons()));
    this.store.dispatch(
      new GetLayers(`${this.configService.webApiEndpoint}layers`)
    );
    this.store.dispatch(new GetToolsPermissions());
    this.store.dispatch(new GetEditPermission());

    if (this.applicationState.appSettings) {
      this.store.dispatch(
        new SetSearchItemsUrl(
          `${this.applicationState.appSettings['environment.searchApiEndpointUrl']}api/searchitems`
        )
      );
    }

    // if (this.mapState.featureLayers && this.mapState.featureLayers.length > 0) {
    //   this.store.dispatch(new LoadLegendLayers({ url: 'api/legends' }));
    // }

    // this.store.dispatch(new DelayedActionBy1([
    //   new DelayedActionBy1([
    //     new MapViewLoad()
    //   ])
    // ]));

    this.store.dispatch(new LoadLegendLayers({ url: 'api/legends' }));

    this.appStoreWrapper = new AppStoreWrapper();
    this.store.dispatch(new MapViewSetStoreWrapper(this.appStoreWrapper));

    this.appUrlProvider = new AppUrlProvider(''); // Typically '' would work as an input here.
    this.store.dispatch(new MapViewSetUrlProvider(this.appUrlProvider));

    this.store.dispatch(
      new MapViewLoad({
        urlProvider: this.appUrlProvider,
        storeWrapper: this.appStoreWrapper,
        selectedId: noLoadedMapView
      })
    );

    // Inspect the url - if a shared ID was provided, load it, otherwise load the user's default MapView
    if (this.route.snapshot && this.route.snapshot.params) {
      const sharedIdLabel = 'sharedId';
      const sharedId: string = this.route.snapshot.params[sharedIdLabel];
      let action: Action;
      if (sharedId) {
        action = new MapViewLoadSharedId({
          urlProvider: this.appUrlProvider,
          storeWrapper: this.appStoreWrapper,
          sharedId
        });

        this.store.dispatch(
          new DelayedActionBy1([new DelayedActionBy1([action])])
        );
      } else {
        action = new MapViewLoadDefault({
          urlProvider: this.appUrlProvider,
          storeWrapper: this.appStoreWrapper
        });
        // waiting for map views to finish loading before setting default view, GT-476
        this.mapViewState$
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe((mvt: MapViewState) => {
            if (
              mvt.mapViews &&
              mvt.mapViews.length > 0 &&
              this.defaultViewLoaded === false
            ) {
              this.store.dispatch(
                new DelayedActionBy1([new DelayedActionBy1([action])])
              );
              this.defaultViewLoaded = true;
            }
          });
      }

      if (this.route.snapshot.url[0]?.path.indexOf('wmrp') > -1) {
        this.store.dispatch(new GetWMRPModule());
        this.store.dispatch(new GetMaterialsDictionary());
        this.store.dispatch(new GetTemplateNames());

        this.store.dispatch(new GetAnalysisDetails());

        this.analysisGuid = this.route.snapshot.params?.analysisId;
        this.scheduleGuid = this.route.snapshot.params?.scheduleId;
      }
    }

    this.colorSwatches = this.generateColors();
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  get hazardMax() {
    return this.hazardForm.get('hazardMax') as UntypedFormControl;
  }

  get hazardMin() {
    return this.hazardForm.get('hazardMin') as UntypedFormControl;
  }

  // Demo interceptor - obtain user profile
  getProfile(): void {
    this.httpClient
      .get(this.graphMeEndpoint)
      .toPromise()
      .then((profile: UserProfile) => {
        this.userProfile = profile;
        this.userIcon =
          profile.givenName.substring(0, 1).toUpperCase() +
          profile.surname.substring(0, 1).toUpperCase();
        this.store.dispatch(new SetUserProfile(this.userProfile));
      });

    // this.httpClient.get('https://localhost:44308/api/user/info').toPromise()
    //   .then((data: any) => {
    //     console.log(data);
    //   });
  }

  logout(): void {
    // this.authService.logout();
    this.router.navigate(['/logout']);
  }

  ngAfterViewInit(): void {
    if (this.headerHeight === 0) {
      this.setHeaderHeight();
    }
    if (this.applicationState.windowInnerWidth > 767) {
      this.isDesktop = true;
    }
    this.changeDetector.detectChanges();


    this.baseMapState$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((state: BaseMapState) => {
        this.baseMapState = state;
        const historicAerials = state.basemap.filter(
          b => b.name.indexOf('Ortho ') > -1
        );
        // sort by year
        historicAerials.sort((x, y) => {
          const xYear = x.name.substr(6, x.name.length);
          const yYear = y.name.substr(6, x.name.length);
          return xYear === yYear ? 0 : xYear < yYear ? -1 : 1;
        });
        if (this.applicationState.toolboxStatus !== ToolboxStatus.HistoricalAerials) {
          this.store.dispatch(new SetHistoricalAerials(historicAerials));
        }
        /*       if (historicAerials && historicAerials.length > 0) {
              historicAerials.forEach(h => {
                const lyr = this.dnvMap.getBasemapLayer(h);
                lyr.options.pane = 'sub-basemap';  // specify map pane
                lyr.addTo(this.dnvMap.subBaseLayerGroup);  // add to layer group
              });
            } */

        this.bmLegendCache = state.basemapLegendsCache;
      });


    this.mapState$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((state: DnvMapState) => {
        if (
          state.historicalAerials &&
          state.historicalAerials.length > 0 &&
          this.aerialDates.length === 0
        ) {
          this.aerialDates = state.historicalAerials.map(h =>
            Number(h.name.substring(6))
          );
          const newOptions = Object.assign({}, this.haSliderOptions);
          newOptions.ceil = this.aerialDates.length - 1;
          this.haSliderOptions = newOptions;
          // console.log(this.aerialDates);
        }
      });
  }

  setHeaderHeight(): void {
    if (this.applicationState.windowInnerWidth > 767) {
      if (this.headerHeight === undefined) {
        this.headerHeight = this.fixedHeader
          ? this.fixedHeader.nativeElement.clientHeight
          : 54;
      }
      this.panelHeight =
        this.applicationState.windowInnerHeight - this.headerHeight;
      this.contentHeight = this.panelHeight - 47;
      this.headerHeightSecondary = this.headerHeight + 12;
    } else {
      // mobile
      this.headerHeight = 60;
      this.panelHeight = this.applicationState.windowInnerHeight - 110;
    }
    this.inspectionHeight = this.panelHeight - 45;
  }

  // dnv-map event handlers

  onMapClick(coordinates: DnvMapInfo): void {
    if (
      !this.mapState.editFeatures &&
      this.applicationState.toolboxStatus !== ToolboxStatus.AssetFinder
    ) {
      this.closeFeatureInformation();
    }

    // close panels on map click
    if (!ApplicationStatus.Draw) {
      this.toIdle(ApplicationStatus.Idle);
    }
    this.resetDrawEdit();

    this.store.dispatch(new ToggleMetaDataPanel(false));

    // property info
    if (this.applicationState.toolboxStatus === ToolboxStatus.PropertyInfo) {
      // clear search field
      this.onClearClicked();
      this.store.dispatch(new GetPropertyByXY(coordinates.latlng));
      this.store.dispatch(new SetSelectedProperty(''));
      this.propertyInfoScrollToTop = true;
    }
    // service conneciton report
    else if (
      this.applicationState.toolboxStatus === ToolboxStatus.ServiceConnections
    ) {
      this.store.dispatch(
        new GetServiceConnectionsByLatLong(coordinates.latlng)
      );

      this.prevConn = { name: '', objectId: 9 };
    }
    // cctv
    else if (this.applicationState.toolboxStatus === ToolboxStatus.CCTV) {
      this.store.dispatch(new SetCCTV([]));
      this.dispatchIdentifyCCTVFeature(coordinates);
    } else if (
      this.applicationState.toolboxStatus === ToolboxStatus.MailMerge
    ) {
      if (
        this.toolboxMailMergeState.area.url &&
        this.toolboxMailMergeState.bufferedArea.url &&
        this.applicationState.shapeCreated === false
      ) {
        this.store.dispatch(
          new ToolboxMailMergeToggleParcelAtCoordinate({
            latlng: coordinates.latlng
          })
        );
      } else {
        if (this.toolboxMailMergeState.selectionMethod === 'property') {
          this.store.dispatch(
            new GetMailMergeByProperty({
              latlng: coordinates.latlng
            })
          );
        }
      }
      this.store.dispatch(new ShapeCreated(false));
    } else if (
      this.applicationState.toolboxStatus === ToolboxStatus.PopulationCalculator
    ) {
      this.dispatchIdentifySurroundingFeature(coordinates);
    } else {
      if (
        this.mapState.editFeaturesPermission &&
        this.mapState.editFeaturesPermission.featureLayerName
          .toLowerCase()
          .indexOf('excluded mains') === -1
      ) {
        this.dispatchIdentifyEditFeature(coordinates);
        //   } else {
        //     this.dispatchIdentifySurroundingFeature(coordinates);
        //   }
      } else {
        this.dispatchIdentifySurroundingFeature(coordinates);
      }
    }

    if (this.applicationState.streetView) {
      this.store.dispatch(new LaunchStreetView(coordinates.latlng));
    }
  }

  onShapeCreated(mapInfo: any) {
    // console.log('mapInfo: ', mapInfo);
    this.store.dispatch(new ShapeCreated(true));
  }

  dispatchIdentifySurroundingFeature(coordinates: DnvMapInfo): void {
    if (this.layerState.layers.length > 0 && !this.selectedFeature) {
      const flIds: number[] = [];
      // const wClauses: string[] = [];
      const wClauses: any[] = [];
      this.layerState.layers.forEach(layer => {
        if (layer.type === 0) {
          layer.featureLayers.forEach(featureLayer => {
            if (
              !(this.appSettings[
                'appConfig.NonClickableFeatureLayers'
              ] as any).includes(featureLayer.name)
            ) {
              const flMinZoom = this.gisUtility.minZoomFromMinScale(
                featureLayer.minScale,
                0,
                this.mapState.resolutions
              );
              const flMaxZoom = this.gisUtility.maxZoomFromMaxScale(
                featureLayer.maxScale,
                this.mapState.resolutions.length - 1,
                this.mapState.resolutions
              );
              if (
                featureLayer.isVisible === true &&
                featureLayer.type.toLocaleLowerCase() !== 'tile' &&
                flMinZoom <= this.mapState.zoomLevel &&
                flMaxZoom >= this.mapState.zoomLevel
              ) {
                let featureLayerId = featureLayerIdFromDynamicFLId(
                  featureLayer.featureLayerId
                );
                flIds.push(featureLayerId);
                if (featureLayer.whereClause !== '1=1') {
                  // wClauses.push(featureLayer.featureLayerId + '\r' + featureLayer.whereClause);
                  wClauses.push({
                    featureLayerId: featureLayerId,
                    whereClause: featureLayer.whereClause
                  });
                }
              }
            }
          });
        }
      });

      // no active layers but there is feature layer, ie one of the tools is active
      if (flIds.length === 0 && this.mapState.featureLayers.length > 0) {
        this.mapState.featureLayers.forEach(f => {
          let featureLayerId = featureLayerIdFromDynamicFLId(f.featureLayerId);
          flIds.push(featureLayerId);
          if (f.whereClause !== '1=1') {
            // wClauses.push(f.featureLayerId + '\r' + f.whereClause);
            wClauses.push({
              featureLayerId: featureLayerId,
              whereClause: f.whereClause
            });
          }
        });
        this.store.dispatch(new SelectFeature(null));
      }

      if (flIds.length === 0) {
        return; // We don't need to query if there are no layers
      }

      // const flIdSet = new Set(flIds);
      const featureLayerIds = Array.from(new Set(flIds)).join(',');

      // combine multiple dynamic feature layer's where clauses into one
      // [20000342, 20010342, 20020342] -> 342 : x OR y OR z
      let whereClause = '';
      if (wClauses.length > 0) {
        const wMap: Map<number, string[]> = new Map();
        wClauses.forEach(value => {
          const featureLayerId = featureLayerIdFromDynamicFLId(
            value.featureLayerId
          );
          let ws: string[] = [];
          if (wMap.has(featureLayerId)) {
            ws = wMap.get(featureLayerId);
          }
          ws = ws.concat(value.whereClause);
          wMap.set(featureLayerId, ws);
        });

        const wc: string[] = [];
        wMap.forEach((value, key) => {
          const whereClause = value.map(v => '(' + v + ')').join(' or ');
          wc.push(key + '\r' + whereClause);
        });

        // const wClauses: string[] = [];
        whereClause = '&where=' + wc.join('\t');
      }

      if (this.applicationState.toolboxStatus === ToolboxStatus.WMRP) {
        // uses http post
        const identifyParams: IdentifySurroundingFeatureParam = {
          latlng: { lat: coordinates.latlng.lat, lng: coordinates.latlng.lng },
          northWestBound: {
            lat: coordinates.mapBounds.northWestBound.lat,
            lng: coordinates.mapBounds.northWestBound.lng
          },
          southEastBound: {
            lat: coordinates.mapBounds.southEastBound.lat,
            lng: coordinates.mapBounds.southEastBound.lng
          },
          imageDisplay: coordinates.mapSizeInPixel,
          layerNum: featureLayerIds,
          isEditTool: false,
          whereClause: whereClause // .slice(whereClause.indexOf(&))
        };
        this.store.dispatch(new IdentifySurroundingFeaturePost(identifyParams));
      } else {
        // check if layer is clickable
        // checking mapState.featureLayers instead of layerState.layers.type because assetFinder doesn't change layer type but needs to be clickable
        this.mapState.featureLayers.forEach(fl => {
          if (
            !(this.appSettings[
              'appConfig.NonClickableFeatureLayers'
            ] as any).includes(fl.name)
          ) {
            // uses http get
            this.store.dispatch(
              new IdentifySurroundingFeature(
                `${this.configService.webApiEndpoint}identifyFeatures?latlng=` +
                coordinates.latlng.lng +
                `,` +
                coordinates.latlng.lat +
                `&northWestBound=` +
                coordinates.mapBounds.northWestBound.lat +
                `,` +
                coordinates.mapBounds.northWestBound.lng +
                `&southEastBound=` +
                coordinates.mapBounds.southEastBound.lat +
                `,` +
                coordinates.mapBounds.southEastBound.lng +
                `&imageDisplay=` +
                coordinates.mapSizeInPixel +
                `&layerNum=` +
                featureLayerIds +
                `&isEditTool=false` +
                encodeURI(whereClause)
              )
            );
          }
        });
      }
    }
  }

  dispatchIdentifyEditFeature(coordinates: DnvMapInfo): void {
    const url =
      this.configService.webApiEndpoint +
      'identifyFeatures?latlng=' +
      coordinates.latlng.lng +
      ',' +
      coordinates.latlng.lat +
      '&northWestBound=' +
      coordinates.mapBounds.northWestBound.lat +
      ',' +
      coordinates.mapBounds.northWestBound.lng +
      '&southEastBound=' +
      coordinates.mapBounds.southEastBound.lat +
      ',' +
      coordinates.mapBounds.southEastBound.lng +
      '&imageDisplay=' +
      coordinates.mapSizeInPixel +
      '&layerNum=' +
      this.mapState.editFeaturesPermission.featureLayerId +
      '&isEditTool=true';
    this.store.dispatch(new IdentifySurroundingFeature(url));
  }

  dispatchIdentifyCCTVFeature(coordinates: DnvMapInfo): void {
    const featureLayerIds = this.layerState.layers
      .filter(l => ['Data_CCTV'].includes(l.uid))
      .map(l => l.featureLayers.map(fl => fl.featureLayerId))
      .reduce(
        (accumulator, currentValue) => accumulator.concat(currentValue),
        []
      )
      .join(',');

    this.store.dispatch(
      new IdentifySurroundingFeature(
        `${this.configService.webApiEndpoint}identifyFeatures?latlng=` +
        coordinates.latlng.lng +
        `,` +
        coordinates.latlng.lat +
        `&northWestBound=` +
        coordinates.mapBounds.northWestBound.lat +
        `,` +
        coordinates.mapBounds.northWestBound.lng +
        `&southEastBound=` +
        coordinates.mapBounds.southEastBound.lat +
        `,` +
        coordinates.mapBounds.southEastBound.lng +
        `&imageDisplay=` +
        coordinates.mapSizeInPixel +
        `&layerNum=` +
        featureLayerIds +
        `&isEditTool=false`
      )
    );
  }

  onMoveChange(state: DnvMapState): void {
    this.store.dispatch(
      new CenterMap({ lat: state.centerPoint.lat, lng: state.centerPoint.lng })
    );
    this.store.dispatch(
      new MapViewCheckIsDirty({
        urlProvider: this.appUrlProvider,
        storeWrapper: this.appStoreWrapper
      })
    );
  }

  onZoomChange(state: DnvMapState): void {
    this.store.dispatch(new SetZoom(state.zoomLevel));
    this.store.dispatch(
      new MapViewCheckIsDirty({
        urlProvider: this.appUrlProvider,
        storeWrapper: this.appStoreWrapper
      })
    );
  }

  onMapUpdate(actions: DnvMapAction[]): void {
    this.store.dispatch(new DelayedAction(actions));

    // TODO dispatch MapViewMarkDirty when layers change

    let markDirty = false;
    actions.forEach((action: DnvMapAction) => {
      switch (action.type) {
        case DnvMapActionType.AddedFeature:
        case DnvMapActionType.DeleteFeature:
        // case DnvMapActionType.UpdateFeature: ???
        case DnvMapActionType.UpdateConversionUnit:
        // case DnvMapActionType.StartDraw:
        case DnvMapActionType.UpdateFeatureGeoCoord:
          markDirty = true;
          break;

        // case DnvMapActionType.ResetSelected:
        //   this.store.dispatch(new SetFeatureAttachment(null));
        //   this.store.dispatch(new SetInspection(null));
        //   break;

        // case DnvLayerActionType.SetInspFields:
        //   this.store.dispatch(new SetInspectionFields(action.payload));
        //   break;

        default:
          break;
      }
    });

    if (markDirty) {
      this.store.dispatch(new MapViewMarkDirty());
    }
  }

  onZoomToFeatures(featureFilterPayload: FeatureFilterPayload): void {
    this.store.dispatch(
      new ZoomToFeatures([featureFilterPayload.featureLayer])
    );
  }

  onUpdateFilter(featureFilterPayload: FeatureFilterPayload): void {
    this.store.dispatch(
      new InvalidateGridCache({
        dnvFeatureLayer: featureFilterPayload.featureLayer
      })
    );

    // If the grid is showing the featureLayer for which the filter is being modified, refresh the data
    if (
      this.applicationState.gridSelectLayer &&
      this.applicationState.gridSelectLayer.uid ===
      featureFilterPayload.featureLayer.uid
    ) {
      this.store.dispatch(new GridSelectLayer({ dnvFeatureLayer: null }));
      // this.store.dispatch(new GridSelectLayer({ dnvFeatureLayer: featureFilterPayload.featureLayer }));
    }
    this.store.dispatch(new UpdateLayerFilter(featureFilterPayload));
    // if (featureFilterPayload.geometry && featureFilterPayload.geometry.length > 0) {
    //   this.store.dispatch(new QueryLayerFeatureCountAOI(
    //     { filterPayload: featureFilterPayload, coordinates: featureFilterPayload.geometry }));
    // } else {
    this.store.dispatch(new QueryLayerFeatureCount(featureFilterPayload));
    // }

    if (
      this.applicationState.status === ApplicationStatus.Toolbox &&
      this.applicationState.toolboxStatus === ToolboxStatus.WMRP
    ) {
      this.store.dispatch(new UpdateWMRPLayerFilter(featureFilterPayload));
      if (
        featureFilterPayload.featureLayer.uid
          .toLowerCase()
          .indexOf('wmrp_analysis') > -1
      ) {
        this.updateWmrpAnalysisCBR();
      }
      if (
        featureFilterPayload.featureLayer.uid
          .toLowerCase()
          .indexOf('wmrp_schedule') > -1
      ) {
        this.updateWmrpScheduleCBR();
      }
      if (
        featureFilterPayload.featureLayer.uid
          .toLowerCase()
          .indexOf('wmrp_poor_access') > -1
      ) {
        this.updateWmrpPoorAccessCBR();
      }
      if (
        featureFilterPayload.featureLayer.uid
          .toLowerCase()
          .indexOf('wrp_merged_scores') > -1 ||
        featureFilterPayload.featureLayer.uid
          .toLowerCase()
          .indexOf('wmrp_merged_scores') > -1
      ) {
        this.updateWmrpMergedScoresCBR();
      }
    }

    // this.store.dispatch(new QueryLayerFeatureCount(featureFilterPayload));
    this.store.dispatch(new CheckLayerDisplay());

    this.store.dispatch(
      new MapViewCheckIsDirty({
        urlProvider: this.appUrlProvider,
        storeWrapper: this.appStoreWrapper
      })
    );
  }

  hideFilterPanel(): void {
    this.store.dispatch(new HideFilterPanel());
  }

  onSetBaseMap(basemap: DnvBasemap): void {
    // const a: DnvBasemap[] = [basemap];
    // this.store.dispatch(new SetMapBasemaps(a));
    this.store.dispatch(new SetBaseMapSelected(basemap));
    // this.store.dispatch(new CloseBasemaps());
    this.initializeLegend();
  }

  onSelectBasemap(basemap: DnvBasemap): void {
    this.store.dispatch(new SelectBasemap(basemap));
    this.store.dispatch(
      new MapViewCheckIsDirty({
        urlProvider: this.appUrlProvider,
        storeWrapper: this.appStoreWrapper
      })
    );
    this.initializeLegend();
  }

  onToggleShowFilterPanel(filterPayload: FeatureFilterPayload): void {
    if (!filterPayload.featureLayer.showFilterPanel) {
      this.store.dispatch(
        new DelayedActionBy1([new QueryLayerFeatureCount(filterPayload)])
      );
    }

    this.store.dispatch(new ToggleShowFilterPanel(filterPayload));
  }

  onLayersOrdered(evt: any): void {
    this.store.dispatch(evt);
    // if (this.applicationState.toolboxStatus !== ToolboxStatus.WMRP) {
    //   this.store.dispatch(evt);
    // } else {
    //   // this.wmrpLayerState.layers = evt.payload;
    //   if (this.applicationState.status === ApplicationStatus.Toolbox && this.applicationState.toolboxStatus === ToolboxStatus.WMRP) {
    //     this.store.dispatch(new SetWMRPLayers(evt.payload));
    //   }

    // }

    this.store.dispatch(new SetMapFeatureLayers(this.layerList(evt.payload)));
    this.store.dispatch(
      new MapViewCheckIsDirty({
        urlProvider: this.appUrlProvider,
        storeWrapper: this.appStoreWrapper
      })
    );
    this.initializeLegend();
  }

  setActiveLayer(layer: DnvLayer): void {
    this.store.dispatch(new SetActiveLayer(layer));

    this.store.dispatch(new CheckLayerDisplay());
    if (layer.layerInfo.length > 0) {
      this.store.dispatch(new SetLayerInfo(layer.layerInfo));
    } else {
      if (
        this.applicationState.toolboxStatus !==
        this.ToolboxStatus.ServiceConnections
      ) {
        this.store.dispatch(new SetLayerInfo(''));
      }
    }
    this.store.dispatch(
      new MapViewCheckIsDirty({
        urlProvider: this.appUrlProvider,
        storeWrapper: this.appStoreWrapper
      })
    );

    // reapply opacity
    if (this.layerOpacity < 1) {
      this.store.dispatch(new SetFeatureLayersOpacity(this.layerOpacity));
    }

    if (
      this.applicationState.status === ApplicationStatus.Toolbox &&
      this.applicationState.toolboxStatus === ToolboxStatus.WMRP
    ) {
      this.store.dispatch(new SetWMRPActiveLayer(layer));
    }
    this.initializeLegend();
  }

  setAvailableLayer(layer: DnvLayer): void {
    this.store.dispatch(new HideFilterPanel()); // TODO WIP fix this

    // if one of the layers currently being removed was the active grid, remove it
    if (this.applicationState.gridSelectLayer) {
      layer.featureLayers.forEach((featureLayer: any) => {
        if (
          this.applicationState.gridSelectLayer &&
          this.applicationState.gridSelectLayer.uid === featureLayer.uid
        ) {
          this.store.dispatch(new GridSelectLayer({ dnvFeatureLayer: null }));
        }
      });
    }

    this.store.dispatch(new SetAvailableLayer(layer));

    this.store.dispatch(new CheckLayerDisplay());
    // this.store.dispatch(new MapViewCheckIsDirty());
    this.store.dispatch(
      new MapViewCheckIsDirty({
        urlProvider: this.appUrlProvider,
        storeWrapper: this.appStoreWrapper
      })
    );

    // remove filters when layer is removed
    this.store.dispatch(
      new ClearLayerFilters({ layer, hidden: this.wmrpHiddenFields })
    );

    // reapply opacity
    if (this.layerOpacity < 1) {
      this.store.dispatch(new SetFeatureLayersOpacity(this.layerOpacity));
    }

    if (layer.uid.indexOf('WMRP_SCHEDULE') > -1) {
      this.scheduleGuid = '';
      this.store.dispatch(new SetSelectedReplacementSchedule(null));
      const scheduleLyr = Object.assign({}, layer, {
        type: LayerType.WmrpLayer,
        name: 'Schedule Layer'
      });
      this.store.dispatch(new UpdateLayer(scheduleLyr));
    }

    if (
      this.applicationState.status === ApplicationStatus.Toolbox &&
      this.applicationState.toolboxStatus === ToolboxStatus.WMRP
    ) {
      // check if layer was added by user before
      if (layer.uid.indexOf('WMRP_ANALYSIS') > -1) {
        const keepLayer = this.mapState.featureLayers.filter(
          fl => fl.uid.indexOf('WMRP_ANALYSIS') > -1
        );
        if (keepLayer.length === 0) {
          this.store.dispatch(new SetWMRPAvailableLayer(layer));
        }
      } else {
        this.store.dispatch(new SetWMRPAvailableLayer(layer));
      }
    }

    // close feature panel if layer is being removed
    this.closeFeatureInformation();

    this.initializeLegend();
  }

  toggleBasemaps(): void {
    this.store.dispatch(new ToggleBasemaps());
  }

  toggleLayer(status: ApplicationStatus): void {
    this.toggleOffDraw();
    this.closePropertyInformation();
    this.resetFeaturesEditing();
    if (status !== ApplicationStatus.Layer) {
      this.store.dispatch(new Layer());
      // resets grid select layer in case user changes visibility
      this.store.dispatch(new GridSelectLayer({ dnvFeatureLayer: null }));
    } else {
      this.toIdle(status);
    }
    this.store.dispatch(new HideFilterPanel());
    this.store.dispatch(new EditFeatureLayerSymbology(null));

    this.closeWMRPpanels(status);
    // reset layer types when leaving wmrp tool
    for (let layer of this.wmrpState.layers) {
      if (this.type2LayerUids?.includes(layer.uid)) {
        layer.type = 2;
      }
    }

    this.rewriteUrl();
  }

  toggleTable(status: ApplicationStatus): void {
    this.toggleOffDraw();
    this.closePropertyInformation();
    this.resetFeaturesEditing();
    this.store.dispatch(new HideFilterPanel());
    this.store.dispatch(new EditFeatureLayerSymbology(null));
    if (status !== ApplicationStatus.Table) {
      this.store.dispatch(new Table());

      // As the table is openned, if no featureLayer is selected, load the first one
      if (!this.applicationState.gridSelectLayer) {
        // this.store.dispatch(new GridSelectLayer({ dnvFeatureLayer:  }));
        const activeLayer = this.layerState.layers.find(
          layer =>
            layer.type === LayerType.Active &&
            layer.featureLayers.find((f: any) => f.isVisible)
        );
        if (
          activeLayer &&
          activeLayer.featureLayers &&
          activeLayer.featureLayers.length > 0
        ) {
          const visibleLayer = activeLayer.featureLayers.filter(
            (f: any) => f.isVisible
          );
          if (visibleLayer) {
            this.store.dispatch(
              new GridSelectLayer({ dnvFeatureLayer: visibleLayer[0] })
            );
          }
        }
      }

      this.closeFeatureInformation();
    } else {
      this.toIdle(status);
      this.store.dispatch(new GridSelectLayer({ dnvFeatureLayer: null }));
    }

    this.closeWMRPpanels(status);
  }

  deleteAllShapes(): void {
    let confirmDelAll = confirm('Are you sure you want to clear all Drawings?');
    if (confirmDelAll === true) {
      this.store.dispatch(new DeleteAllArrows(true));
      this.store.dispatch(new EditShapes([]));
    }
  }

  toggleLegend(status: ApplicationStatus): void {
    this.toIdle(status);
    this.toggleOffDraw();
    this.closePropertyInformation();
    this.resetFeaturesEditing();
    this.onDnvLegendSymbolizeCancel();
    this.store.dispatch(new HideFilterPanel());
    if (status !== ApplicationStatus.Legend) {
      this.store.dispatch(new Legend());
      this.store.dispatch(new ToggleMetaDataPanel(false));
      this.initializeLegend();
    }

    this.closeWMRPpanels(status, false); // TODO Close toolbox panel if open?
  }

  // Legend
  onShowSymbolizeComponentEmitter(legendLayer: DnvFeatureLayer): void {
    if (null === legendLayer) {
      this.store.dispatch(
        new ToastUserNotification({
          type: 'info',
          title: 'Symbolize',
          message: "This layer's symbology can not be customized.",
          options: {
            disableTimeOut: false,
            closeButton: true,
            enableHtml: true
          }
        })
      );
    }
    // layer from edit tool
    if (
      this.mapState.editFeaturesPermission &&
      this.mapState.editFeaturesPermission.featureLayerName
    ) {
      let edl;
      for (const ep of this.applicationState.editPermission) {
        for (const edlyr of ep.editableLayers) {
          if (
            edlyr.featureLayerName ===
            this.mapState.editFeaturesPermission.featureLayerName
          ) {
            edl = edlyr;
            break;
          }
        }
      }

      if (edl) {
        const symbolCopy = edl.symbology;
        const modEfl = Object.assign({}, legendLayer, {
          symbology: symbolCopy, // parseDrawInfo(this.mapState.editFeaturesPermission),
          drawingInfo: edl.drawingInfo
        }) as any;
        legendLayer = modEfl;
      }
    }
    // console.log(legendLayer);
    this.store.dispatch(new EditFeatureLayerSymbology(legendLayer));
  }
  onDnvLegendSymbolizeApply(legendObj: {
    legendLayer: DnvFeatureLayer;
    action: string;
  }) {
    const legendLyr = legendObj.legendLayer;
    // console.log(legendLayer);
    // update legendState.editFeatureLayerSymbology if Edit Tool active
    if (
      this.mapState.editFeaturesPermission &&
      this.mapState.editFeaturesPermission.featureLayerName
    ) {
      const efLegendLyr = Object.assign({}, legendLyr, {
        symbology: {
          ...legendLyr.symbology,
          timestamp: new Date().toISOString()
        }
      });
      this.store.dispatch(new EditFeatureLayerSymbology(efLegendLyr));
      this.store.dispatch(new SetEditPermissionSymbology(efLegendLyr));
    } else {
      // edit tool not active, update layerState
      this.store.dispatch(new SetFeatureLayerSymbology(legendLyr));
    }

    this.store.dispatch(new CheckLayerDisplay());
    if (legendObj.action === 'apply') {
      this.store.dispatch(new EditFeatureLayerSymbology(legendLyr)); // symbolize panel stays open
    } else {
      this.store.dispatch(new EditFeatureLayerSymbology(null)); // symbolize panel closes
    }

    this.store.dispatch(
      new MapViewCheckIsDirty({
        urlProvider: this.appUrlProvider,
        storeWrapper: this.appStoreWrapper
      })
    );
  }
  onDnvLegendSymbolizeCancel() {
    // onDnvLegendSymbolizeAction(action: Action) {
    // console.log(action);
    this.store.dispatch(new EditFeatureLayerSymbology(null));
  }

  initializeLegend(): void {
    this.currentLayerInfo = undefined;
    // const layers: DnvLayer[] = this.layerState.layers
    //   .filter(l => l.type === LayerType.Active);
    // const featureLayers: DnvFeatureLayer[] = layers
    //   .map(l => l.featureLayers)
    //   .reduce((accumulator, currentValue) => accumulator.concat(currentValue), []) // Poor man's FlatMap
    //   .filter(fl => fl.isVisible);

    let featureLayers: DnvFeatureLayer[];

    if (this.mapState.featureLayers) {
      featureLayers = this.mapState.featureLayers.filter(fl => fl.isVisible);
    }

    const activeLegends: LayerInfo[] = [];

    const error: any[] = [];
    if (featureLayers) {
      for (const fl of featureLayers) {
        if (Number(fl.gisLayerNum) >= 0) {
          const legend = this.legendState.legendCache.find(
            (l: any) =>
              Number(fl.gisLayerNum) === l.layerId && fl.name === l.layerName
          );
          if (legend) {
            activeLegends.push(legend);
          } else {
            if (fl.uid.indexOf('WMRP_SCHEDULE') > -1) {
              let legend = this.legendState.legendCache.find(
                (l: any) => 'WMRP Schedule' === l.layerName
              );

              // legend = Object.assign({}, legend, { layerName: fl.displayName });

              if (legend && !activeLegends.includes(legend)) {
                activeLegends.push(legend);
              }
            } else if (fl.uid.toLowerCase().indexOf('merged_scores') > -1) {
              let legend = this.legendState.legendCache.find(
                (l: any) =>
                  l.layerName.toLowerCase().indexOf('merged scores') > -1
              );

              if (legend && !activeLegends.includes(legend)) {
                activeLegends.push(legend);
              }
            } else {
              // ie contours layers
              const legend = this.legendState.legendCache.find(
                (l: any) => fl.name === l.layerName
              );
              if (legend) {
                activeLegends.push(legend);
              } else {
                error.push(fl.name);
              }
            }
          }
        }
        // else {
        //   const legend = this.legendState.legendCache.find(
        //     (l: any) => fl.name === l.layerName);
        //   if (legend) {
        //     activeLegend.push(legend);
        //   } else {
        //     error.push(fl.name);
        //   }
        // }
      }
    }

    // console.log(activeLegend);
    if (error.length > 0) {
      this.store.dispatch(
        new ToastUserNotification({
          type: 'fail',
          title: 'Legend',
          message:
            'There was a problem with the legend for the following layer(s): </br>' +
            error.join('</br>'),
          options: {
            disableTimeOut: true,
            closeButton: true,
            enableHtml: true
          }
        })
      );
    }

    this.store.dispatch(new SetActiveLegendLayers(activeLegends));

    // get basemap legend
    if (this.mapState.basemaps) {
      const activeBasemap = this.mapState.basemaps.find((b: any) => b.selected);
      if (activeBasemap) {
        const mapping = this.basemapLegendMap.filter(
          (m: { basemapName: any }) => m.basemapName === activeBasemap.name
        );
        if (mapping) {
          const basemapLegend = this.bmLegendCache.filter(legend =>
            mapping.some(
              (layer: { legendName: any }) =>
                legend.layerName === layer.legendName
            )
          );
          console.log(basemapLegend);
          this.store.dispatch(new SetActiveBasemapLegends(basemapLegend));
        }
      }
    }
  }

  toggleExport(status: ApplicationStatus): void {
    this.toggleOffDraw();
    this.closePropertyInformation();
    this.resetFeaturesEditing();
    if (status !== ApplicationStatus.Export) {
      this.store.dispatch(new Export());
      this.store.dispatch(new HideFilterPanel());
      this.store.dispatch(new EditFeatureLayerSymbology(null));
    } else {
      this.toIdle(status);
    }

    this.rewriteUrl();
  }

  toggleDraw(status: ApplicationStatus): void {
    this.toggleOffDraw();
    this.closePropertyInformation();
    this.resetFeaturesEditing();
    if (this.drawBtn === 'delete') {
      this.toggleDelete();
    }
    if (status !== ApplicationStatus.Draw) {
      this.store.dispatch(new Draw()); // open panel
      // this.store.dispatch(new AddText(true)); // allow adding text
      this.store.dispatch(new HideFilterPanel());
      this.store.dispatch(new EditFeatureLayerSymbology(null));
    } else {
      this.toIdle(status);
      this.store.dispatch(new AddText(false));
    }

    this.rewriteUrl();
  }

  getToolboxTitleText(): string {
    if (
      this.applicationState.status !== this.ApplicationStatus.Toolbox &&
      this.applicationState.toolboxStatus === ToolboxStatus.PropertyInfo
    ) {
      return 'Property Information is active';
    } else if (
      this.applicationState.toolboxStatus ===
      this.ToolboxStatus.ServiceConnections
    ) {
      return 'Service Connections is active';
    } else if (
      this.applicationState.toolboxStatus === this.ToolboxStatus.MailMerge
    ) {
      return 'Mailing Labels is active';
    } else if (
      this.applicationState.toolboxStatus ===
      this.ToolboxStatus.HistoricalAerials
    ) {
      return 'Historical Aerials is active';
    } else if (
      this.applicationState.toolboxStatus === this.ToolboxStatus.EngDrawing
    ) {
      return 'Engineering Drawings is active';
    } else if (
      this.applicationState.toolboxStatus === this.ToolboxStatus.CCTV
    ) {
      return 'CCTV Inspections is active';
    } else if (
      this.applicationState.toolboxStatus === this.ToolboxStatus.EditFeatures
    ) {
      return 'Edit Features is active';
    } else {
      return 'Toolbox';
    }
  }

  // Toolbox Toggle Handlers

  togglePropertyInfo(): void {
    const turnOnTool =
      this.applicationState.toolboxStatus !== ToolboxStatus.PropertyInfo;
    this.closeActiveTool();
    this.resetFeaturesEditing();
    if (turnOnTool) {
      this.store.dispatch(new SetToolboxStatus(ToolboxStatus.PropertyInfo));
      if (!this.isDesktop) {
        this.toggleToolbox(ApplicationStatus.Toolbox);
      }
      // check if there was a search, then get property info
      if (this.applicationState.search) {
        // address search
        let searchObj: any;
        if (this.applicationState.search.search) {
          searchObj = this.applicationState.search.search.searchedItem;
          if (searchObj && searchObj.type === SearchItemType.Address) {
            this.store.dispatch(
              new GetPropertyByAddress({
                address: searchObj.name,
                dblink: null,
                ltopid: null,
                search: false
              })
            );
          }
          // pid search
          searchObj = (this.applicationState.search.search as any).num;
          if ((this.applicationState.search.search as any).type === 'pid') {
            if (searchObj) {
              this.store.dispatch(new GetPropertyByPID(searchObj.name));
            }
            // folio search
          } else if (
            (this.applicationState.search.search as any).type === 'folio'
          ) {
            if (searchObj) {
              this.store.dispatch(new GetPropertyByFolio(searchObj.name));
            }
          }
        }
      }
    }
  }

  toggleEditFeatures(): void {
    const turnOnTool =
      this.applicationState.toolboxStatus !== ToolboxStatus.EditFeatures;
    this.closeActiveTool();

    if (turnOnTool) {
      this.store.dispatch(new SetToolboxStatus(ToolboxStatus.EditFeatures));
      // this.store.dispatch(new GetEditPermission()); // This is updating the permission everytime the tool is enabled
      // this.store.dispatch(new GetEditRequiredFields());
      // this.store.dispatch(new GetEditReadOnlyFields());
    }
  }

  toggleEngDraw(status: ToolboxStatus, reset: boolean): void {
    const turnOnTool =
      this.applicationState.toolboxStatus !== ToolboxStatus.EngDrawing;
    this.closeActiveTool();
    this.resetFeaturesEditing();
    if (turnOnTool) {
      this.store.dispatch(new SetToolboxStatus(ToolboxStatus.EngDrawing)); // open panel
      if (this.applicationState.windowInnerWidth > 767) {
        this.isDesktop = true;
        this.store.dispatch(
          new DelayedAction([new StartDraw({ shape: 'eng-polygon', guid: '' })])
        );
        this.store.dispatch(new Toolbox());
      } else {
        this.isDesktop = false;
      }
    }
  }

  togglePostingPlans(status: ToolboxStatus, reset: boolean): void {
    const turnOnTool =
      this.applicationState.toolboxStatus !== ToolboxStatus.PostingPlans;
    this.closeActiveTool();
    this.resetFeaturesEditing();
    if (turnOnTool) {
      this.store.dispatch(new SetToolboxStatus(ToolboxStatus.PostingPlans)); // open panel
      if (this.applicationState.windowInnerWidth > 767) {
        this.isDesktop = true;
        this.store.dispatch(
          new DelayedAction([new StartDraw({ shape: 'eng-polygon', guid: '' })])
        );
        this.store.dispatch(new Toolbox());
      } else {
        this.isDesktop = false;
      }
    }
  }

  toggleCCTV(status: ToolboxStatus): void {
    const turnOnTool =
      this.applicationState.toolboxStatus !== ToolboxStatus.CCTV;
    this.closeActiveTool();
    this.resetFeaturesEditing();
    if (turnOnTool) {
      this.store.dispatch(new SetToolboxStatus(ToolboxStatus.CCTV)); // open panel
      if (this.applicationState.windowInnerWidth > 767) {
        this.isDesktop = true;
      } else {
        this.isDesktop = false;
      }
      this.store.dispatch(new CheckLayerDisplay());
    }
  }

  toggleSvcConn(): void {
    const turnOnTool =
      this.applicationState.toolboxStatus !== ToolboxStatus.ServiceConnections;
    this.closeActiveTool();
    this.resetFeaturesEditing();
    if (turnOnTool) {
      this.store.dispatch(
        new SetToolboxStatus(ToolboxStatus.ServiceConnections)
      ); // open panel
      this.store.dispatch(new CheckLayerDisplay());
    }
  }

  toggleMailMerge(): void {
    const turnOnTool =
      this.applicationState.toolboxStatus !== ToolboxStatus.MailMerge;
    this.closeActiveTool();
    this.resetFeaturesEditing();
    if (turnOnTool) {
      this.store.dispatch(new SetToolboxStatus(ToolboxStatus.MailMerge));
    }
  }

  toggleHistoricalAerials(): void {
    const turnOnTool =
      this.applicationState.toolboxStatus !== ToolboxStatus.HistoricalAerials;
    this.closeActiveTool();
    this.resetFeaturesEditing();
    if (turnOnTool) {
      this.store.dispatch(
        new SetToolboxStatus(ToolboxStatus.HistoricalAerials)
      );
      this.store.dispatch(new ToggleHideTilePane(true));
      this.store.dispatch(new AddHistoricalAerials(true));
      // set first historical aerial opacity to 1
      this.store.dispatch(
        new SetHistoricalAerialsOpacity({
          currentIndex: 0,
          currentOpacity: 1,
          nextIndex: null,
          nextOpacity: null
        })
      );
    }
  }

  toggleAssetFinder(): void {
    const turnOnTool =
      this.applicationState.toolboxStatus !== ToolboxStatus.AssetFinder;
    this.closeActiveTool();
    this.resetFeaturesEditing();
    if (turnOnTool) {
      this.store.dispatch(new SetToolboxStatus(ToolboxStatus.AssetFinder));
    }
  }

  togglePopulation(): void {
    const turnOnTool =
      this.applicationState.toolboxStatus !==
      ToolboxStatus.PopulationCalculator;
    this.closeActiveTool();
    this.resetFeaturesEditing();
    this.store.dispatch(new PopulationSelectMode(''));
    // this.store.dispatch(new PopulationSetState({ populationTotal: 0, buildingTotal: 0 }));
    // this.store.dispatch(new SetMeasurements(null));
    this.onPopulationClear();
    if (turnOnTool) {
      this.store.dispatch(
        new SetToolboxStatus(ToolboxStatus.PopulationCalculator)
      );
      this.onPopulationDraw();
    }
  }

  toggleWMRP(): void {
    const turnOnTool =
      this.applicationState.toolboxStatus !== ToolboxStatus.WMRP;
    this.closeActiveTool();
    this.resetFeaturesEditing();
    this.showAnalysisStatus = false;

    if (turnOnTool) {
      this.store.dispatch(new SetToolboxStatus(ToolboxStatus.WMRP));
      this.store.dispatch(new GetWMRPModule());
      this.store.dispatch(new GetMaterialsDictionary());
      this.store.dispatch(new GetTemplateNames());
      this.store.dispatch(new GetExclusionLayerMains());
      this.location.replaceState('/wmrp');
    } else {
      this.location.replaceState('/map');
      // reset layer types when leaving wmrp tool
      for (let layer of this.wmrpLayerState.layers) {
        if (this.type2LayerUids?.includes(layer.uid)) {
          layer.type = 2;
        }
      }
      // clear exclusion layer from editing tool
      this.setFeatureType({
        featureType: '',
        featureLayerId: this.layerState.layers.find(
          layer => layer.uid === 'WMRP_EXCLUSION_LAYERS'
        ).id,
        shape: ''
      });
    }
  }

  toggleWMRPConditions(show: boolean | undefined, idx: number = -1) {
    if (show !== undefined) {
      this.wmrpConditions = show;
    } else {
      this.wmrpConditions = !this.wmrpConditions;
    }

    if (this.wmrpConditions) {
      if (idx > -1) {
        const paramSetId = (this.wmrpForm.get('paramSet') as UntypedFormArray)
          .at(idx)
          .get('paramSetId').value;
        const template = this.templates.filter(t => t.id === paramSetId);
        if (template.length > 0) {
          this.store.dispatch(new GetTemplateParameters(template[0].id));
        }
      } else {
        // get default
        if (this.defaultTemplate) {
          this.store.dispatch(
            new GetTemplateParameters(this.defaultTemplate.id)
          );
        }
      }
    }
  }

  toggleAnalysisStatus(show: boolean | undefined) {
    if (show !== undefined) {
      this.showAnalysisStatus = show;
    } else {
      this.showAnalysisStatus = !this.showAnalysisStatus;
    }

    if (!this.showAnalysisStatus) {
      // stop polling
      this.store.dispatch(new StopAnalysisResultsPolling());
      this.store.dispatch(new HideFilterPanel());
    } else {
      this.store.dispatch(new GetAnalysisDetails());
      // remove schedule layers from 'available'
      const scheduleLayer = this.wmrpState.layers.filter(
        l =>
          l.uid.indexOf('WMRP_SCHEDULE') > -1 && l.type !== LayerType.WmrpLayer
      );
      if (
        scheduleLayer.length > 0 &&
        this.applicationState.toolboxStatus !== ToolboxStatus.WMRP
      ) {
        const newLyr = Object.assign({}, scheduleLayer[0], {
          type: LayerType.WmrpLayer,
          name: 'WMRP Schedule'
        });
        this.store.dispatch(new UpdateLayer(newLyr));
      }
    }
  }

  toggleAnalysisSchedule(
    show: boolean | undefined,
    removeLayers: boolean = false
  ) {
    if (show !== undefined) {
      this.showAnalysisSchedules = show;
    } else {
      this.showAnalysisSchedules = !this.showAnalysisSchedules;
    }

    if (this.showAnalysisSchedules) {
      this.store.dispatch(new ShowExpandParametersBtn(true));
    } else {
      this.toggleAnalysisStatus(true);
      if (this.showAnalysisParameters) {
        this.toggleParamPanel();
      }
      this.store.dispatch(new ShowExpandParametersBtn(false));
      this.store.dispatch(new StopSchedulePolling());
      // reset results
      this.store.dispatch(new SetWmrtResults([]));
      this.closeFeatureInformation();
      this.store.dispatch(new HideFilterPanel());

      if (removeLayers) {
        this.store.dispatch(new SetSelectedReplacementSchedule(null));

        // reset wmrp layers
        const wmrpLyrs = this.layerState.layers.filter(
          lyr => lyr.uid.indexOf('WMRP') > -1 || lyr.uid.indexOf('WRP') > -1
        );
        if (wmrpLyrs?.length > 0) {
          wmrpLyrs.forEach(ly => {
            const resetLayer = Object.assign({}, ly, {
              type: 2
            });
            this.store.dispatch(new UpdateLayer(resetLayer));
          });
        }

        // clear wmrp only layers from map
        const mfl = this.mapState.featureLayers.filter(
          fl => fl.uid?.indexOf('WMRP') === -1 && fl.uid?.indexOf('WRP') === -1
        );
        this.store.dispatch(new SetMapFeatureLayers(mfl));

        this.location.replaceState('/wmrp');

        this.scheduleGuid = '';
        this.analysisGuid = '';
      }
    }
  }

  generateReplacementSchedule() {
    const permit = this.isWMRP('WMRP USER');
    const scheduleParams: WmrpReplacementSchedParam = {
      fmeReference: this.selectedRun.fmeReference,
      analysisValueEnabled: this.replacementSchedForm.get(
        'analysisValueEnabled'
      ).value,
      addressingEnabled: this.replacementSchedForm.get('addressingEnabled')
        .value,
      endOfLifeEnabled: this.replacementSchedForm.get('endOfLifeEnabled').value,
      numBreaksEnabled: this.replacementSchedForm.get('numberOfBreaksEnabled')
        .value,
      exclusionLayerEnabled: this.replacementSchedForm.get(
        'exclusionLayerEnabled'
      ).value,
      replacementMetresPerYear: Number(
        this.replacementSchedForm.get('replacementMetres').value
      ),
      startYear: this.replacementSchedForm.get('startYear').value,
      endYear: this.replacementSchedForm.get('endYear').value
    };

    if (this.replacementSchedForm.status !== 'INVALID' && permit) {
      this.store.dispatch(new GenerateReplacementSchedule(scheduleParams));
      this.replacementSchedForm.reset(this.replacementSchedFormDefaults);
      this.dismiss();
    }

    if (!permit) {
      this.notAuthorizedToast();
    }
  }

  editReplacementSchedule(modal: TemplateRef<any>) {
    // todo: populate form with selected schedule's info

    this.open(modal);
  }

  closeActiveTool(): void {
    if (this.applicationState.windowInnerWidth > 767) {
      this.toggleOffDraw();
    }

    switch (this.applicationState.toolboxStatus) {
      case ToolboxStatus.Idle:
        break;

      case ToolboxStatus.PropertyInfo:
        this.closePropertyInformation();
        this.store.dispatch(new Toolbox());
        this.store.dispatch(new SetToolboxStatus(ToolboxStatus.Idle));
        this.store.dispatch(new ResetGeoJsonProperty());
        break;

      case ToolboxStatus.EditFeatures:
        this.store.dispatch(new SetToolboxStatus(ToolboxStatus.Idle));
        this.store.dispatch(new SetEditFeaturesGeometry({ leafletId: null }));
        this.store.dispatch(new GetEditFeaturesGeometry(null));
        this.store.dispatch(new SetEditFeaturesPermission(null));
        this.store.dispatch(new CheckLayerDisplay());
        break;

      case ToolboxStatus.EngDrawing:
        this.onClearEngSearch('num');
        this.onClearEngSearch('proj');
        // this.toIdle(status);
        if (this.isDesktop) {
          this.toggleOffDraw();
        }
        if (this.applicationState.windowInnerWidth > 767) {
          this.toggleToolbox(ApplicationStatus.Idle);
          this.store.dispatch(new SetToolboxStatus(ToolboxStatus.Idle));
        } else {
          this.drawingSearch = 'EngDrawing';
        }

        if (true) {
          this.store.dispatch(new SetToolboxStatus(ToolboxStatus.Idle));
          this.toggleOffDraw();
        }
        break;

      case ToolboxStatus.PostingPlans:
        this.onClearPPSearch('num');
        if (this.isDesktop) {
          this.toggleOffDraw();
        }
        if (this.applicationState.windowInnerWidth > 767) {
          this.toggleToolbox(ApplicationStatus.Idle);
          this.store.dispatch(new SetToolboxStatus(ToolboxStatus.Idle));
        } else {
          this.drawingSearch = 'PostingPlans';
        }

        if (true) {
          this.store.dispatch(new SetToolboxStatus(ToolboxStatus.Idle));
          this.toggleOffDraw();
        }
        break;

      case ToolboxStatus.CCTV:
        this.toggleToolbox(ApplicationStatus.Idle);
        this.store.dispatch(new SetToolboxStatus(ToolboxStatus.Idle));

        // closes info panel
        this.closeCCTV();
        this.store.dispatch(new CheckLayerDisplay());
        break;

      case ToolboxStatus.ServiceConnections:
        this.resetSVCLayers();
        this.store.dispatch(new Toolbox());
        this.store.dispatch(new SetToolboxStatus(ToolboxStatus.Idle));
        // this.toIdle(this.applicationState.status);
        // this.toggleToolbox(this.applicationState.status);
        this.store.dispatch(new SetPrintSvcConn(null));
        this.store.dispatch(new CheckLayerDisplay());
        break;

      case ToolboxStatus.MailMerge:
        this.store.dispatch(new Toolbox());
        this.store.dispatch(new SetToolboxStatus(ToolboxStatus.Idle));

        let guid = '';

        if (this.toolboxMailMergeState.selectionMethod === 'area') {
          guid = Guid.create().toString();
          this.store.dispatch(new StartDraw({ shape: '', guid: guid }));
          this.store.dispatch(new IsDrawing(false));
        }

        this.store.dispatch(
          new ToolboxMailMerge({
            toolboxMailMergeState: Object.assign(
              {},
              this.toolboxMailMergeState,
              { selectionMethod: 'property' }
            ),
            invalidate: true
          })
        );

        this.store.dispatch(new DelayedAction([new RefreshDisplayedGeoJson()]));
        break;

      case ToolboxStatus.HistoricalAerials:
        this.store.dispatch(new AddHistoricalAerials(false));
        this.store.dispatch(new Toolbox());
        this.store.dispatch(new SetToolboxStatus(ToolboxStatus.Idle));
        this.store.dispatch(new ToggleHideTilePane(false));
        break;

      case ToolboxStatus.WMRP:
      case ToolboxStatus.PopulationCalculator:
      case ToolboxStatus.AssetFinder:
        this.toggleToolbox(ApplicationStatus.Idle);
        this.store.dispatch(new SetToolboxStatus(ToolboxStatus.Idle));
        this.store.dispatch(new CheckLayerDisplay());
        break;

      default:
        break;
    }
  }

  toggleToolbox(status: ApplicationStatus): void {
    if (
      this.applicationState.windowInnerWidth < 767 &&
      this.applicationState.toolboxStatus !== ToolboxStatus.EngDrawing
    ) {
      this.toggleOffDraw();
    }
    if (status !== ApplicationStatus.Toolbox) {
      this.store.dispatch(new Toolbox());
      this.store.dispatch(new HideFilterPanel());
      this.store.dispatch(new EditFeatureLayerSymbology(null));
      // get edit features layers
      this.store.dispatch(new GetEditPermission());
      this.store.dispatch(new GetEditRequiredFields());
      this.store.dispatch(new GetEditReadOnlyFields());
      if (
        this.applicationState.status === ApplicationStatus.Toolbox &&
        this.applicationState.toolboxStatus === ToolboxStatus.WMRP
      ) {
        if (this.showAnalysisStatus) {
          this.store.dispatch(new GetAnalysisDetails());
        }
        if (this.showAnalysisSchedules) {
          this.store.dispatch(
            new GetReplacementSchedules(this.selectedRun.fmeReference)
          );
        }

        let newPath = '/wmrp';
        if (this.analysisGuid && this.analysisGuid.length > 0) {
          newPath = newPath + '/' + this.analysisGuid;
          if (!this.sharedURLLoaded) {
            this.selectRun(this.analysisGuid);
          }
        }

        if (this.scheduleGuid && this.scheduleGuid.length > 0) {
          newPath = newPath + '/' + this.scheduleGuid;
        }
        this.location.replaceState(newPath);
      }
    } else {
      // off
      this.toIdle(status);
      if (this.showAnalysisParameters) {
        this.toggleParamPanel();
      }
      if (this.wmrpConditions) {
        this.toggleWMRPConditions(false);
      }
      this.store.dispatch(new StopAnalysisResultsPolling());
      this.store.dispatch(new StopSchedulePolling());
      this.closeFeatureInformation();
    }
  }

  toIdle(status: ApplicationStatus): void {
    switch (status) {
      // case ApplicationStatus.Idle:
      case ApplicationStatus.Error:
        break;
      default:
        this.store.dispatch(new Idle());
        this.store.dispatch(new ToggleEditShapes(false));
        break;
    }
  }

  layerList(layerState: DnvLayer[]): any {
    const activeFeatureLayers = layerState
      .filter(l => l.type === 0) // Only keep active layers
      .filter(l => this.currentZoomLevel >= l.minZoom) // Show all layer greater than current zoom level
      .map(l => l.featureLayers);
    return activeFeatureLayers.reduce(
      (accumulator, currentValue) => accumulator.concat(currentValue),
      []
    ); // Poor man's FlatMap
  }

  onSelectItem(event: NgbTypeaheadSelectItemEvent): void {
    this.store.dispatch(new SetShowSearchSpinner(true));
    // intersection
    if (event.item.type === 4) {
      this.store.dispatch(new SearchCoordinates(event.item));
    } else if (event.item.type === 5 || event.item.type === 6) {
      // 5 = pid, 6 = folio
      this.store.dispatch(
        new GetDBLink({
          num: event.item,
          type: event.item.type === 5 ? 'pid' : 'folio'
        })
      );

      if (this.applicationState.toolboxStatus === ToolboxStatus.PropertyInfo) {
        this.store.dispatch(new ResetGeoJsonProperty());
        if (event.item.type === 5) {
          // pid
          this.store.dispatch(new GetPropertyByPID(event.item.name));
        }
        if (event.item.type === 6) {
          // folio
          this.store.dispatch(new GetPropertyByFolio(event.item.name));
        }
      }
    } else if (event.item.type === 7) {
      this.store.dispatch(
        new GetEngDrawingGeometry({ searchedItem: event.item, apisUrl: '' })
      );
    } else {
      const search: SearchedInfo = {
        searchedItem: event.item,
        apisUrl: `${this.applicationState.appSettings['environment.searchApiEndpointUrl']}api/geoinfo`
      };

      // search by address
      if (
        event.item.type === 1 &&
        this.applicationState.toolboxStatus === ToolboxStatus.PropertyInfo
      ) {
        this.store.dispatch(
          new GetPropertyByAddress({
            address: event.item.name,
            dblink: '',
            ltopid: '',
            search: true
          })
        );
        this.store.dispatch(new SetSelectedProperty(''));
      } else {
        // this returns a different shape than property info
        this.store.dispatch(new Search({ search }));
      }
    }
  }

  onSelectEng(event: NgbTypeaheadSelectItemEvent): void {
    if (event.item.name !== 'no results') {
      if (event.item.assetId === 'name') {
        this.store.dispatch(new SearchEngineerDrawingsByProj(event.item.name));
      } else {
        this.store.dispatch(new SearchEngineerDrawingsByNum(event.item.name));
      }
    }
  }

  onSelectPP(event: NgbTypeaheadSelectItemEvent): void {
    if (event.item.name !== 'no results') {
      if (event.item.assetId === 'name') {
        //  this.store.dispatch(new SearchEngineerDrawingsByProj(event.item.name));
      } else {
        this.store.dispatch(new SearchPostingPlansByNum(event.item.name));
      }
    }
  }

  onSelectAsset(event: NgbTypeaheadSelectItemEvent): void {
    if (!this.isDesktop) {
      this.toggleToolbox(ApplicationStatus.Toolbox);
    }
    const assetId = event.item.assetId;
    const firstNumPos = assetId.search(/\d/);
    const prefix = assetId.substr(0, firstNumPos);
    let featureLayer: DnvFeatureLayer = {} as DnvFeatureLayer;
    const layer = this.layerState.layers.filter(l => {
      return l.featureLayers.some(f => {
        // using event.item.featureLayerId because some featureLayers have same prefix, ie stmfit, see GT-653
        if (f.featureLayerId === event.item.featureLayerId) {
          featureLayer = f;
          return f;
        }
      });
    });

    this.store.dispatch(
      new SearchAsset({ assetId, featureLayerId: event.item.featureLayerId })
    );
    this.store.dispatch(new SetRelatedRecords([]));
    this.store.dispatch(new CheckLayerDisplay());
    this.store.dispatch(
      new GetFeatureData({
        featureUrl:
          `${this.configService.webApiEndpoint
          }getFeatureData?url=${featureLayer.url +
          encodeURIComponent(
            '/query?f=json&outFields=*&returnGeometry=true&outSR=4326&where=' +
            featureLayer.assetField +
            "='"
          ) +
          assetId}` + "'",
        url: featureLayer.url
      })
    );
    this.store.dispatch(
      new GetCoordsByAssetId({
        url: featureLayer.url,
        assetId,
        assetField: featureLayer.assetField
      })
    );
    this.store.dispatch(
      new FeatureClicked({
        url: featureLayer.url,
        objectId: event.item.id,
        writeUrl: featureLayer.writeUrl,
        // tableLayers: tableLayers,
        assetId: event.item.assetId
        // excludeFeatureInfo: data.mapState.excludeFeatureInfo
      })
    );
  }

  // MapView handlers
  openMapViewDialog(): void {
    this.mapViewComponent.openMapViewDialog();
  }

  mapViewUpdate(event: MapViewAction): void {
    this.store.dispatch(event);
  }
  // mapViewName(event: string): void {
  //   this.mapViewViewName = event;
  //   // this.changeDetector.markForCheck();
  //   // constructor
  //   // this.cd.detectChanges();
  //   this.zone.run(() => this.changeDetector.markForCheck());
  // }

  // checkDirtyView() {
  //   if (this._mapViewState.isDirty && this._mapViewState.loadedMapViewId > -1 && !this.isDialogOpen) {
  //     this.confirmDirtyViewSave();
  //     this.isDialogOpen = true;
  //   } else {
  //     if (!this.isDialogOpen) {
  //       this.openMapViewDialog();
  //     }
  //   }
  // }

  // confirmDirtyViewSave(): void {
  //   let dialogWidth = '510px';
  //   // if (this._applicationState.windowInnerWidth <= 767) {
  //   //   dialogWidth = '90vw';
  //   // }

  //   // const dialogRef = this.dialog.open(ConfirmDialogComponent, {
  //   //   width: dialogWidth,
  //   //   data: {
  // tslint:disable-next-line: max-line-length
  //   //     message: "Do you want to save changes to \"<strong>" + currentMapView(this._mapViewState).bookmarkName + "</strong>\" before loading the new map view?",
  //   //     title: "Save Changes Before Loading?"
  //   //   }
  //   // });
  //   // dialogRef.afterClosed().subscribe(result => {
  //   //   this.isDialogOpen = false;
  //   //   if (result) {
  //   //     this.mapViewComponent.save();
  //   //   } else {
  //   //     this.openMapViewDialog();
  //   //   }
  //   // });
  // }

  onKeyDown(evt: any): void {
    evt.stopPropagation();
  }

  onBlur(): void {
    const locString = this.searchForm.get('addressSearch')?.value;
    if (typeof locString === 'string' && '' !== locString) {
      this.searchForm
        .get('addressSearch')!
        .setValue({ name: locString, id: 0, type: '' });
    }
  }

  getClass(type: number): string {
    let result = this.defaultIcon;
    if (this.dnvSearchState.icons) {
      const icon = this.dnvSearchState.icons.find(
        (x: { id: number }) => x.id === type
      );
      if (icon) {
        result = icon.fontAwesome;
      }
    }
    return result;
  }

  checkTrailType(type: number): string {
    if (type === SearchItemType.NonPublicTrail) {
      return ' (UNOFFICIAL)';
    }
    return '';
  }

  // gridSelectLayer(featureLayer: DnvFeatureLayer): void {
  //   // console.log(layer);
  //   this.store.dispatch(new GridSelectLayer({ dnvFeatureLayer: featureLayer }));
  //   // delayed because if only one layer, panel stops half way as it's sliding up
  //   // this.store.dispatch(
  //   //   new DelayedActionBy1([
  //   //     new GridSelectLayer({ dnvFeatureLayer: layer })
  //   //   ])
  //   // );
  // }
  gridViewUpdate(action: Action): void {
    this.store.dispatch(action);
  }

  onClearClicked(): void {
    this.searchForm.get('addressSearch')!.setValue('');
    // this.store.dispatch(new SetMapGeoJsonLayers([]));
    this.store.dispatch(new SearchReset());
    this.store.dispatch(new SetMarkers([])); // To be investigated
  }

  onClearSearch(evt: any): void {
    const searchVal = evt.target.value;
    if (searchVal.length === 0) {
      // this.store.dispatch(new SetMapGeoJsonLayers([])); //should not dispatch this action
      this.store.dispatch(new SearchReset());
    }
  }

  onClearEngSearch(field: string): void {
    if (field === 'num') {
      this.engSearchForm.get('engDrawSearchNum')!.setValue('');
    } else {
      this.engSearchForm.get('engDrawSearchProj')!.setValue('');
    }
  }

  onClearPPSearch(field: string): void {
    if (field === 'num') {
      this.ppSearchForm.get('ppSearchNum')!.setValue('');
    }
  }

  onClearCCTVSearch(): void {
    this.cctvSearchForm.get('cctvSearch')!.setValue('SANMN');
  }

  onClearAssetSearch(): void {
    this.assetSearchForm.get('assetSearch')!.setValue('');
    this.closeFeatureInformation();
  }

  onToggleExpand(lyr: DnvLayer): void {
    this.store.dispatch(new ToggleExpand(lyr));
    if (
      this.applicationState.status === ApplicationStatus.Toolbox &&
      this.applicationState.toolboxStatus === ToolboxStatus.WMRP
    ) {
      if (lyr.uid.indexOf('WMRP') === -1 || lyr.uid.indexOf('WRP') === -1) {
        this.store.dispatch(new ToggleWMRPLayer(lyr));
      }
    }
  }

  onHideLayer(payload: FeatureLayerVisibilityPayload): void {
    if (
      this.applicationState.status === ApplicationStatus.Toolbox &&
      this.applicationState.toolboxStatus === ToolboxStatus.WMRP
    ) {
      this.store.dispatch(new SetWMRPLayerFeatureVisible(payload));
    }
    // else {
    this.store.dispatch(new SetLayerFeatureVisible(payload));
    // }

    this.store.dispatch(new CheckLayerDisplay());
    this.store.dispatch(
      new MapViewCheckIsDirty({
        urlProvider: this.appUrlProvider,
        storeWrapper: this.appStoreWrapper
      })
    );
    // reapply opacity
    if (this.layerOpacity < 1) {
      this.store.dispatch(new SetFeatureLayersOpacity(this.layerOpacity));
    }
  }
  onHideFeatureLayer(payload: FeatureLayerVisibilityPayload): void {
    this.onHideLayer(payload); // steps are identical in both case
    // this.store.dispatch(new SetLayerFeatureVisible(payload));
    // this.store.dispatch(new CheckLayerDisplay());
  }

  // onHideFeatureLayer(payload: ToggleVisiblePayload): void {
  //   this.store.dispatch(new SetFeatureLayerVisible(payload));
  // }

  // setLayerFeatures(action: Action): void {
  //   this.store.dispatch(action);
  // }

  onMetadataClick(layerInfo: LayerInfo): void {
    let featureLayer = this.mapState.featureLayers.find(
      fl => fl.name?.toLowerCase() === layerInfo.layerName.toLowerCase()
    );
    if (
      !featureLayer &&
      layerInfo.layerName.toLowerCase().indexOf('merged scores') > -1
    ) {
      featureLayer = this.mapState.featureLayers.find(
        fl => fl.name!.toLowerCase().indexOf('merged scores') > -1
      );
    }
    this.store.dispatch(new GetDataNames(featureLayer?.featureLayerId));
    if (this.currentLayerInfo === undefined) {
      this.store.dispatch(new ToggleMetaDataPanel());
    }
    this.currentLayerInfo = layerInfo;
  }

  hideMetaData(): void {
    this.store.dispatch(new ToggleMetaDataPanel());
    this.store.dispatch(new SetMetaData(null));
    this.currentLayerInfo = undefined; 
  }

  highlightFeature(evt: { url: string; objectId: number }): void {
    if (evt) {
      this.store.dispatch(new GetCoordsByObjectId(evt));
    } else {
      if (!this.mapState.selectedFeature) {
        this.store.dispatch(new SetFeatureRasterHighlight({}));
        this.store.dispatch(new DelayedAction([new RefreshDisplayedGeoJson()]));
      }
    }
  }

  closeFeatureInformation(): void {
    this.store.dispatch(new SetSurroundingFeatureList(null));
    this.store.dispatch(new SelectFeature(null));
    this.store.dispatch(new SetSurroundingFeature(false));

    // reset raster highlight
    this.store.dispatch(new SetFeatureRasterHighlight({}));
    this.store.dispatch(new DelayedAction([new RefreshDisplayedGeoJson()]));

    // clears asset finder search field
    this.assetSearchForm.get('assetSearch')?.reset();
  }

  closePropertyInformation(): void {
    this.store.dispatch(new SetPropertyInfo([]));
    this.store.dispatch(new ResetGeoJsonProperty());
    this.store.dispatch(new SetPropertiesDbLinks([]));
    this.store.dispatch(new SetSelectedProperty(''));
  }

  closeServiceConnections(): void {
    this.store.dispatch(new SetPrintSvcConn(''));
    this.store.dispatch(new ResetGeoJsonProperty());
    // reset highlight
    this.store.dispatch(new SetFeatureRasterHighlight({}));
    this.store.dispatch(new DelayedAction([new RefreshDisplayedGeoJson()]));
    this.prevConn = { name: '', objectId: 0 };
  }

  // from edit-features.component setFeatureDetails emitter
  selectEditFeature(evt: {
    objectId: string;
    url: string;
    writeUrl: string;
    allowInsp: boolean;
    featureId: number;
    assetId: string;
  }): void {
    if (evt == null) {
      this.store.dispatch(new SelectFeature(null));
      this.store.dispatch(new SetEditFeaturesGeometry({ leafletId: null }));
      this.store.dispatch(new GetEditFeaturesGeometry(null));
      this.store.dispatch(new SetEditFeaturesPermission(null));
      this.store.dispatch(new CheckLayerDisplay());
      // reset raster highlight
      this.store.dispatch(new SetFeatureRasterHighlight({}));
      this.store.dispatch(new DelayedAction([new RefreshDisplayedGeoJson()]));
    } else {
      this.store.dispatch(new SetSurroundingFeature(true));
      this.store.dispatch(new SetRelatedRecords(null));
      this.store.dispatch(
        new GetFeatureData({
          featureUrl: `${this.configService.webApiEndpoint
            }getFeatureData?url=${evt.url +
            encodeURIComponent(
              '/query?f=json&outFields=*&returnGeometry=true&outSR=4326&objectIds='
            ) +
            evt.objectId}`,
          url: evt.url
        })
      );

      this.store.dispatch(
        new SetSelectedFeatureLayer({
          url: evt.url,
          allow_inspections: false,
          writeUrl: evt.writeUrl
        })
      );
      this.store.dispatch(
        new FeatureClicked({
          url: evt.url,
          objectId: evt.objectId,
          writeUrl: evt.writeUrl,
          // tableLayers: tableLayers,
          assetId: evt.assetId
          // excludeFeatureInfo: data.mapState.excludeFeatureInfo
        })
      );

      // highlight selected
      this.store.dispatch(
        new GetCoordsByObjectId({ url: evt.url, objectId: evt.objectId })
      );
      this.store.dispatch(new GetEditFeaturesGeometry(Number(evt.objectId)));
    }
  }

  onSelectFeatureEmit(evt: {
    objectId: string;
    url: string;
    writeUrl: string;
    allowInsp: boolean;
    featureId: number;
    assetId: string;
  }) {
    if (evt) {
      this.selectEditFeature(evt);
    } else {
      this.resetEditFeature();
    }
  }

  resetEditFeature() {
    this.store.dispatch(new SelectFeature(null));
    this.store.dispatch(new SetEditFeaturesGeometry({ leafletId: null }));
    this.store.dispatch(new GetEditFeaturesGeometry(null));
    this.store.dispatch(new RevertFeatureGeometry(true));

    // reset raster highlight
    this.store.dispatch(new SetFeatureRasterHighlight({}));
    this.store.dispatch(new DelayedAction([new RefreshDisplayedGeoJson()]));
  }

  dismiss(): void {
    if (this.modal) {
      this.modal.dismiss();
    }
  }

  open(modal: TemplateRef<any>): void {
    const modalOptions: NgbModalOptions = {
      beforeDismiss: () => {
        setTimeout(() => {
          this.store.dispatch(new SetLayerInfo(''));
        }, 1000);
        return true;
      }
    };
    this.modal = this.modalService.open(modal, modalOptions);
  }

  openSchedule(modal: TemplateRef<any>): void {
    const modalOptions: NgbModalOptions = {
      beforeDismiss: () => {
        setTimeout(() => {
          this.store.dispatch(new SetLayerInfo(''));
        }, 1000);
        return true;
      },
      windowClass: 'schedule-modal'
    };
    this.modal = this.modalService.open(modal, modalOptions);
  }

  openWMRP(modal: TemplateRef<any>): void {
    this.modal = this.modalService.open(modal);
  }

  openWMRPTitle(
    modal: TemplateRef<any>,
    fmeJobId: number,
    title: string,
    type: string
  ): void {
    if (type !== undefined) {
      this.selectedAnalysisType = type;
    }
    if (type.toLowerCase() === 'analysis') {
      this.selectedAnalysisJobId = fmeJobId;
    } else {
      this.selectedScheduleJobId = fmeJobId;
    }

    if (title?.length > 0) {
      this.analysisTitleForm.get('analysisTitle')?.setValue(title);
    } else {
      this.analysisTitleForm.get('analysisTitle')?.setValue('');
    }
    this.modal = this.modalService.open(modal);
  }

  confirmDeleteAnalysisRun(fmeJobId: number, modal: TemplateRef<any>) {
    this.selectedAnalysisJobId = fmeJobId;
    this.scheduleCount = this.wmrpState.recentAnalysisRunData.filter(
      r => r.fmeJobId === fmeJobId.toString()
    )[0]?.schedulesCount;
    this.modal = this.modalService.open(modal);
  }

  deleteAnalysisRun() {
    this.store.dispatch(new DeleteAnalysisRun(this.selectedAnalysisJobId));
    this.modal.dismiss();
    this.selectedAnalysisJobId = 0;
  }

  confirmDeleteScheduleRun(fmeJobId: number, modal: TemplateRef<any>) {
    this.selectedScheduleJobId = fmeJobId;
    this.modal = this.modalService.open(modal);
  }

  deleteScheduleRun() {
    const currentSchedule = this.wmrpState.replacementSchedules.filter(rs => rs.fmeJobId === this.selectedScheduleJobId.toString());
    if (currentSchedule.length > 0) {
      const analsyisFmeRef = this.wmrpRecentAnalyses.filter(ar => ar.fmeReference === currentSchedule[0].fmeReference_Job);
      this.store.dispatch(new DeleteSchedule({ jobId: this.selectedScheduleJobId, fmeJobRef: analsyisFmeRef[0].fmeReference }));
    }

    this.modal.dismiss();
    this.selectedScheduleJobId = 0;
  }

  generateColors(): any {
    const colors = [];
    const result = [];
    const vals = ['00', '33', '66', '99', 'cc', 'ff'];
    let color = '';
    for (const val1 of vals) {
      for (const val2 of vals) {
        for (const val3 of vals) {
          color = '#' + val1 + val2 + val3;
          colors.push(color);
        }
      }
    }

    while (colors.length) {
      result.push(colors.splice(0, 6));
    }
    return result;
  }

  // when user uses swatch picker
  changeComplete(evt: any): void {
    // console.log(evt);
    this.selectedColor = evt.data.hex;
    this.changeColor(this.selectedColor);
  }

  onSwatchHover(evt: any): void {
    // console.log(evt);
    this.color = evt.hex;
  }

  // for when user types in color
  setColor(evt: any): any {
    // console.log(evt);
    if (evt.currentTarget.value.length === 0) {
      this.selectedColor = '#000000';
      evt.currentTarget.value = '#000000';
    } else {
      this.selectedColor = evt.currentTarget.value;
    }
    this.changeColor(this.selectedColor);
  }

  openSwatches(obj: any): void {
    obj.open();
  }

  changeColor(color: string): void {
    if (
      this.drawBtn === 'addText' ||
      this.editingShape === 'addText' ||
      this.drawBtn === 'labelmarker' ||
      this.editingShape === 'labelmarker'
    ) {
      this.store.dispatch(
        new DelayedAction([
          new UpdateShapeFeatureStyle({ color: this.selectedColor })
        ])
      );
      this.store.dispatch(new SetTextStyle({ color: this.selectedColor }));
      this.updateTextStyle({ color: this.selectedColor });
      this.store.dispatch(
        new SetAllTextStyle({
          ...this.mapState.textStyle,
          color: this.selectedColor
        })
      );
    } else {
      const activeShape = this.getActiveFeature();
      if (activeShape.length > 0) {
        this.store.dispatch(
          new UpdateShapeFeatureColor({ color: this.selectedColor })
        );
        this.store.dispatch(new MapViewMarkDirty());
      }
    }
    this.store.dispatch(new UpdateShapeOutlineColour(this.selectedColor));
  }

  getSize(min: number, max: number): number[] {
    const sizes = [];
    for (let i = min; i <= max; i = i + 1) {
      sizes.push(i);
    }
    return sizes;
  }

  setFontSize(evt: any): void {
    this.store.dispatch(
      new SetTextStyle({ fontSize: evt.currentTarget.value })
    );
    this.store.dispatch(
      new UpdateShapeFeatureStyle({ fontSize: evt.currentTarget.value })
    );
    //this.store.dispatch(new DelayedAction([new UpdateShapeFeatureStyle({ fontSize: evt.currentTarget.value })]));
    const selectedText = this.getSelectedTextMarkup();
    if (selectedText && selectedText.length > 0) {
      this.store.dispatch(
        new UpdateFeatureStyle({
          leafletId: selectedText[0].leafletId ?? 0,
          style: { ...selectedText[0].style, fontSize: evt.currentTarget.value }
        })
      );
    }
  }

  setFontFace(evt: any): void {
    let font = evt.currentTarget.value;
    //this.store.dispatch(new UpdateShapeFeatureStyle({ font: evt.currentTarget.value }));
    this.store.dispatch(
      new DelayedAction([new UpdateShapeFeatureStyle({ font: font })])
    );
    this.store.dispatch(new SetTextStyle({ fontFace: font }));

    const selectedText = this.getSelectedTextMarkup();
    if (selectedText && selectedText.length > 0) {
      this.store.dispatch(
        new UpdateFeatureStyle({
          leafletId: selectedText[0].leafletId ?? 0,
          style: { ...selectedText[0].style, fontFace: evt.currentTarget.value }
        })
      );
    }
  }

  getSliderValue(): void {
    this.store.dispatch(
      new SetTextStyle({ rotation: this.sliderControl.value })
    );
    //this.store.dispatch(new UpdateShapeFeatureStyle({ rotate: this.sliderControl.value }));
    this.store.dispatch(
      new DelayedAction([
        new UpdateShapeFeatureStyle({ rotate: this.sliderControl.value })
      ])
    );
    // console.log(this.sliderControl.value);
    const selectedText = this.getSelectedTextMarkup();
    if (selectedText && selectedText.length > 0) {
      this.store.dispatch(
        new UpdateFeatureStyle({
          leafletId: selectedText[0].leafletId ?? 0,
          style: {
            ...selectedText[0].style,
            rotation: this.sliderControl.value
          }
        })
      );
    }
  }

  toggleAddText(): void {
    if (this.drawBtn === 'addText') {
      this.store.dispatch(new AddText(false));
      this.drawBtn = 'cancel';
    } else {
      this.color = this.selectedColor;
      this.store.dispatch(
        new SetAllTextStyle({
          ...this.mapState.textStyle,
          color: this.selectedColor
        })
      );
      this.store.dispatch(new AddText(true));
      this.drawBtn = 'addText';
    }

    // cancels other drawing tools
    this.store.dispatch(new StartDraw({ shape: 'cancel', guid: '' }));
  }

  editText(evt: any): void {
    this.editingShape = 'addText';
  }

  moveText(): void {
    this.editingShape = 'addText';
  }

  createPdf(): void {
    this.dnvMap.getPngBlob(blob => {
      this.printService.createPdf(blob);
    });
  }

  toggleAddLabel(): void {
    if (this.drawBtn === 'labelmarker') {
      this.toggleOffDraw();
    } else {
      this.store.dispatch(new StartDraw({ shape: 'labelmarker', guid: '' }));
      this.store.dispatch(
        new DelayedAction([
          new UpdateShapeFeatureStyle({ color: this.selectedColor })
        ])
      );
      this.store.dispatch(new SetTextStyle({ color: this.selectedColor }));
      this.updateTextStyle({ color: this.selectedColor });
      this.store.dispatch(
        new SetAllTextStyle({
          ...this.mapState.textStyle,
          color: this.selectedColor
        })
      );
      this.drawBtn = 'labelmarker';
      this.onSetMeasurements({ leafletId: 0, measurements: null });
    }
    this.resetDrawEdit();
  }

  toggleDrawline(): void {
    if (this.drawBtn === 'line') {
      this.toggleOffDraw();
    } else {
      this.store.dispatch(new StartDraw({ shape: 'line', guid: '' }));
      this.setLineStyle(this.mapState.lineStyle);
      this.drawBtn = 'line';
      this.onSetMeasurements({ leafletId: 0, measurements: null });
    }
    this.store.dispatch(new UpdateLabelMarkerText(''));
    this.resetDrawEdit();
  }

  togglePolygon(): void {
    if (this.drawBtn === 'polygon') {
      this.toggleOffDraw();
    } else {
      this.store.dispatch(new StartDraw({ shape: 'polygon', guid: '' }));
      this.drawBtn = 'polygon';
      this.onSetMeasurements({ leafletId: 0, measurements: null });
    }
    this.store.dispatch(new UpdateLabelMarkerText(''));
    this.resetDrawEdit();
  }

  toggleMarker(): void {
    if (this.drawBtn === 'marker') {
      this.toggleOffDraw();
    } else {
      this.store.dispatch(new StartDraw({ shape: 'marker', guid: '' }));
      this.drawBtn = 'marker';
      this.onSetMeasurements({ leafletId: 0, measurements: null });
    }
    this.store.dispatch(new UpdateLabelMarkerText(''));
    this.resetDrawEdit();
  }

  toggleCircle(): void {
    if (this.drawBtn === 'circle') {
      this.toggleOffDraw();
    } else {
      const radius = this.circleRadius.value;
      this.store.dispatch(
        new StartDraw({
          shape: 'circleRadius',
          guid: '',
          radius: radius !== '' ? radius : 0
        })
      );
      this.drawBtn = 'circle';
      this.onSetMeasurements({ leafletId: 0, measurements: null });
    }
    this.store.dispatch(new UpdateLabelMarkerText(''));
    this.resetDrawEdit();
  }

  toggleRect(): void {
    if (this.drawBtn === 'delete') {
      this.toggleDelete();
    }
    if (this.drawBtn === 'eng-polygon') {
      this.toggleOffDraw();
    } else {
      if (!this.isDesktop) {
        this.toggleToolbox(ApplicationStatus.Toolbox);
      }
      this.store.dispatch(
        new DelayedAction([new StartDraw({ shape: 'eng-polygon', guid: '' })])
      );
      this.drawBtn = 'eng-polygon';
      if (this.applicationState.toolboxStatus === ToolboxStatus.EngDrawing) {
        this.toggleEngDraw(ToolboxStatus.EngDrawing, false);
      } else {
        this.togglePostingPlans(ToolboxStatus.PostingPlans, false);
      }
      this.onSetMeasurements({ leafletId: 0, measurements: null });
    }
    this.store.dispatch(new AddText(false));
  }

  toggleDelete(): void {
    // this.toggleOffDraw();
    if (this.drawBtn === 'delete') {
      this.store.dispatch(new StartDraw({ shape: 'deleteoff', guid: '' }));
      this.drawBtn = 'cancel';
      this.store.dispatch(new IsDrawing(false));
    } else {
      this.store.dispatch(new IsDrawing(true));
      this.store.dispatch(new StartDraw({ shape: 'delete', guid: '' }));
      this.drawBtn = 'delete';
    }
  }

  toggleOffDraw(): void {
    this.store.dispatch(new StartDraw({ shape: 'cancel', guid: '' }));
    this.store.dispatch(new IsDrawing(false));
    this.store.dispatch(new AddText(false));
    this.drawBtn = 'cancel';
    this.closePropertyInformation();
  }

  updateCircleRadius(): void {
    const radius = Number(this.circleRadius.value);
    if (radius > 0) {
      this.store.dispatch(new UpdateStartDrawCircle(radius));
    } else {
      // freeform
      this.store.dispatch(new UpdateStartDrawCircle(0));
    }
    this.store.dispatch(new UpdateCircleRadius(radius));
  }

  labelTextChanged(event: any) {
    this.store.dispatch(new UpdateLabelMarkerText(event.target.value));
    this.store.dispatch(
      new DelayedAction([
        new UpdateShapeFeatureStyle({ text: event.target.value }),
        new MapViewMarkDirty()
      ])
    );
  }

  toggleMeasureLabel(event: any): void {
    this.store.dispatch(new UpdateShowMeasure(event.target.checked));
    this.store.dispatch(
      new DelayedAction([
        new UpdateShapeFeatureStyle({ showMeasure: event.target.checked }),
        new MapViewMarkDirty()
      ])
    );
  }

  changeMeasureLinearUnit(unit: MeasurementUnit): void {
    this.store.dispatch(new UpdateLinearMeasure(unit));
    this.store.dispatch(
      new DelayedAction([
        new UpdateShapeFeatureStyle({
          lengthUnit: unit.unit,
          lengthScaleFactor: unit.factor,
          lengthFixed: unit.fixed
        }),
        new MapViewMarkDirty()
      ])
    );
  }

  changeMeasureAreaUnit(unit: MeasurementUnit): void {
    this.store.dispatch(new UpdateAreaMeasure(unit));
    this.store.dispatch(
      new DelayedAction([
        new UpdateShapeFeatureStyle({
          areaUnit: unit.unit,
          areaScaleFactor: unit.factor,
          areaFixed: unit.fixed
        }),
        new MapViewMarkDirty()
      ])
    );
  }

  setUseUtm(useUTM: boolean): void {
    this.store.dispatch(new UpdateUtmMeasure(useUTM));
    this.store.dispatch(
      new DelayedAction([
        new UpdateShapeFeatureStyle({ useUTM: useUTM }),
        new MapViewMarkDirty()
      ])
    );
  }

  searchEngDrawings(latlngs: DnvLatLng[]): void {
    if (this.isDesktop) {
      this.store.dispatch(
        new DelayedAction([new StartDraw({ shape: 'eng-polygon', guid: '' })])
      );
    }

    if (
      this.drawingSearch === 'EngDrawing' ||
      this.applicationState.toolboxStatus === ToolboxStatus.EngDrawing
    ) {
      this.store.dispatch(new SearchEngineerDrawings(latlngs));
    } else if (
      this.drawingSearch === 'PostingPlans' ||
      this.applicationState.toolboxStatus === ToolboxStatus.PostingPlans
    ) {
      this.store.dispatch(new SearchPostingPlans(latlngs));
    }
  }

  searchEng(): void {
    this.searchingNum = false;
    this.searchingProj = false;
    const searchNum = this.engSearchForm.get('engDrawSearchNum')!.value.name
      ? this.engSearchForm.get('engDrawSearchNum')!.value.name
      : this.engSearchForm.get('engDrawSearchNum')!.value;
    const searchProj = this.engSearchForm.get('engDrawSearchProj')!.value.name
      ? this.engSearchForm.get('engDrawSearchProj')!.value.name
      : this.engSearchForm.get('engDrawSearchProj')!.value;
    if (searchNum.length > 0) {
      this.store.dispatch(new SearchEngineerDrawingsByNum(searchNum));
    }
    if (searchProj.length > 0) {
      this.store.dispatch(new SearchEngineerDrawingsByProj(searchProj));
    }
  }

  searchPPNum(): void {
    const searchNum = this.ppSearchForm.get('ppSearchNum')!.value.name
      ? this.ppSearchForm.get('ppSearchNum')!.value.name
      : this.ppSearchForm.get('ppSearchNum')!.value;

    if (searchNum.length > 0) {
      this.store.dispatch(new SearchPostingPlansByNum(searchNum));
    }
  }

  searchCCTV(): void {
    let assetId = this.cctvSearchForm.get('cctvSearch')!.value;
    if (assetId.indexOf(',') > -1) {
      const tmpArr = assetId.split(',');
      const assetIdList = tmpArr.map((t: string) => "'" + t + "'");
      assetId = assetIdList.join(',');
    }
    this.store.dispatch(new SearchCCTV(assetId));

    let featureLayer: DnvFeatureLayer = {} as DnvFeatureLayer;
    const layer = this.layerState.layers.filter((l: any) => {
      return l.featureLayers.some((f: any) => {
        if (f.uid === 'View_CCTVSanMain') {
          featureLayer = f;
          return f;
        }
      });
    });
    if (featureLayer && featureLayer.url) {
      this.store.dispatch(
        new GetCoordsByAssetId({
          url: featureLayer.url,
          assetId,
          assetField: `${this.appSettings['appConfig.gisdb']}SDE_ADMIN.SanMain.Asset_Id`
        })
      );
    }
  }

  onSetOpacity(e: any): void {
    this.store.dispatch(new SetFeatureLayersOpacity(e));
    this.layerOpacity = e;
  }

  setLineStyle(lineStyle: string): void {
    // const lineStyle = evt.target.value;
    this.store.dispatch(new SetLineStyle(lineStyle));
    const activeShape = this.getActiveFeature();
    if (activeShape.length > 0) {
      this.store.dispatch(new UpdateFeatureLineStyle({ lineStyle }));
      this.store.dispatch(new MapViewMarkDirty());
    }
  }

  setMarker(markerShape: string): void {
    const activeShape = this.getActiveFeature();
    if (activeShape.length > 0) {
      this.store.dispatch(new UpdateShapeFeatureMarker({ markerShape }));
      this.store.dispatch(new MapViewMarkDirty());
    }

    this.store.dispatch(new UpdateMarkerShape(markerShape));
  }

  changePattern(pattern: string): void {
    this.store.dispatch(new SetFillPattern(pattern));
    const activeShape = this.getActiveFeature();
    if (activeShape.length > 0) {
      this.store.dispatch(new UpdateShapeFillPattern({ pattern }));
      this.store.dispatch(new MapViewMarkDirty());
    }
  }

  toggleEdit(): void {
    this.store.dispatch(new ToggleEditShapes(this.drawBtn !== 'edit'));
    this.store.dispatch(new StartDraw({ shape: 'cancel', guid: '' }));
    this.store.dispatch(new AddText(false));
    this.store.dispatch(new IsDrawing(false));
    if (this.mapState.editShapes) {
      this.drawBtn = 'edit';
    } else {
      this.drawBtn = 'cancel';
      this.editingShape = '';
    }
  }

  onShapeClick(evt: any): void {
    this.editingShape = evt.shape;

    if (this.applicationState.status === this.ApplicationStatus.Draw) {
      if (evt.shapeStyle) {
        this.store.dispatch(new UpdateShapeOutlineColour(evt.shapeStyle.color));
        this.store.dispatch(new UpdateShowMeasure(evt.shapeStyle.showMeasure));
        if (evt.shape === 'circle') {
          this.store.dispatch(new SetFillPattern(evt.shapeStyle.pattern));
          this.store.dispatch(new UpdateCircleRadius(0));
        } else if (evt.shape === 'marker') {
          this.store.dispatch(
            new UpdateMarkerShape(evt.shapeStyle.markerShape)
          );
          this.store.dispatch(new UpdateUtmMeasure(evt.shapeStyle.useUTM));
        } else if (evt.shape === 'LineString') {
          this.store.dispatch(new SetLineStyle(evt.shapeStyle.lineStyle));
          this.store.dispatch(
            new UpdateLinearMeasure(
              MeasurementUnits.GetUnit(evt.shapeStyle.lengthUnit) ??
              this.mapState.defaultLinearUnit
            )
          );
        } else if (evt.shape === 'Polygon') {
          this.store.dispatch(new SetFillPattern(evt.shapeStyle.pattern));
          this.store.dispatch(
            new UpdateAreaMeasure(
              MeasurementUnits.GetUnit(evt.shapeStyle.areaUnit) ??
              this.mapState.defaultAreaUnit
            )
          );
        } else if (evt.shape === 'labelmarker') {
          this.store.dispatch(
            new DelayedAction([new UpdateLabelMarkerText(evt.shapeStyle.text)])
          );
          this.store.dispatch(
            new DelayedAction([new UpdateShapeFeatureStyle(evt.shapeStyle)])
          );
          this.store.dispatch(
            new DelayedAction([
              new SetAllTextStyle({
                fontFace: evt.shapeStyle.font,
                fontSize: evt.shapeStyle.fontSize,
                color: evt.shapeStyle.color,
                rotation: evt.shapeStyle.rotate
              })
            ])
          );
          // this.store.dispatch(new UpdateShapeFeatureStyle(evt.shapeStyle));
        }

        if (evt.shapeStyle.lineWeight) {
          this.store.dispatch(new SetLineWeight(evt.shapeStyle.lineWeight));
        }

        if (evt.shapeStyle.markerSize) {
          this.store.dispatch(new SetMarkerSize(evt.shapeStyle.markerSize));
        }
      }
    }
  }

  onCoordinatesEmit(evt: any): void {
    if (this.applicationState.toolboxStatus === ToolboxStatus.PropertyInfo) {
      this.store.dispatch(new GetPropertyByXY(evt));
      this.store.dispatch(new SetSelectedProperty(''));
    }
  }

  resetDrawEdit(): void {
    this.store.dispatch(new AddText(false));
    this.store.dispatch(new ResetSelected());
    this.editingShape = '';
  }

  updateTextStyle(textStyle: any): void {
    const selectedFeature = this.mapState.features.filter(
      f => f.properties?.isSelected === true
    );
    if (selectedFeature.length > 0) {
      if (selectedFeature[0].textMarkup) {
        this.store.dispatch(
          new UpdateFeatureStyle({
            style: {
              ...selectedFeature[0].style,
              color: textStyle.color
            },
            leafletId: selectedFeature[0].leafletId ?? 0
          })
        );
      }
    }
  }

  getActiveFeature(): any {
    return this.mapState.features.filter(f => f.properties?.isSelected);
  }

  getSelectedTextMarkup(): DnvDrawnShapes[] {
    if (this.mapState.features) {
      return this.mapState.features.filter(
        f => f.properties?.isSelected && f.textMarkup
      );
    }
  }

  bringToFront(): void {
    const selectedShape = this.mapState.features.filter(
      s => s.properties.isSelected
    );
    if (selectedShape && selectedShape.length > 0) {
      this.store.dispatch(new BringToFront(selectedShape[0].leafletId ?? 0));
    }
    // resets value
    this.store.dispatch(new BringToBack(0));
  }

  bringToBack(): void {
    const selectedShape = this.mapState.features.filter(
      s => s.properties.isSelected
    );
    if (selectedShape && selectedShape.length > 0) {
      this.store.dispatch(new BringToBack(selectedShape[0].leafletId));
    }
    // resets value
    this.store.dispatch(new BringToFront(0));
  }

  onClearActiveLayer(layerState: DnvLayer[]): void {
    layerState.forEach(l => {
      if (l.type.toString() === '0') {
        this.store.dispatch(new SetAvailableLayer(l));
        this.store.dispatch(new ClearLayerFilters({ layer: l, hidden: [] }));
      }
    });
    this.store.dispatch(new CheckLayerDisplay());
    this.initializeLegend();
  }

  print(): void {
    window.print();
  }

  // TODO review the two this.propertiesInfo$ subscriptions below
  // Ideally it should be possible to subscribe only once, not re-subscribe

  setAddress(address: string, dbLink: string): void {
    this.propertiesInfo$
      // takeUntil(this.ngUnsubscribe)
      .pipe(take(1))
      // tslint:disable-next-line: deprecation
      .subscribe((propertiesInfo: PropertyInfo[]) => {
        if (propertiesInfo && propertiesInfo[0]) {
          if (propertiesInfo[0].propertyCount > 1) {
            const property = propertiesInfo[0].properties.find(p =>
              p.addresses.find(a => a.fullAddress === address)
            );
            if (property) {
              this.dblink = property.dbLink;
              this.ltopid = property.ltopid;
            } else {
              // Added error handling code to investigate random ERROR TypeError: Cannot read property 'dbLink' of undefined
              console.error('Property not found for ' + address);
              console.log(propertiesInfo[0].properties);
            }
          } else {
            this.dblink = propertiesInfo[0].properties[0].dbLink;
            this.ltopid = propertiesInfo[0].properties[0].ltopid;
          }
        }
      });
    this.store.dispatch(
      new GetPropertyByAddress({
        address,
        dblink: dbLink ? dbLink : this.dblink,
        ltopid: this.ltopid,
        search: false
      })
    );
    this.store.dispatch(new SetSelectedProperty(address));
  }

  openDrawing(payload: { drawNum: string; drawType: string }): void {
    this.store.dispatch(new SearchEngineerDrawingsByNumType(payload));
  }

  GetMultipleResults(dblink: string): void {
    if (this.multiPlan) {
      let lat = 0;
      let lng = 0;
      this.propertiesInfo$
        .pipe(takeUntil(this.ngUnsubscribe))
        // tslint:disable-next-line: deprecation
        .subscribe((propertiesInfo: PropertyInfo[]) => {
          if (
            propertiesInfo &&
            propertiesInfo[0] &&
            propertiesInfo[0].properties[0].details
          ) {
            lat = propertiesInfo[0].properties[0].details.geography.latitude;
            lng = propertiesInfo[0].properties[0].details.geography.longitude;
          }
        });
      this.store.dispatch(new GetPropertyByXY({ lat, lng }));
    } else {
      this.store.dispatch(new GetPropertyInfo(dblink));
    }
  }

  GetPropertyByDbLink(dblink: string): void {
    this.store.dispatch(new GetPropertyInfo(dblink));
    this.store.dispatch(new GetShape(dblink));
    this.store.dispatch(new SetSelectedProperty(''));
  }

  BackToPlansOrClose(): void {
    if (this.multiPlan) {
      this.store.dispatch(new SetPropertyInfo([]));
      // this.store.dispatch(new SetMapGeoJsonLayers([]));
      this.store.dispatch(new SetSelectedProperty(''));
    } else {
      this.closePropertyInformation();
    }
  }

  onFilterAOI(evt: any): void {
    // if (evt.action === 'select') {
    //   this.store.dispatch(new IsDrawing(true));
    // } else {
    //   if (this.filterAOILeafletId && this.filterAOILeafletId > 0) {
    //     this.store.dispatch(new DeleteFeature(this.filterAOILeafletId));
    //   }
    //   this.store.dispatch(new IsDrawing(false));
    //   this.store.dispatch(new SetFilterAOIShape({}));
    //   this.store.dispatch(new QueryLayerFeatureCount(evt.featurefilterpayload));
    // }

    // this.store.dispatch(new SetFilterAOIMode(evt));
    // this.store.dispatch(new CheckLayerDisplay());

    if (evt.action === 'select') {
      this.store.dispatch(new IsDrawing(false));
      this.store.dispatch(new SetFilterAOIShape({} as DnvDrawnShapes));

      this.store.dispatch(
        new SetFilterAOIMode({
          action: 'clear',
          featureLayerId: null,
          shape: null,
          showingAOIShape: true
        })
      );
      this.store.dispatch(new IsDrawing(true));
    } else if (evt.action === 'clear') {
      if (this.filterAOILeafletId && this.filterAOILeafletId > 0) {
        this.store.dispatch(new DeleteFeature(this.filterAOILeafletId));
      }
      this.store.dispatch(new IsDrawing(false));
      this.store.dispatch(new SetFilterAOIShape({} as DnvDrawnShapes));
    }

    this.store.dispatch(new SetFilterAOIMode(evt));
  }

  closeCCTV(): void {
    this.store.dispatch(new SetCCTV([]));
    this.store.dispatch(new SelectCCTV(null));
    this.closeFeatureInformation();
  }

  onSelectCctv(inspection: SelectedFeatureInspection): void {
    this.store.dispatch(new SelectCCTV(inspection));
  }

  printMap(evt: any): void {
    const mapBorder = this.mapBorder; // for passing into browser-print event
    const noTitle = this.isMapTitle();
    // this.dnvMap.printControl.options.manualMode = true;

    const mode = evt.mode;
    const paper = evt.paperSize.toLowerCase();
    if (evt.mode === 'portrait') {
      this.dnvMap.printControl.browserPrint.print(
        (L as any).BrowserPrint.Mode.Portrait(evt.paperSize)
      );
    } else if (evt.mode === 'landscape') {
      this.dnvMap.printControl.browserPrint.print(
        (L as any).BrowserPrint.Mode.Landscape(evt.paperSize)
      );
    } else {
      this.dnvMap.printControl.browserPrint.print(
        (L as any).BrowserPrint.Mode.Custom(evt.paperSize)
      );
    }

    (this.dnvMap as any).map.on('browser-print', function (e: any) {
      // console.log(e);
      const gridPrint = e.printMap._container.parentElement; // .grid-print-container
      const titleDiv = e.printMap._container.parentElement.querySelector(
        '.titleContainer'
      );
      const legend = e.printMap._container.parentElement.querySelector(
        '#printableLegend'
      );
      const northArrow = e.printMap._container.parentElement.querySelector(
        '.north-arrow'
      );
      let arrowRight = 10;
      if (legend && northArrow) {
        if (legend.classList.contains('bottomRight')) {
          arrowRight = Number(legend.scrollWidth + 10);
        }

        if (noTitle) {
          if (titleDiv) {
            arrowRight = arrowRight + 10;
          }
        }
      } else {
        arrowRight = 15;
      }
      northArrow.style = 'right: ' + arrowRight + 'px;';

      if (mapBorder) {
        if (gridPrint) {
          gridPrint.classList.add('mapborder');
          gridPrint.classList.remove('singleMapBorder');
          /*
          if (paper === 'tabloid') {
            if (mode === 'landscape') {
              gridPrint.classList.add('tabloid-landscape');
              gridPrint.classList.remove('tabloid-portrait');
            } else {
              gridPrint.classList.remove('tabloid-landscape');
              gridPrint.classList.add('tabloid-portrait');
            }
          } else {
            gridPrint.classList.remove('tabloid-landscape');
            gridPrint.classList.remove('tabloid-portrait');
          }
          */
        }
        if (!noTitle) {
          if (titleDiv) {
            titleDiv.classList.add('noTitle');
          }
          if (northArrow) {
            northArrow.classList.add('noTitle');
          }
        } else {
          if (titleDiv) {
            titleDiv.classList.remove('noTitle');
          }
          if (northArrow) {
            northArrow.classList.remove('noTitle');
          }
        }
      } else {
        if (gridPrint) {
          gridPrint.classList.remove('mapborder');
          gridPrint.classList.add('singleMapBorder');
          /*
          if (paper === 'tabloid') {
            if (mode === 'landscape') {
              gridPrint.classList.add('tabloid-landscape');
              gridPrint.classList.remove('tabloid-portrait');
            } else {
              gridPrint.classList.remove('tabloid-landscape');
              gridPrint.classList.add('tabloid-portrait');
            }
          } else {
            gridPrint.classList.remove('tabloid-landscape');
            gridPrint.classList.remove('tabloid-portrait');
          }
          */
        }
      }
    });
  }

  onChangeMapTitle(evt: string): void {
    this.mapTitle = evt;
  }

  onChangeMapSubtitle(evt: string): void {
    this.mapSubTitle = evt;
  }

  onChangeMapLegendPosition(evt: string): void {
    this.mapLegendPosition = evt;
  }

  onChangeMapLegendEnabled(evt: boolean): void {
    this.mapLegendEnabled = evt;
  }

  onChangeMapBorderEnabled(evt: boolean): void {
    this.mapBorder = evt;
  }

  openReport(dblink: string): void {
    this.store.dispatch(
      new PrintSvcConn({
        dblink: dblink,
        opacity: this.mapState.orthoOpacity,
        token: this.mapState.arcGisToken.token
      })
    );
  }

  highlightServiceConnection(name: string, objectId: number) {
    // this.layerState.layers.forEach(layer => {
    this.mapState.featureLayers.forEach(featureLayer => {
      //  layer.featureLayers.forEach(featureLayer => {
      if (featureLayer.name === name) {
        // raster
        if (
          this.prevConn.name !== name ||
          this.prevConn.objectId !== objectId
        ) {
          this.store.dispatch(
            new GetCoordsByObjectId({
              url: featureLayer.url,
              objectId: objectId
            })
          );
          this.prevConn = { name, objectId };
        } else {
          // reset
          this.store.dispatch(new SetFeatureRasterHighlight({}));
          this.store.dispatch(
            new DelayedAction([new RefreshDisplayedGeoJson()])
          );
          this.prevConn = { name: '', objectId: 0 };
        }
      }
    });
    // });
  }

  highlightCCTV(url: string, objectId: number): void {
    if (url && objectId) {
      this.store.dispatch(new GetCoordsByObjectId({ url, objectId }));
    } else {
      this.store.dispatch(new SetFeatureRasterHighlight({}));
      this.store.dispatch(new DelayedAction([new RefreshDisplayedGeoJson()]));
    }
  }

  onMailLabelDraw() {
    if (this.toolboxMailMergeState.selectionMethod !== 'area') {
      const guid = Guid.create().toString();
      this.store.dispatch(new StartDraw({ shape: 'tool-polygon', guid: guid }));

      this.store.dispatch(
        new ToolboxMailMerge({
          toolboxMailMergeState: Object.assign({}, this.toolboxMailMergeState, {
            selectionMethod: 'area'
          }),
          invalidate: true
        })
      );

      this.store.dispatch(new DelayedAction([new RefreshDisplayedGeoJson()]));
    }
  }

  onMailLabelSelect() {
    // this.store.dispatch(new StartDraw({ shape: '', guid: guid }));
    // this.store.dispatch(new IsDrawing(false));
    // mailMergeSelect() {
    if (this.toolboxMailMergeState.selectionMethod !== 'property') {
      const guid = Guid.create().toString();
      this.store.dispatch(new StartDraw({ shape: '', guid: guid }));
      this.store.dispatch(new IsDrawing(false));

      this.store.dispatch(
        new ToolboxMailMerge({
          toolboxMailMergeState: Object.assign({}, this.toolboxMailMergeState, {
            selectionMethod: 'property'
          }),
          invalidate: true
        })
      );

      this.store.dispatch(new DelayedAction([new RefreshDisplayedGeoJson()]));
    }
  }

  onMailLabelClearEmitter() {
    let guid = '';

    if (this.toolboxMailMergeState.selectionMethod === 'area') {
      guid = Guid.create().toString();
      this.store.dispatch(new StartDraw({ shape: '', guid: guid }));
      this.store.dispatch(new IsDrawing(false));

      guid = Guid.create().toString();
      this.store.dispatch(new StartDraw({ shape: 'tool-polygon', guid: guid }));

      this.store.dispatch(
        new ToolboxMailMerge({
          toolboxMailMergeState: Object.assign({}, this.toolboxMailMergeState, {
            selectionMethod: 'area'
          }),
          invalidate: true
        })
      );
    } else if (this.toolboxMailMergeState.selectionMethod === 'property') {
      this.store.dispatch(
        new ToolboxMailMerge({
          toolboxMailMergeState: Object.assign({}, this.toolboxMailMergeState, {
            selectionMethod: 'property'
          }),
          invalidate: true
        })
      );
    }

    this.store.dispatch(new DelayedAction([new RefreshDisplayedGeoJson()]));
  }

  onMailMergeBufferChange(value: number) {
    this.store.dispatch(
      new ToolboxMailMerge({
        toolboxMailMergeState: Object.assign({}, this.toolboxMailMergeState, {
          selectionBuffer: value
        }),
        invalidate: false
      })
    );

    if (this.toolboxMailMergeState.area.json) {
      this.store.dispatch(
        new ToolboxMailMergeArea(this.toolboxMailMergeState.area)
      );
    }
  }

  onOrthoOpacityChange(value: number): void {
    this.store.dispatch(new SetOrthoOpacity(value));
    this.store.dispatch(
      new MapViewCheckIsDirty({
        urlProvider: this.appUrlProvider,
        storeWrapper: this.appStoreWrapper
      })
    );
  }

  downloadMailLabels(evt: any): void {
    this.store.dispatch(new GetMailMergeList());
  }

  onMailLabelOptionsEmitter(evt: ToolboxMailMergeOptions): void {
    this.store.dispatch(new ToolboxMailMergeUpdateOptions(evt));
  }

  resetSVCLayers(): void {
    // remove service connections layers
    // const svcLayers = ['Sanitary Network', 'Water Network', 'Storm Network', 'Rights of Way and Easements'];

    // const svcLyrs = this.layerState.layers.filter(l => svcLayers.includes(l.name));
    // if (svcLyrs) {
    //   svcLyrs.forEach(s => {
    //     this.setAvailableLayer(s);
    //   });

    // }
    // closes info panel
    this.store.dispatch(new SetPrintSvcConn(''));
  }

  getHASliderValue(): void {
    // console.log(this.historicalSlider.value);
    const sliderValue = this.historicalSlider.value;
    const minNum = Math.floor(sliderValue);
    this.store.dispatch(
      new SetHistoricalAerialsOpacity({
        currentIndex: minNum,
        currentOpacity:
          sliderValue - minNum === 0
            ? 1
            : Math.round((1 - (sliderValue - minNum)) * 100) / 100,
        nextIndex: minNum + 1,
        nextOpacity:
          sliderValue - minNum === 0
            ? 0
            : Math.round((sliderValue - minNum) * 100) / 100
      })
    );
  }

  onCustomBtnClick(evt: string) {
    if (evt === 'streetview') {
      this.store.dispatch(new ToggleStreetView());

      setTimeout(() => {
        this.changeDetector.detectChanges();
      }, 1);
    }
  }

  onSetMeasurements(evt: any) {
    this.store.dispatch(new SetMeasurements(evt.measurements));
    this.store.dispatch(new SetMeasureShapeId(evt.leafletId));
    this.store.dispatch(new SetFromMeasureTool(evt.measureTool));
  }

  showThickness() {
    if (
      this.drawBtn === 'line' ||
      this.drawBtn === 'polygon' ||
      this.drawBtn === 'circle' ||
      ((this.editingShape === 'LineString' ||
        this.editingShape === 'Polygon' ||
        this.editingShape === 'circle') &&
        this.isShapeSelected())
    ) {
      return true;
    }
    return false;
  }

  setLineWeight(evt: any) {
    const lineWeight = evt.target.value;
    this.store.dispatch(new SetLineWeight(lineWeight));
    this.store.dispatch(new UpdateLineWeight(lineWeight));
  }

  setMarkerSize(evt: any) {
    const markerSize = evt.target.value;
    this.store.dispatch(new SetMarkerSize(markerSize));
    this.store.dispatch(new UpdateMarkerSize(markerSize));
  }

  editFeatureClick(lyr: EditPermissionPayload): void {
    this.store.dispatch(new GetEditFeatureFields(lyr.write_Url));
    if (lyr && lyr.autoIncrementField) {
      this.store.dispatch(
        new GetMaxAssetId({ url: lyr.url, name: lyr.autoIncrementField })
      );
    } else {
      this.store.dispatch(new SetMaxAssetId({ assetId: null, name: null }));
    }

    this.setFeatureType({
      featureType: lyr.featureLayerName,
      featureLayerId: lyr.featureLayerId,
      shape: lyr.shape
    });
    this.store.dispatch(new SetEditFeaturesPermission(lyr));
    this.store.dispatch(new CheckLayerDisplay());
  }

  setFeatureType(featureTypeObj: {
    featureType: string;
    featureLayerId: number;
    shape: string;
  }) {
    this.store.dispatch(new SetEditFeature(featureTypeObj));

    if (featureTypeObj.featureType === '') {
      // reset states
      this.store.dispatch(new SetSurroundingFeatureList(null));
      this.store.dispatch(new SelectFeature(null));
      this.store.dispatch(new SetSelectedFeatureSections(null));
      // this.store.dispatch(new SetEditFeaturesGeometry({ leafletId: null }));
      this.store.dispatch(new GetEditFeaturesGeometry(null));
      this.store.dispatch(new SetEditFeaturesPermission(null));
      this.store.dispatch(new SetEditFeatureShowActiveLayer(false));
      this.store.dispatch(new CheckLayerDisplay());
      this.store.dispatch(new SetSnapToLayers(false));
      this.store.dispatch(new SetEditFeatureFields(null));
      this.store.dispatch(new SetEditFeaturesGeometry(null));

      // clear highlights
      if (!this.mapState.selectedFeature) {
        this.store.dispatch(new SetFeatureRasterHighlight({}));
        this.store.dispatch(new DelayedAction([new RefreshDisplayedGeoJson()]));
      }
    }
  }

  saveEditFeature(evt: { formValues: any; action: string; shape: string }) {
    // if (evt === null) { // new feature but cancelled, so turn off drawing
    //   this.store.dispatch(new StartDraw({ shape: 'cancel', guid: '' }));
    // } else {

    // get writeUrl
    const featureLayer = this.mapState.featureLayers.find(
      (fl: DnvFeatureLayer) =>
        fl.featureLayerId === this.applicationState.editFeature.featureLayerId
    );
    if (featureLayer) {
      this.writeUrl = featureLayer.writeUrl;
    }

    // if new feature, get coordinates from state
    let latlng;
    if (evt.action === 'save') {
      // saving new feature
      if (this.applicationState.newFeatureLatLng) {
        // console.log(this.applicationState.newFeatureLatLng);
        latlng = this.applicationState.newFeatureLatLng;
        // clear state
        this.store.dispatch(new SetNewFeatureLatLng(null));
      }

      const featureObj = this.formatFeatureObj(
        evt.formValues,
        latlng,
        evt.shape
      );

      this.store.dispatch(
        new AddEditFeature({
          feature: featureObj,
          url: this.writeUrl,
          token: this.mapState.arcGisToken.token
        })
      );

      // this.store.dispatch(new SaveEditFeature({ formValues: evt.formValues, writeUrl: this.writeUrl, latlng: latlng, shape: evt.shape }));
      this.store.dispatch(new SetShowSpinner(true));
      this.featureAdded = false;
    } else if (evt.action === 'update') {
      // updating feature

      if (evt.formValues) {
        // latlng  saved separately, see onLatLngEmit
        const editedFeature = this.formatFeatureObj(
          evt.formValues,
          null,
          evt.shape
        );
        //  this.store.dispatch(new UpdateEditFeature({ formValues: evt.formValues, writeUrl: this.writeUrl, shape: evt.shape }));
        this.store.dispatch(
          new UpdateEditFeature({
            feature: editedFeature,
            url: this.writeUrl,
            token: this.mapState.arcGisToken.token,
            objId: evt.formValues['OBJECTID']
          })
        );

        this.store.dispatch(new SetShowSpinner(true));
      }
      this.store.dispatch(new SetEditFeatures(false));
      // this.store.dispatch(new SetEditFeaturesGeometry(null));
    }
    this.store.dispatch(new SetEditFeatures(false));
    // }

    // feature's been saved or cancelled, delete feature from map
    if (this.applicationState.lastEditFeature) {
      this.store.dispatch(
        new DeleteFeature(this.applicationState.lastEditFeature)
      ); // deletes drawing from map
      this.store.dispatch(new SetLastEditFeature(null));
    }
  }

  addNewFeature(shape: string) {
    this.store.dispatch(new StartDraw({ shape: shape, guid: '' }));
  }

  onNewFeatureAdded(evt: any) {
    // console.log(evt);
    this.store.dispatch(
      new DelayedAction([
        new StartDraw({ shape: 'cancel', guid: '' }),
        new SetNewFeatureLatLng(evt.latlng),
        new SetLastEditFeature(evt.leafletId),
        new EditingFeature(false)
      ])
    );
    // this.store.dispatch(new StartDraw({ shape: 'cancel', guid: '' }));
    // this.store.dispatch(new SetNewFeatureLatLng(evt.latlng));
    // this.store.dispatch(new SetLastEditFeature(evt.leafletId));
    // this.store.dispatch(new EditingFeature(false));
    this.featureAdded = true;
  }

  // delete new feature added to map, not saved
  deleteNewFeature() {
    if (this.applicationState.lastEditFeature) {
      this.store.dispatch(
        new DeleteFeature(this.applicationState.lastEditFeature)
      );
      this.store.dispatch(new SetLastEditFeature(null));

      this.featureAdded = false; // disables form
    }
  }

  deleteFeature(event: any) {
    // get writeUrl
    let writeUrl = '';
    let epLyr: any;
    this.applicationState.editPermission.filter(ep =>
      ep.editableLayers.filter(lyr => {
        if (
          lyr.featureLayerId ===
          this.applicationState.editFeature.featureLayerId
        ) {
          epLyr = lyr;
        }
      })
    );

    if (epLyr && epLyr.write_Url) {
      this.store.dispatch(
        new MapDeleteEditFeature({
          objId: event,
          url: epLyr.write_Url,
          token: this.mapState.arcGisToken.token
        })
      ); //map action

      this.store.dispatch(new SetShowSpinner(true));
    } else {
      this.store.dispatch(
        new ToastUserNotification({
          type: 'fail',
          title: 'Cannot delete feature',
          message: 'There was a problem deleting the feature',
          options: {
            disableTimeOut: true,
            closeButton: true
          }
        })
      );
    }
  }

  onEditedFeature(evt: { action: string; error: any; response: any }) {
    let pastTense;
    let errorMsg;
    let nullAction;
    if (evt.action === 'add') {
      pastTense = 'added';
      errorMsg = 'There was a problem adding the feature';
      nullAction = new AddEditFeature({
        url: null,
        token: null,
        feature: null
      });
    } else if (evt.action === 'update') {
      pastTense = 'updated';
      errorMsg =
        'There was a problem updating the feature with objectId ' +
        evt.error?.objectId;
      nullAction = new UpdateEditFeature({
        url: null,
        token: null,
        feature: null,
        objId: null
      });
    } else if (evt.action === 'delete') {
      pastTense = 'deleted';
      errorMsg =
        'There was a problem deleting the feature with objectId ' +
        evt.error?.objectId;
      nullAction = new MapDeleteEditFeature({
        url: null,
        token: null,
        objId: null
      });
    }

    this.store.dispatch(new SetShowSpinner(false));

    const featureLyr = this.mapState.featureLayers.filter(
      f =>
        f.featureLayerId === this.mapState.editFeaturesPermission.featureLayerId
    );

    if (evt.response) {
      this.store.dispatch(
        new DelayedAction([
          nullAction,
          new AddEditFeature(null),
          new SetEditFeaturesPermission(null),
          new CheckLayerDisplay(),
          new ToastUserNotification({
            type: 'success',
            title: 'Feature ' + pastTense,
            message: 'Feature was successfully ' + pastTense,
            options: {
              disableTimeOut: false,
              closeButton: true
            }
          }),
          new SelectFeature(null),
          new SetSurroundingFeatureList(null),
          new SetFeatureRasterHighlight({}),
          new ToggleFeaturePanel(null),
          new DelayedActionBy1([
            new SetEditFeaturesPermission(this.mapState.editFeaturesPermission),
            new SetFeatureLayerSymbology(featureLyr[0] ? featureLyr[0] : null),
            new CheckLayerDisplay(),
            new RefreshDisplayedGeoJson()
          ])
        ])
      );
    } else if (evt.error) {
      this.store.dispatch(
        new ToastUserNotification({
          type: 'error',
          title: 'Cannot ' + evt.action,
          message: errorMsg + '. Error: ' + JSON.stringify(evt.error.message),
          options: {
            disableTimeOut: true,
            closeButton: true
          }
        })
      );
    }
  }

  enableEditFeatures(evt: boolean) {
    this.store.dispatch(new SetEditFeatures(evt));
    this.store.dispatch(new RefreshDisplayedGeoJson());
    // turn off highlighting for editing if user can edit geometry
    if (this.mapState.editFeaturesPermission.geometry) {
      this.store.dispatch(new SetFeatureRasterHighlight({}));
    }
  }

  revertGeometry() {
    this.store.dispatch(new RevertFeatureGeometry(true));

    // get feature layer url
    let flUrl = '';
    this.layerState.layers.filter(l =>
      l.featureLayers.filter(f => {
        if (
          f.featureLayerId === this.applicationState.editFeature.featureLayerId
        ) {
          flUrl = f.url;
        }
      })
    );
    // set highlight on feature
    if (this.mapState.editFeaturesGeometryObjId) {
      this.store.dispatch(
        new GetCoordsByObjectId({
          url: flUrl,
          objectId: this.mapState.editFeaturesGeometryObjId
        })
      );
    }

    this.writeUrl = '';
    this.store.dispatch(new SetSnapAsset(null));
  }

  onActionEmit(evt: Action) {
    this.store.dispatch(evt);
  }

  onLatLngEmit(evt: {
    state: string;
    latlng: any;
    objId: number;
    shape: string;
  }) {
    // console.log(evt);
    if (evt.state === 'original') {
      this.store.dispatch(
        new SetEditFeaturesGeometry({ original: evt, edited: null })
      );
    } else if (evt.state === 'edited') {
      // check if geometry edited
      if (
        this.mapState.editFeaturesGeometry &&
        this.mapState.editFeaturesGeometry.original
      ) {
        const origLatLng = this.mapState.editFeaturesGeometry.original.latlng;
        const editedLatLng = evt.latlng;
        const isGeoDiff = this.compareGeometry(origLatLng, editedLatLng);
        if (isGeoDiff) {
          this.store.dispatch(
            new UpdateEditFeatureGeometry({
              objId: evt.objId,
              latlng: evt.latlng,
              writeUrl: this.writeUrl,
              shape: evt.shape
            })
          );
          this.store.dispatch(new SetShowSpinner(true));
        }
      }
    }
  }

  compareGeometry(orig: any, edited: any): boolean {
    let result = false;
    if (orig.lat !== edited.lat || orig.lng !== edited.lng) {
      // point
      result = true;
    } else {
      // line or polygon
      if (orig.length !== edited.length) {
        result = true;
      } else {
        for (let i = 0; i < orig.length; i++) {
          if (orig[i].lat !== edited[i].lat || orig[i].lng !== edited[i].lng) {
            result = true;
            break;
          }
        }
      }
    }

    return result;
  }

  onSnapToggle(flag: boolean): void {
    const newFlag = !flag;
    this.store.dispatch(new SetSnapToLayers(newFlag));
  }

  // user abandons editing and click on another menu button
  resetFeaturesEditing(): void {
    this.deleteNewFeature();
    this.resetEditFeature();
    //  this.setFeatureType({ featureLayerId: 0, featureType: '', shape: '' });
  }

  isMapTitle(): boolean {
    if (this.mapTitle.trim().length > 0 || this.mapSubTitle.trim().length > 0) {
      return true;
    }
    return false;
  }

  onCheckMapViewDirty(): void {
    this.store.dispatch(
      new MapViewCheckIsDirty({
        urlProvider: this.appUrlProvider,
        storeWrapper: this.appStoreWrapper
      })
    );
  }

  formatFeatureObj(values: any, latlng: any, shape: string) {
    let feature;

    if (latlng) {
      if (shape.toLowerCase().indexOf('line') > -1) {
        let geoStr = [];
        for (let i = 0; i < latlng.length; i++) {
          geoStr.push([latlng[i].lng, latlng[i].lat]);
        }

        feature = {
          type: 'Feature',
          properties: values,
          geometry: {
            coordinates: geoStr,
            type: 'LineString'
          }
        };
      } else if (shape.toLowerCase().indexOf('point') > -1) {
        feature = {
          type: 'Feature',
          properties: values,
          geometry: {
            coordinates: [latlng.lng, latlng.lat],
            type: 'Point'
          }
        };
      } else if (shape.toLowerCase().indexOf('polygon') > -1) {
        let geoStr = [];
        const polygon = latlng[0];
        for (let i = 0; i < polygon.length; i++) {
          geoStr.push([polygon[i].lng, polygon[i].lat]);
        }
        feature = {
          type: 'Feature',
          properties: values,
          geometry: {
            coordinates: [geoStr],
            type: 'Polygon'
          }
        };
      }

      // format dates
      Object.keys(values).forEach(key => {
        if (
          key.toLowerCase().indexOf('date') > -1 &&
          key.toLowerCase().indexOf('create') === -1 &&
          key.toLowerCase().indexOf('edit') === -1
        ) {
          if (values[key]?.length === 10 && values[key]?.indexOf('-') > -1) {
            const newDate = new Date(values[key] + ' 00:00:00');
            values[key] = newDate.getTime();
          }

          if (values[key]?.length === 8 && values[key]?.indexOf('-') === -1) {
            const temp = values[key];
            const newTempDate =
              temp.substr(0, 4) +
              '-' +
              temp.substr(4, 2) +
              '-' +
              temp.substr(6, 2);
            const newDate = new Date(newTempDate + ' 00:00:00');
            values[key] = newDate.getTime();
          }
        }
      });
    } else {
      const editedValues = Object.assign({}, values);
      const objId = values['OBJECTID'];
      Object.keys(editedValues).forEach(key => {
        if (
          editedValues[key] === '' ||
          (editedValues[key] &&
            editedValues[key].toString().trim().length === 0)
        ) {
          // delete editedValues[key];
          editedValues[key] = null;
        }
        // make sure not to edit create or edit dates
        if (
          key.toLowerCase().indexOf('date') > -1 &&
          key.toLowerCase().indexOf('create') === -1 &&
          key.toLowerCase().indexOf('edit') === -1
        ) {
          if (
            editedValues[key]?.length === 10 &&
            editedValues[key]?.indexOf('-') > -1
          ) {
            const newDate = new Date(editedValues[key] + ' 00:00:00');
            editedValues[key] = newDate.getTime();
          }

          if (
            editedValues[key]?.length === 8 &&
            editedValues[key]?.indexOf('-') === -1
          ) {
            const temp = editedValues[key];
            const newTempDate =
              temp.substr(0, 4) +
              '-' +
              temp.substr(4, 2) +
              '-' +
              temp.substr(6, 2);
            const newDate = new Date(newTempDate + ' 00:00:00');
            editedValues[key] = newDate.getTime();
          }
        }
      });
      feature = {
        type: 'Feature',
        properties: editedValues,
        id: Number(objId)
      };
    }

    return feature;
  }

  deleteShape() {
    const selectedShape = this.mapState.features.filter(
      s => s.properties.isSelected === true
    );
    if (selectedShape && selectedShape[0]) {
      this.store.dispatch(new DeleteFeature(selectedShape[0].leafletId));
    }
  }

  isShapeSelected(): boolean {
    if (!this.mapState?.features) return false;
    const selectedShape = this.mapState.features.filter(
      s => s.properties.isSelected === true
    );
    if (selectedShape && selectedShape[0]) {
      return true;
    }
    return false;
  }

  onShowActiveLayer(evt: boolean): void {
    this.store.dispatch(new SetEditFeatureShowActiveLayer(evt));
    this.store.dispatch(new CheckLayerDisplay());
  }

  onExportInspections(evt: any): void {
    this.store.dispatch(new ExportInspections(evt));
  }

  updateSchedule(formValues: any): void {
    this.updateReplacementYear(formValues);
    this.updateExclusionLayer(formValues);
  }

  updateExclusionLayer(formValues: any): void {
    let wmrpEditPermissionLayer = this.applicationState.editPermission
      .find(tool => tool.toolname === 'TOOL_WMRP')
      .editableLayers.find(
        layer => layer.featureLayerName === 'Excluded Mains'
      );
    // note: url and write_url are the same (https://giswebapps.cdnv.dnv.ca/arcgis/rest/services/NewGT/WMRP_Analysis_Schedule_Layers/FeatureServer) for this layer because layer editing is only enabled on FeatureServer and is needed for both url and write_url

    // not sure why the behaviour is different here, but AddEditFeature and MapDeleteEditFeature require the url to be only the last part after '/arcgis'
    const exclusionLayerWriteUrl = wmrpEditPermissionLayer.url.slice(
      wmrpEditPermissionLayer.url.indexOf('/arcgis')
    );
    this.editFeatureClick(wmrpEditPermissionLayer);
    // should now have editFeaturesPermission

    const formattedPropertiesObject = this.mapState.selectedFeature.reduce(
      (formattedObj: { [x: string]: any }, property: any[]) => {
        const key = property[0].replace(
          `${this.appSettings['appConfig.gisdb']}SDE_ADMIN.WtrWRPSchedule.`,
          ''
        );
        formattedObj[key] = property[1];
        return formattedObj;
      },
      {}
    );

    formattedPropertiesObject['Reason'] = formValues.comments;
    formattedPropertiesObject['Active'] = 'Y'; // todo, leave as yes always for now

    const selectedAssetFeatureObj = {
      type: 'Feature',
      properties: formattedPropertiesObject,
      geometry: {
        coordinates: this.applicationState.featureRasterHighlight.json
          ?.features[0].geometry.coordinates,
        type: 'LineString'
      }
    };

    const shouldAddMain = formValues.addToExclusionLayer;
    const isInExclusionLayer = this.wmrpState.exclusionLayerMains.find(
      main =>
        main.Watermain_id === selectedAssetFeatureObj.properties.Watermain_id
    );

    if (shouldAddMain && !isInExclusionLayer) {
      this.store.dispatch(
        new AddEditFeature({
          feature: selectedAssetFeatureObj,
          url: exclusionLayerWriteUrl,
          token: this.mapState.arcGisToken.token
        })
      );
    } else if (!shouldAddMain && isInExclusionLayer) {
      this.store.dispatch(
        new MapDeleteEditFeature({
          objId: isInExclusionLayer.OBJECTID,
          url: exclusionLayerWriteUrl,
          token: this.mapState.arcGisToken.token
        })
      );
    }
  }

  updateReplacementYear(formValues: any): void {
    const feature: [string, string][] = this.mapState.selectedFeature;
    const objectId = parseInt(
      feature.find(attr => attr[0].toLowerCase().indexOf('objectid') >= 0)[1]
    );
    const replacementYear: number =
      formValues.replacementYear.toLowerCase() == 'unscheduled'
        ? null
        : formValues.replacementYear;

    const selectedAssetFeatureObj = {
      type: 'Feature',
      properties: {
        OBJECTID: objectId,
        Replacement_year: replacementYear,
        Manual_override: 'Y',
        Deferral_reason: formValues.comments
      }
    };
    //TODO: Move URL to application setting
    this.store.dispatch(
      new UpdateScheduleYear({
        feature: selectedAssetFeatureObj,
        url:
          '/arcgis/rest/services/NewGT/WMRP_Analysis_Schedule_Layers/FeatureServer/1'
      })
    );
  }

  hideTools() {
    return (
      !(this.applicationState.status === ApplicationStatus.Toolbox) ||
      (this.applicationState.status === ApplicationStatus.Toolbox &&
        (this.applicationState.toolboxStatus === ToolboxStatus.EngDrawing ||
          this.applicationState.toolboxStatus === ToolboxStatus.CCTV ||
          this.applicationState.toolboxStatus === ToolboxStatus.MailMerge ||
          this.applicationState.toolboxStatus ===
          ToolboxStatus.HistoricalAerials ||
          this.applicationState.toolboxStatus === ToolboxStatus.PostingPlans ||
          this.applicationState.toolboxStatus === ToolboxStatus.AssetFinder ||
          this.applicationState.toolboxStatus === ToolboxStatus.WMRP ||
          this.applicationState.toolboxStatus ===
          ToolboxStatus.PopulationCalculator))
    );
  }

  updateCount(evt: number) {
    this.chkCount = evt;
  }

  onSaveParams(params: WmrpSaveObject) {
    this.store.dispatch(new SaveTemplateParameters(params));
  }

  onRunAnalysisCustom(params: WmrpAnalysisParam[]) {
    const permit = this.isWMRP('WMRP USER');
    if (permit) {
      this.toggleWMRPConditions(false);
      this.showAnalysisParametersBtn = true;
      this.showAnalysisStatus = true;

      this.store.dispatch(new RunAnalysisCustom(params));
    } else {
      this.notAuthorizedToast();
    }
  }

  onRunAnalysisTemplate(templateId: number) {
    const permit = this.isWMRP('WMRP USER');
    if (permit) {
      this.toggleWMRPConditions(false);
      this.showAnalysisParametersBtn = true;
      this.showAnalysisStatus = true;

      this.store.dispatch(new RunAnalysisTemplate(templateId));
    } else {
      this.notAuthorizedToast();
    }
  }

  toggleParamPanel() {
    this.showAnalysisParameters = !this.showAnalysisParameters;
  }

  getHazardSliderValue() {
    this.hazardMin.setValue(this.minValue);
    this.hazardMax.setValue(this.maxValue);
    this.store.dispatch(
      new SetWmrtBoundary({
        hazardBoundaryLow: this.minValue,
        hazardBoundaryHigh: this.maxValue
      })
    );
    this.updateWmrpAnalysisCBR();
    this.updateWmrpMergedScoresCBR();
    this.store.dispatch(new CheckLayerDisplay());
  }

  onChangeHazard(flag: string) {
    if (flag === 'min') {
      const tempMin = parseInt(this.hazardMin.value);
      if (isNaN(tempMin) || tempMin < 0 || tempMin > 1000) {
        this.hazardMin.setValue(this.minValue);
        return;
      }
      this.minValue = tempMin;
    } else {
      const tempMax = parseInt(this.hazardMax.value);
      if (isNaN(tempMax) || tempMax < 0 || tempMax > 1000) {
        this.hazardMax.setValue(this.maxValue);
        return;
      }
      this.maxValue = tempMax;
    }

    if (this.minValue > this.maxValue) {
      const tempMin = this.maxValue;
      this.maxValue = this.minValue;
      this.minValue = tempMin;
      this.hazardMin.setValue(this.minValue);
      this.hazardMax.setValue(this.maxValue);
    }

    this.store.dispatch(
      new SetWmrtBoundary({
        hazardBoundaryLow: this.minValue,
        hazardBoundaryHigh: this.maxValue
      })
    );
    this.updateWmrpAnalysisCBR();
    this.updateWmrpMergedScoresCBR();

    this.store.dispatch(new CheckLayerDisplay());
  }

  private classBreakRenderer(
    mapLayerId: number,
    field: string,
    defaultSymbol: Symbol,
    classBreakInfos: { symbol: Symbol; classMaxValue: number }[],
    definitionExpression: string = null
  ) {
    let renderer = [
      {
        source: {
          type: 'mapLayer',
          mapLayerId
        },
        drawingInfo: {
          renderer: {
            type: 'classBreaks',
            field,
            defaultSymbol,
            minValue: 0,
            classBreakInfos
          }
        },
        minScale: 0,
        maxScale: 0
      }
    ];

    if (definitionExpression) {
      renderer = renderer.map(r =>
        Object.assign({}, r, { definitionExpression })
      );
    }

    return renderer;
  }

  private simpleRenderer(
    mapLayerId: number,
    symbol: Symbol,
    definitionExpression: string = null
  ) {
    let renderer = [
      {
        source: {
          type: 'mapLayer',
          mapLayerId
        },
        drawingInfo: {
          renderer: {
            type: 'simple',
            symbol
          }
        },
        minScale: 0,
        maxScale: 0
      }
    ];

    if (definitionExpression) {
      renderer = renderer.map(r =>
        Object.assign({}, r, { definitionExpression })
      );
    }

    return renderer;
  }

  private uniqueValueRenderer(
    mapLayerId: number,
    field1: string,
    defaultSymbol: Symbol,
    uniqueValueInfos: { symbol: Symbol }[],
    definitionExpression: string = null
  ) {
    let renderer = [
      {
        source: {
          type: 'mapLayer',
          mapLayerId
        },
        // definitionExpression,
        drawingInfo: {
          renderer: {
            type: 'uniqueValue',
            field1,
            // valueExpression, ???
            // field1: 'SDE_MOB.SDE_ADMIN.WtrWRPAnalysisScores.Poor_Access_Reason',
            defaultSymbol,
            // minValue: 0,
            uniqueValueInfos
          }
        }
        // minScale: 0,
        // maxScale: 0
      }
    ];

    if (definitionExpression) {
      renderer = renderer.map(r =>
        Object.assign({}, r, { definitionExpression })
      );
    }

    return renderer;
  }

  private updateWmrpAnalysisCBR() {
    if (
      !(this.selectedRun && this.analysisGuid && this.analysisGuid.length > 0)
    ) {
      return;
    }

    let layer = this.layerState.layers.find(
      layer => layer.uid === 'WMRP_ANALYSIS_LAYERS'
    );
    if (layer) {
      const name = `WMRP Analysis ID ${this.selectedRun.fmeJobId}`;

      let featureLayers = layer.featureLayers.map((fl, index) => {
        let fieldFilters = [
          {
            name: `${this.appSettings['appConfig.gisdb']}${this.appSettings['appConfig.gisdb.wmrpprefix']}Run_reference`,
            type: 'esriFieldTypeString',
            isLike: false,
            filter: [this.analysisGuid],
            isDate: false,
            isNumber: false
          }
        ];
        let whereClause = `${this.appSettings['appConfig.gisdb']}${this.appSettings['appConfig.gisdb.wmrpprefix']}Run_reference in ('${this.analysisGuid}')`;
        let showFilterPanel = false;

        if (fl.fieldFilters?.length > 0) {
          fieldFilters = Object.assign([], fl.fieldFilters);
          showFilterPanel = fl.showFilterPanel;
          if (fl.whereClause.indexOf(this.analysisGuid) > -1) {
            whereClause = fl.whereClause;
          }
        }

        const defaultSymbol = {
          type: 'esriSLS',
          style: 'esriSLSSolid',
          color: [42, 42, 42, 155],
          width: 10
        };

        const classBreakInfos = [
          {
            symbol: {
              type: 'esriSLS',
              style: 'esriSLSSolid',
              color: [255, 0, 0, 255],
              width: 2
            },
            classMaxValue: this.minValue
          },
          {
            symbol: {
              type: 'esriSLS',
              style: 'esriSLSSolid',
              color: [255, 255, 0, 255],
              width: 2
            },
            classMaxValue: this.maxValue
          },
          {
            symbol: {
              type: 'esriSLS',
              style: 'esriSLSSolid',
              color: [0, 0, 255, 255],
              width: 2
            },
            classMaxValue: 999999
          }
        ];

        const dynamicLayers = this.classBreakRenderer(
          0,
          `${this.appSettings['appConfig.gisdb']}${this.appSettings['appConfig.gisdb.wmrpprefix']}Analysis_value`,
          defaultSymbol,
          classBreakInfos,
          whereClause
        );
        const symbology = Object.assign({}, fl.symbology || {}, {
          timestamp: new Date().toISOString()
        });

        let returnValue = Object.assign({}, fl, {
          featureLayerId: dynamicFeatureLayerIdGenerator(
            DynamicFeatureLayer.WmrpAnalysis,
            index,
            fl.featureLayerId
          ),
          fieldFilters,
          whereClause,
          dynamicLayers,
          symbology,
          showFilterPanel,
          drawingInfo: Object.assign({}, fl.drawingInfo, {
            renderer: dynamicLayers[0].drawingInfo.renderer
          })
        });
        let symbols: DnvSymbol[] = flSymbols(
          returnValue.symbology,
          returnValue
        );
        let symbologyDefaultSymbol: DnvSymbol = symbols.shift();

        return Object.assign({}, returnValue, {
          symbology: Object.assign({}, returnValue.symbology, {
            defaultSymbol: symbologyDefaultSymbol,
            symbols
          })
        });

        // return Object.assign({}, fl, { featureLayerId: dynamicFeatureLayerIdGenerator(DynamicFeatureLayer.WmrpAnalysis, index, fl.featureLayerId), fieldFilters, whereClause, dynamicLayers, symbology, showFilterPanel });
      });

      let lyrType = LayerType.Active;
      const keepAnalysis = this.mapState.featureLayers.filter(
        f => f.uid.indexOf('WMRP_ANALYSIS') > -1
      );
      if (this.scheduleGuid?.length > 0 && keepAnalysis?.length === 0) {
        lyrType = LayerType.Available;
      }
      layer = Object.assign({}, layer, { name, featureLayers, type: lyrType });

      this.store.dispatch(new UpdateLayer(layer));
    }
  }

  // updateWmrpAnalysisCBR
  updateWmrpScheduleCBR() {
    if (
      !(
        this.selectedSchedule &&
        this.scheduleGuid &&
        this.scheduleGuid.length > 0
      )
    ) {
      // if (!(this.selectedRun && this.analysisGuid && this.analysisGuid.length > 0)) {
      return;
    }

    const name = `WMRP Schedule ID ${this.selectedSchedule.fmeJobId}`;
    const startYear = Number(this.selectedSchedule.startYear);
    const endYear = Number(this.selectedSchedule.endYear);

    // let newWmrpScheduleLayerType = this.applicationState.classBreakRendererDemoActive ? LayerType.WmrpLayer : LayerType.Active;
    const unscheduled = 'Unscheduled';
    // const guid = '2b679f1b-625a-442b-969b-43b59cb52fbe';
    const guid = this.selectedSchedule.fmeReference_Schedule;
    // const years = [2022, 2023, null];
    const years = [...generateSequence(startYear, endYear)];
    const symbols = years
      .map((x, i) => {
        return {
          type: 'esriSLS',
          style: 'esriSLSSolid',
          color: [
            [255, 0, 0, 255],
            [255, 255, 0, 255],
            [0, 255, 0, 255],
            [0, 255, 255, 255],
            [0, 0, 255, 255]
          ][i % 5],
          width: 2
        };
      })
      .concat({
        type: 'esriSLS',
        style: 'esriSLSSolid',
        color: [0, 0, 0, 155],
        width: 0.5
      });

    let layer = this.layerState.layers.find(
      layer => layer.uid === 'WMRP_SCHEDULE_LAYERS'
    );
    if (layer) {
      let featureLayerTemplate = layer.featureLayers[0];

      let featureLayers = [...years, null].map((year, index) => {
        const currentFL = layer.featureLayers.find(
          fl =>
            fl.name.toLowerCase() === (year ? year.toString() : 'unscheduled')
        );

        let fieldFilters = [
          {
            name: 'Schedule_reference',
            type: 'esriFieldTypeString',
            isLike: false,
            filter: [guid],
            isDate: false,
            isNumber: false
          },
          {
            name: 'Replacement_year',
            type: 'esriFieldTypeInteger',
            isLike: false,
            filter: null === year ? null : [year],
            isDate: false,
            isNumber: true
          }
        ];
        let name = `${year}`;
        let uid = `WMRP_SCHEDULE_${year}`;
        let whereClause = `Schedule_reference in ('${guid}') AND Replacement_year in (${year})`;
        let isVisible = true;
        let showFilterPanel = false;

        if (null === year) {
          name = unscheduled;
          uid = `WMRP_SCHEDULE_${unscheduled}`;
          whereClause = `Schedule_reference in ('${guid}') AND Replacement_year is null`;
        }
        let displayName = name;

        if (currentFL?.fieldFilters?.length > 0) {
          isVisible = currentFL.isVisible;
          showFilterPanel = currentFL.showFilterPanel;
          if (
            currentFL.whereClause.indexOf(this.scheduleGuid) > -1 &&
            currentFL.whereClause.indexOf(currentFL.name) > -1
          ) {
            whereClause = currentFL.whereClause;
            fieldFilters = Object.assign([], currentFL.fieldFilters);
          }
        }

        let symbol = symbols[index];

        // const defaultSymbol = {
        //   type: 'esriSLS',
        //   style: 'esriSLSSolid',
        //   color: [
        //     0,
        //     0,
        //     0,
        //     155
        //   ],
        //   width: 0.3
        // };

        // const classBreakInfos = years.map((x, i) => {
        //   return {
        //     symbol: {
        //       type: 'esriSLS',
        //       style: 'esriSLSSolid',
        //       color: [
        //         [255, 0, 0, 255],
        //         [255, 255, 0, 255],
        //         [0, 255, 0, 255],
        //         [0, 255, 255, 255],
        //         [0, 0, 255, 255]
        //       ][i % 5],
        //       width: 2
        //     },
        //     classMaxValue: (x + 0.999)
        //   };
        // });

        // const defaultSymbol = {
        //   type: 'esriSLS',
        //   style: 'esriSLSSolid',
        //   color: [
        //     0,
        //     0,
        //     0,
        //     155
        //   ],
        //   width: 0.3
        // };

        // const classBreakInfos = [
        //   {
        //     symbol: {
        //       type: 'esriSLS',
        //       style: 'esriSLSSolid',
        //       color: [
        //         255,
        //         0,
        //         0,
        //         255
        //       ],
        //       width: 2
        //     },
        //     classMaxValue: 2022.999
        //   },
        //   {
        //     symbol: {
        //       type: 'esriSLS',
        //       style: 'esriSLSSolid',
        //       color: [
        //         255,
        //         255,
        //         0,
        //         255
        //       ],
        //       width: 2
        //     },
        //     classMaxValue: 2023.999
        //   }
        // ];

        const dynamicLayers = this.simpleRenderer(1, symbol, whereClause);
        // const classBreaksRenderer = this.classBreakRenderer(1, 'SDE_MOB.SDE_ADMIN.WtrWRPSchedule.Replacement_year', defaultSymbol, classBreakInfos, whereClause);
        const symbology: DnvSymbology = Object.assign(
          {},
          (featureLayerTemplate.symbology || {}) as DnvSymbology,
          { timestamp: new Date().toISOString() }
        );
        let returnValue = Object.assign({}, featureLayerTemplate, {
          featureLayerId: dynamicFeatureLayerIdGenerator(
            DynamicFeatureLayer.WmrpSchedule,
            index,
            featureLayerTemplate.featureLayerId
          ),
          name,
          displayName,
          uid,
          fieldFilters,
          whereClause,
          dynamicLayers,
          isVisible,
          showFilterPanel
          // , name, uid, fieldFilters, whereClause, dynamicLayers
        });

        let dnvSymbols: DnvSymbol[] = flSymbols(symbology, returnValue);
        let symbologyDefaultSymbol: DnvSymbol = dnvSymbols.shift();

        return Object.assign({}, returnValue, {
          symbology: Object.assign({}, symbology, {
            defaultSymbol: symbologyDefaultSymbol
          })
        });

        // const temp = Object.assign({}, featureLayerTemplate,
        //   {
        //     featureLayerId: dynamicFeatureLayerIdGenerator(DynamicFeatureLayer.WmrpSchedule, index, featureLayerTemplate.featureLayerId)
        //     , name, uid, fieldFilters, whereClause, dynamicLayers, symbology, isVisible, showFilterPanel
        //   });
        // return temp;
      });

      layer = Object.assign({}, layer, {
        name,
        featureLayers,
        type: LayerType.Active
      });
      this.store.dispatch(new UpdateLayer(layer));
    }
  }

  //   return Object.assign({}, fl, { fieldFilters, whereClause, classBreaksRenderer, symbology });
  // });
  // layer = Object.assign({}, layer, { name, featureLayers, type: LayerType.Active });

  private updateWmrpPoorAccessCBR() {
    if (
      !(this.selectedRun && this.analysisGuid && this.analysisGuid.length > 0)
    ) {
      return;
    }

    let layer = this.layerState.layers.find(
      layer => layer.uid === 'WMRP_POOR_ACCESS_LAYERS'
    );
    if (layer) {
      const name = `WMRP Poor Access Mains ID ${this.selectedRun.fmeJobId}`;

      let featureLayers = layer.featureLayers.map((fl, index) => {
        let fieldFilters = [
          {
            name: 'Run_reference',
            type: 'esriFieldTypeString',
            isLike: false,
            filter: [this.analysisGuid],
            isDate: false,
            isNumber: false
          },
          {
            name: 'Has_Poor_Access',
            type: 'esriFieldTypeString',
            isLike: false,
            filter: ['Y'],
            isDate: false,
            isNumber: false
          }
        ];
        let whereClause = `Run_reference in ('${this.analysisGuid}') AND Has_Poor_Access = 'Y'`;
        let showFilterPanel = false;

        if (fl.fieldFilters?.length > 0) {
          fieldFilters = Object.assign([], fl.fieldFilters);
          showFilterPanel = fl.showFilterPanel;
          if (fl.whereClause.indexOf(this.analysisGuid) > -1) {
            whereClause = fl.whereClause;
          }
        }

        const renderer = fl.drawingInfo.renderer as DnvUniqueValueRenderer;

        const dynamicLayers = this.uniqueValueRenderer(
          Number(fl.gisLayerNum),
          renderer.field1,
          renderer.defaultSymbol,
          renderer.uniqueValueInfos,
          whereClause
        );
        // const valueExpression = "When( Find('Under Highways/Major roads', $feature.SDE_MOB.SDE_ADMIN.WtrWRPAnalysisScores.Poor_Access_Reason), 'highway', Find('Within ROW', $feature.SDE_MOB.SDE_ADMIN.WtrWRPAnalysisScores.Poor_Access_Reason), 'row')"
        // const classBreaksRenderer = this.classBreakRenderer(0, 'SDE_MOB.SDE_ADMIN.WtrWRPAnalysisScores.Analysis_value', defaultSymbol, classBreakInfos, whereClause);
        // 'SDE_MOB.SDE_ADMIN.WtrWRPAnalysisScores.Poor_Access_Reason' ???
        // const uniqueValueRenderer = this.uniqueValueRenderer(0, 'Poor_Access_Reason', defaultSymbol, uniqueValueInfos, whereClause);
        const symbology = Object.assign({}, fl.symbology || {}, {
          timestamp: new Date().toISOString()
        });

        // featureLayerID = 10343 in order to return feature info
        // return Object.assign({}, fl, { featureLayerId: dynamicFeatureLayerIdGenerator(DynamicFeatureLayer.WmrpPoorAccess, index, fl.featureLayerId), fieldFilters, whereClause, uniqueValueRenderer, symbology });

        return Object.assign({}, fl, {
          featureLayerId: dynamicFeatureLayerIdGenerator(
            DynamicFeatureLayer.WmrpPoorAccess,
            index,
            fl.featureLayerId
          ),
          fieldFilters,
          dynamicLayers,
          whereClause,
          symbology
        });
        // return Object.assign({}, fl, { featureLayerId: 10000343, fieldFilters, whereClause, classBreaksRenderer, symbology, showFilterPanel });
      });
      layer = Object.assign({}, layer, { name, featureLayers });

      this.store.dispatch(new UpdateLayer(layer));
    }
  }

  private updateWmrpMergedScoresCBR() {
    if (
      !(this.selectedRun && this.analysisGuid && this.analysisGuid.length > 0)
    ) {
      return;
    }

    let layer = this.layerState.layers.find(
      layer =>
        layer.uid === 'WRP_MERGED_SCORES' || layer.uid === 'WMRP_MERGED_SCORES'
    );
    if (layer) {
      const name = `WRP Merged Scores ID ${this.selectedRun.fmeJobId}`;

      let featureLayers = layer.featureLayers.map((fl, index) => {
        let fieldFilters = [
          // { name: `${this.appSettings['appConfig.gisdb']}SDE_ADMIN.WtrWRPAnalysisScores.Run_reference`, type: 'esriFieldTypeString', isLike: false, filter: [this.analysisGuid], isDate: false, isNumber: false }
          {
            name: `Run_reference`,
            type: 'esriFieldTypeString',
            isLike: false,
            filter: [this.analysisGuid],
            isDate: false,
            isNumber: false
          }
        ];
        let whereClause = `Run_reference in ('${this.analysisGuid}')`;
        let showFilterPanel = false;

        if (fl.fieldFilters?.length > 0) {
          fieldFilters = Object.assign([], fl.fieldFilters);
          whereClause = fl.whereClause;
          showFilterPanel = fl.showFilterPanel;
        }

        const defaultSymbol = {
          type: 'esriSMS',
          style: 'esriSMSCircle',
          color: [0, 0, 0, 255],
          size: 10,
          angle: 0,
          xoffset: 0,
          yoffset: 0,
          outline: {
            color: [0, 0, 0, 255],
            width: 0
          }
        };

        const classBreakInfos = [
          {
            symbol: {
              type: 'esriSMS',
              style: 'esriSMSCircle',
              color: [255, 0, 0, 255],
              size: 10,
              angle: 0,
              xoffset: 0,
              yoffset: 0,
              outline: {
                color: [255, 0, 0, 255],
                width: 0
              }
            },
            classMaxValue: this.minValue
          },
          {
            symbol: {
              type: 'esriSMS',
              style: 'esriSMSCircle',
              color: [255, 255, 0, 255],
              size: 10,
              angle: 0,
              xoffset: 0,
              yoffset: 0,
              outline: {
                color: [255, 255, 0, 255],
                width: 0
              }
            },
            classMaxValue: this.maxValue
          },
          {
            symbol: {
              type: 'esriSMS',
              style: 'esriSMSCircle',
              color: [0, 0, 255, 255],
              size: 10,
              angle: 0,
              xoffset: 0,
              yoffset: 0,
              outline: {
                color: [0, 0, 255, 255],
                width: 0
              }
            },
            classMaxValue: 999999
          }
        ];

        const dynamicLayers = this.classBreakRenderer(
          6,
          'Analysis_value_average',
          defaultSymbol,
          classBreakInfos,
          whereClause
        );
        const symbology = Object.assign({}, fl.symbology || {}, {
          timestamp: new Date().toISOString()
        });

        let returnValue = Object.assign({}, fl, {
          featureLayerId: dynamicFeatureLayerIdGenerator(
            DynamicFeatureLayer.WmrpMergedScores,
            index,
            fl.featureLayerId
          ),
          fieldFilters,
          whereClause,
          dynamicLayers,
          symbology,
          showFilterPanel,
          drawingInfo: Object.assign({}, fl.drawingInfo, {
            renderer: dynamicLayers[0].drawingInfo.renderer
          })
        });
        let symbols: DnvSymbol[] = flSymbols(
          returnValue.symbology,
          returnValue
        );
        let symbologyDefaultSymbol: DnvSymbol = symbols.shift();

        return Object.assign({}, returnValue, {
          symbology: Object.assign({}, returnValue.symbology, {
            defaultSymbol: symbologyDefaultSymbol,
            symbols
          })
        });

        // return Object.assign({}, fl, { featureLayerId: dynamicFeatureLayerIdGenerator(DynamicFeatureLayer.WmrpMergedScores, index, fl.featureLayerId), fieldFilters, whereClause, dynamicLayers, symbology, showFilterPanel });
      });

      let lyrType = LayerType.Available;
      // const keepAnalysis = this.mapState.featureLayers.filter(f => f.uid.indexOf('WMRP_ANALYSIS') > -1);
      // if (this.scheduleGuid?.length > 0 && keepAnalysis?.length === 0) {
      //   lyrType = LayerType.Available;
      // }
      layer = Object.assign({}, layer, { name, featureLayers, type: lyrType });

      // layer = Object.assign({}, layer, { name, featureLayers });

      this.store.dispatch(new UpdateLayer(layer));
    }
  }

  selectRun(fmeRef: string) {
    this.location.replaceState('/wmrp/' + fmeRef);
    const selectedRun = this.wmrpRecentAnalyses.filter(
      r => r.fmeReference === fmeRef
    );
    if (selectedRun.length > 0 && selectedRun[0].status === 'SUCCESS') {
      this.selectedRun = selectedRun[0] as WmrpAnalysisRun;
      this.analysisGuid = this.selectedRun.fmeReference;
      this.updateWmrpAnalysisCBR();
      this.updateWmrpPoorAccessCBR();
      this.updateWmrpMergedScoresCBR();
      // let layers: Layer[] = this.layerState.layers.concat(
      //   store.layerState.layers
      //     .filter(l => ['WMRP_ANALYSIS_LAYERS'].includes(l.uid))
      //     .map(l => Object.assign({}, l, {
      //       featureLayers: l.featureLayers.filter(fl => ['WMRP_ANALYSIS'].includes(fl.uid)).map(fl => {

      //         const defaultSymbol = {
      //           type: 'esriSLS',
      //           style: 'esriSLSSolid',
      //           color: [
      //             255,
      //             0,
      //             0,
      //             155
      //           ],
      //           width: 10
      //         };

      //         const classBreakInfos = [
      //           {
      //             symbol: {
      //               type: 'esriSLS',
      //               style: 'esriSLSSolid',
      //               color: [
      //                 255,
      //                 0,
      //                 0,
      //                 255
      //               ],
      //               width: 2
      //             },
      //             classMaxValue: hazardBoundaryLow
      //           },
      //           {
      //             symbol: {
      //               type: 'esriSLS',
      //               style: 'esriSLSSolid',
      //               color: [
      //                 255,
      //                 255,
      //                 0,
      //                 255
      //               ],
      //               width: 2
      //             },
      //             classMaxValue: hazardBoundaryHigh
      //           },
      //           {
      //             symbol: {
      //               type: 'esriSLS',
      //               style: 'esriSLSSolid',
      //               color: [
      //                 0,
      //                 0,
      //                 255,
      //                 255
      //               ],
      //               width: 2
      //             },
      //             classMaxValue: 999999
      //           }
      //         ];

      //         const definitionExpression = `SDE_MOB.SDE_ADMIN.WtrWRPAnalysisScores.Run_reference='${store.wmrpState.selectedRun.fmeReference}'`;
      //         const classBreaksRenderer = this.classBreakRenderer(0, 'SDE_MOB.SDE_ADMIN.WtrWRPAnalysisScores.Analysis_value', defaultSymbol, classBreakInfos, definitionExpression);
      //         const symbology = Object.assign({}, (fl.symbology || {}), { timestamp: new Date().toISOString() });

      //         return Object.assign({}, fl, {
      //           classBreaksRenderer,
      //           symbology
      //         });
      //       })
      //     }))

      // // show wmrp layers
      // this.type2LayerUids = this.wmrpLayerState.layers.filter(layer => layer.type == 2).map(layer => layer.uid);
      // for (let layer of this.wmrpLayerState.layers) {
      //   if (this.type2LayerUids.includes(layer.uid)) {
      //     layer.type = 1;
      //   }
      // }

      // let dnvFieldFilter: DnvFieldFilter = {
      //   name: 'SDE_MOB.SDE_ADMIN.WtrWRPAnalysisScores.Run_reference',
      //   type: 'esriFieldTypeString',
      //   isLike: false,
      //   filter: [this.selectedRun.fmeReference], // here, with isLike = false, use the string[] form
      //   isDate: false,
      //   isNumber: false
      // };

      // let whereClause = `SDE_MOB.SDE_ADMIN.WtrWRPAnalysisScores.Run_reference in ('${this.selectedRun.fmeReference}')`;

      // let l = this.layerState.layers.filter((l: any) => ['WMRP_ANALYSIS_LAYERS'].includes(l.uid));
      // let fl = l[0]?.featureLayers.filter((fl: any) => ['WMRP_ANALYSIS'].includes(fl.uid));

      // if (fl?.length > 0) {

      //   let featureFilterUpdate: FeatureFilterUpdate = {
      //     newFilters: [dnvFieldFilter],
      //     whereClause,
      //     featureLayer: fl[0]
      //   }

      //   let featureFilterPayload: FeatureFilterPayload = {
      //     layer: l[0],
      //     featureLayer: fl[0],
      //     featureFilterUpdate,
      //   }
      //   this.store.dispatch(new UpdateLayerFilter(featureFilterPayload));
      // }

      this.store.dispatch(new SelectRun(this.selectedRun));
      this.store.dispatch(
        new GetTemplateParameters(this.selectedRun.wmrpAnalysisParamSet_Id)
      );
      this.store.dispatch(new ShowExpandParametersBtn(true));
      this.toggleAnalysisStatus(false);

      this.toggleAnalysisSchedule(true);

      this.store.dispatch(new GetWmrtResults(this.analysisGuid));
      this.store.dispatch(new GetReplacementSchedules(this.analysisGuid));
      this.store.dispatch(new StopAnalysisResultsPolling());
      this.store.dispatch(new CheckLayerDisplay());
    } else {
      this.store.dispatch(
        new ToastUserNotification({
          type: 'fail',
          title: 'Invalid analysis',
          message: 'The analysis is not available',
          options: {
            disableTimeOut: false,
            closeButton: true,
            enableHtml: true,
            timeOut: 5000
          }
        })
      );
      this.analysisGuid = '';
    }
  }

  selectSchedule(wmrpReplacementSched: WmrpReplacementSched) {
    this.location.replaceState(
      '/wmrp/' +
      wmrpReplacementSched.fmeReference_Job +
      '/' +
      wmrpReplacementSched.fmeReference_Schedule
    );
    // console.log(wmrpReplacementSched);
    this.selectedSchedule = wmrpReplacementSched;
    this.scheduleGuid = this.selectedSchedule.fmeReference_Schedule;

    // determine if user selected run, then remove analysis layer per GT-589
    const userSelected = this.mapState.featureLayers.filter(
      f => f.uid.indexOf('WMRP_SCHEDULE') > -1
    );

    this.updateWmrpScheduleCBR();

    // let dnvFieldFilter: DnvFieldFilter = {
    //   name: 'SDE_MOB.SDE_ADMIN.WtrWRPSchedule.Schedule_reference',
    //   type: 'esriFieldTypeString',
    //   isLike: false,
    //   filter: [this.selectedSchedule.fmeReference_Schedule], // here, with isLike = false, use the string[] form
    //   isDate: false,
    //   isNumber: false
    // };

    // let whereClause = `SDE_MOB.SDE_ADMIN.WtrWRPSchedule.Schedule_reference in ('${this.selectedSchedule.fmeReference_Schedule}')`;

    // let l = this.layerState.layers.filter((l: any) => ['WMRP_SCHEDULE_LAYERS'].includes(l.uid));
    // let fl = l[0].featureLayers.filter((fl: any) => ['WMRP_SCHEDULE'].includes(fl.uid));

    // let featureFilterUpdate: FeatureFilterUpdate = {
    //   newFilters: [dnvFieldFilter],
    //   whereClause,
    //   featureLayer: fl[0]
    // }

    // let featureFilterPayload: FeatureFilterPayload = {
    //   layer: l[0],
    //   featureLayer: fl[0],
    //   featureFilterUpdate,
    // }
    // this.store.dispatch(new UpdateLayerFilter(featureFilterPayload));

    this.store.dispatch(new StopSchedulePolling());
    this.store.dispatch(
      new SetSelectedReplacementSchedule(this.selectedSchedule)
    );
    this.store.dispatch(new CheckLayerDisplay());

    const scheduleLayer = this.wmrpState.layers.filter(
      lyr => lyr.uid === 'WMRP_SCHEDULE_LAYERS'
    );

    if (scheduleLayer.length > 0) {
      this.store.dispatch(
        new SetLayerExpandState({ layer: scheduleLayer[0], expand: true })
      );
    }

    const analysisLyr = this.wmrpState.layers.find(
      lyr => lyr.uid.indexOf('WMRP_ANALYSIS_LAYERS') > -1
    );
    if (analysisLyr) {
      // check if analysis layer was loaded before
      const keepLayer = this.mapState.featureLayers.filter(
        fl => fl.uid.indexOf('WMRP_ANALYSIS') > -1
      );
      if (
        keepLayer.length === 0 ||
        (userSelected.length === 0 && keepLayer.length > 0)
      ) {
        this.setAvailableLayer(analysisLyr);
      }
    }
  }

  onExportParams() {
    const maxConditions = Math.max(
      ...this.currentConditions.map(o => o.conditions.length)
    );

    let header = 'Enabled,Parameter,Description';
    const lines: string[] = [];

    for (let i = 0; i < maxConditions; i++) {
      header += ',Condition ' + (i + 1).toString() + ',Value';
    }
    // console.log(header);

    this.wmrpModule.forEach((mod: WMRPModule) => {
      const condition = this.currentConditions.filter(
        (cond: WmrpAnalysisParam) => cond.wmrpModule_Id === mod.id
      );
      let line = '';
      if (condition.length > 0) {
        line +=
          condition[0].enabled + ',' + mod.title + ',' + mod.breakDescription;
        (condition[0].conditions as WmrpCondition[]).forEach(
          (cond: WmrpCondition) => {
            let breakVal = cond.breakValue.toString();
            if (breakVal.indexOf(',') > -1) {
              breakVal = '"' + breakVal + '"';
            }
            if (
              breakVal.indexOf('>') === -1 &&
              mod.title.toLowerCase().indexOf('material') === -1
            ) {
              breakVal = '≤ ' + breakVal;
            }

            let alias = cond.alias;
            if (alias?.indexOf(',') > -1) {
              alias = '"' + alias + '"';
            }
            if (alias?.length > 0) {
              line += ',' + alias + ' (' + breakVal + '),' + cond.analysisValue;
            } else {
              line += ',' + breakVal + ',' + cond.analysisValue;
            }
          }
        );
        // console.log(line);
        lines.push(line);
      }
    });

    const exportData = [];
    exportData.push(header);
    exportData.push(lines.join('\r\n'));
    const BOM = '\uFEFF';
    const csv = BOM + exportData.join('\r\n');
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
    saveAs(blob, 'wmrp_parameters_jobid_' + this.selectedRun.fmeJobId + '.csv');
  }

  checkFMEStatus(status: string) {
    switch (status.toLowerCase()) {
      case 'running':
      case 'queued':
      case 'success':
      case 'pulled':
        return status.toLowerCase();
      default:
        return 'failed';
    }
  }

  closeWMRPpanels(
    status: ApplicationStatus,
    removeLayers: boolean = false
  ): void {
    if (
      status === ApplicationStatus.Toolbox &&
      this.applicationState.toolboxStatus === ToolboxStatus.WMRP
    ) {
      if (this.showAnalysisSchedules) {
        this.toggleAnalysisSchedule(false, removeLayers);
      }
      if (this.showAnalysisStatus) {
        this.toggleAnalysisStatus(false);
      }

      this.wmrpConditions = false;
      this.sharedURLLoaded = false;
      this.location.replaceState('/map');
    }
  }

  rewriteUrl(): void {
    if (this.route.snapshot.url[0]?.path.indexOf('wmrp') > -1) {
      this.location.replaceState('/map');
      this.toggleAnalysisSchedule(false);
      this.toggleAnalysisStatus(false);
    }
  }

  shareLink(fmeRef: string): void {
    let link = this._window.location.toString();
    if (fmeRef) {
      if (link.indexOf(fmeRef) === -1) {
        link = link + '/' + fmeRef;
      }
      this.clipboardService.copyFromContent(link);
      this.store.dispatch(
        new ToastUserNotification({
          type: 'success',
          title: 'Share Link Copied to Clipboard',
          message: link,
          options: {}
        })
      );
    } else {
      this.store.dispatch(
        new ToastUserNotification({
          type: 'error',
          title: 'There is a problem with the link',
          message: 'The link is invalid',
          options: {}
        })
      );
    }
  }

  compareStatus(currentState: any, prevState: any, type: string) {
    for (const item of prevState) {
      const currentItem = currentState.find(
        (run: any) => run.fmeJobId === item.fmeJobId
      );
      if (currentItem) {
        if (currentItem.status !== item.status) {
          const status = currentItem.status.toLowerCase();
          if (status === 'success') {
            this.store.dispatch(
              new ToastUserNotification({
                type: 'success',
                title: type + ' completed',
                message: type + ' ID ' + currentItem.fmeJobId + ' is complete',
                options: {
                  disableTimeOut: false,
                  closeButton: true,
                  enableHtml: true,
                  timeOut: 5000
                }
              })
            );
          } else if (status.indexOf('failure') > -1) {
            this.store.dispatch(
              new ToastUserNotification({
                type: 'fail',
                title: type + ' failed',
                message: type + ' ID ' + currentItem.fmeJobId + ' failed',
                options: {
                  disableTimeOut: false,
                  closeButton: true,
                  enableHtml: true,
                  timeOut: 5000
                }
              })
            );
          } else {
            this.store.dispatch(
              new ToastUserNotification({
                type: 'info',
                title: type + ' status changed',
                message:
                  type +
                  ' ID ' +
                  currentItem.fmeJobId +
                  "'s status has changed",
                options: {
                  disableTimeOut: false,
                  closeButton: true,
                  enableHtml: true,
                  timeOut: 5000
                }
              })
            );
          }
        }
      }
    }
  }

  isWMRP(targetRole: string): boolean {
    let result = false;
    const tool = this.applicationState.toolsPermissions?.find(
      (t: any) => t.toolName === 'TOOL_WMRP'
    );
    if (tool && tool.allowed && tool.roleName === targetRole) {
      result = true;
    }
    return result;
  }

  notAuthorizedToast() {
    this.store.dispatch(
      new ToastUserNotification({
        type: 'fail',
        title: 'Access denied',
        message:
          'You do not have permission to access this data, please contact Utilities for approval.',
        options: {
          closeButton: true,
          enableHtml: true,
          timeOut: 5000
        }
      })
    );
    this.location.replaceState('/map');
    this.showAnalysisStatus = false;
    this.showAnalysisSchedules = false;
  }

  onPopulationSelect() {
    if (this.populationState.selectionMethod !== 'select') {
      const guid = Guid.create().toString();
      this.store.dispatch(new StartDraw({ shape: '', guid: guid }));
      this.store.dispatch(new IsDrawing(false));

      this.store.dispatch(new PopulationSelectMode('select'));

      this.store.dispatch(new DelayedAction([new RefreshDisplayedGeoJson()]));
    }
  }

  onPopulationDraw() {
    if (this.populationState.selectionMethod !== 'draw') {
      const guid = Guid.create().toString();
      this.store.dispatch(new StartDraw({ shape: 'tool-polygon', guid: guid }));

      this.store.dispatch(new PopulationSelectMode('draw'));

      this.store.dispatch(new DelayedAction([new RefreshDisplayedGeoJson()]));
    }
  }

  onPopulationClear() {
    let guid = '';

    if (this.populationState.selectionMethod === 'draw') {
      guid = Guid.create().toString();
      this.store.dispatch(new StartDraw({ shape: '', guid: guid }));
      this.store.dispatch(new IsDrawing(false));

      guid = Guid.create().toString();
      this.store.dispatch(new StartDraw({ shape: 'tool-polygon', guid: guid }));

      this.store.dispatch(new PopulationSelectMode('draw'));
    }

    this.store.dispatch(new SetMeasurements(null));
    this.store.dispatch(
      new PopulationSetState({ populationTotal: 0, buildingTotal: 0 })
    );
    this.store.dispatch(new PopulationClearSelectedArea(null));
    this.store.dispatch(new DelayedAction([new RefreshDisplayedGeoJson()]));
  }

  getDensity(): string {
    return (
      (this.populationTotal / this.applicationState.measurements.msq) *
      1000000
    ).toFixed(2);
  }

  getPopulation(): string {
    let population = 0;
    this.applicationState.populationState.buildings.forEach(
      (b: { assetId: string; population: number }) => {
        population = population + b.population;
      }
    );
    return population.toFixed(2);
  }

  // getPopArea(): number {
  //   if (this.applicationState.populationState.selectionMethod = 'draw') {
  //     return this.applicationState.measurements?.msq;
  //   } else {
  //     return this.applicationState.populationState.area;
  //   }
  // }

  zoomToSearch() {
    const url = this.mapState.geoJsonLayers[0]?.url;
    if (url && url.length > 0) {
      this.store.dispatch(new ZoomToGeoJsonLayer(url));
    }
  }

  saveTitle(type: string) {
    const analysisTitle = this.analysisTitleForm.get('analysisTitle').value;
    if (type.toLowerCase() === 'analysis') {
      this.store.dispatch(
        new SaveAnalysisTitle({
          id: this.selectedAnalysisJobId,
          title: analysisTitle
        })
      );
    } else {
      const currentSchedule = this.wmrpState.replacementSchedules.filter(rs => rs.fmeJobId === this.selectedScheduleJobId.toString());
      if (currentSchedule.length > 0) {
        const analsyisFmeRef = this.wmrpRecentAnalyses.filter(ar => ar.fmeReference === currentSchedule[0].fmeReference_Job);
        this.store.dispatch(
          new SaveScheduleTitle({
            id: this.selectedScheduleJobId,
            title: analysisTitle,
            fmeJobRef: analsyisFmeRef[0].fmeReference
          })
        );
      }

    }

    this.modal.dismiss();
    this.analysisTitleForm.get('analysisTitle').setValue('');
    this.selectedAnalysisJobId = 0;
  }

  isNarwhal() {
    const users = [
      'heinrichk@dnv.org',
      'lim@dnv.org',
      'lussierl@dnv.org',
      'ponm@dnv.org',
      'turenneb@dnv.org'
    ];
    for (let u of users) {
      if (u === this.userProfile?.userPrincipalName?.toLowerCase()) {
        return true;
      }
    }
    return false;
  }

  userName() {
    return this.userProfile?.givenName;
  }
}
